import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Accordion, Button, Col, Form, Modal, Row } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment";
import { Spin } from "antd";
import {
  customConfirmDialog,
  delete_RecordWithoutApi,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import img200 from "../../../../images/avatar/DefaultUserPhoto.jpg";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import { SVGICON } from "../../../constant/theme";
import Cropper from "react-cropper";
import { dataUrlToFileUsingFetch } from "../../../CustomControls/Utils";
import "cropperjs/dist/cropper.css";
import { useRef } from "react";
import Webcam from "react-webcam";
import {
  POST_DDLGetInwardListForInwardClubing,
  POST_GetAllCustomerRepresentativeDropDown,
  POST_GetCategoryDropDownListByCategoryType,
  POST_GetCustomerContactPersonDDL,
  POST_GetCustomerContactPersonDDLByCustomerProject,
  POST_GetCustomerDDLList,
  POST_GetCustomerDDLListAJAX,
  POST_GetCustomerProjectAddressDDLList,
  POST_GetCustomerProjectList,
  POST_GetDDLTestMasterByDepartmentProductGroupMaterialType,
  POST_GetDepartmentDropDownList,
  POST_GetEmployeeDDLList,
  POST_GetMaterialInwardFoodTestingDetail,
  POST_GetMaterialInwardProjectWorkDetailDDLList,
  POST_GetParametersPreferenceListBasedOnRefStandardTestSubGroup,
  POST_GetReferenceStandardTestSubGroupDDL,
  POST_GetTestMethodDDL_ReferenceStandardDDL_TestMasterDetails_ByTestMasterID,
  POST_GetTestParametersList,
  POST_GetVoucherSeriesDDLList,
  POST_MaterialInwardFoodTestingFilesSave,
  POST_MaterialInwardFoodTestingHeaderDetailChange,
  POST_MaterialInwardFoodTestingInsert,
  POST_MaterialInwardFoodTestingUpdate,
  POST_ValidateCustomerCredit,
} from "../../../helpers/url_helper";
import { post, postFormData } from "../../../helpers/api_helper";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import CustomMultiSelect from "../../../CustomControls/CustomMultiSelect";
import CustomInputUncontrolled from "../../../CustomControls/CustomInputUncontrolled";
import CustomTextAreaUncontrolled from "../../../CustomControls/CustomTextAreaUncontrolled";

const AddMaterialInwardFoodTesting = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const {
    PrimaryIdParam,
    ViewPrimaryIdParam,
    CopyInwardIdParam,
    editHeaderInwardIdParam,
  } = useParams();

  const [inwardNoOptions, setInwardNoOptions] = useState([]);
  // const [customerOptions, setCustomerOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [modeByOptions, setModeByOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [sampleReceivedViaOptions, setSampleReceivedViaOptions] = useState([]);
  const [referredByOptions, setReferredByOptions] = useState([]);
  const [tpiCustomerOptions, setTPICustomerOptions] = useState([]);
  const [tpiContactPersonOptions, setTPIContactPersonOptions] = useState([]);
  const [dispatchMaterialModeOptions, setDispatchMaterialModeOptions] =
    useState([]);
  const [tcNoOptions, setTCNoOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);

  const yesNoOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  const requestTypeOptions = [
    { label: "Regular", value: 1 },
    { label: "IQC Activities", value: 2 },
    { label: "Training", value: 3 },
    { label: "APEDA", value: 4 },
    { label: "Sub Contract", value: 5 },
    { label: "BLANK", value: 6 },
  ];

  const samplingByOptions = [
    { label: "Lab", value: 1 },
    { label: "Other", value: 2 },
  ];

  // const [stampImage, setStampImage] = useState(null);
  // const [stampImageFile, setStampImageFile] = useState(null);

  const [showLetterRefDocModal, setShowLetterRefDocModal] = useState(false);
  const [showAddTPIDetailModal, setShowAddTPIDetailModal] = useState(false);
  const [showTPIDetailModal, setShowTPIDetailModal] = useState(false);
  const [showMaterialInfoImagesModal, setShowMaterialInfoImagesModal] =
    useState(false);
  const [
    showMaterialInfoRepeatRowQtyModal,
    setShowMaterialInfoRepeatRowQtyModal,
  ] = useState(false);
  const [showWorkDetailModal, setShowWorkDetailModal] = useState(false);
  const [customerRepresentativeOptions, setCustomerRepresentativeOptions] =
    useState([]);

  const [showTestQtyModal, setShowTestQtyModal] = useState(false);

  const webcamRef = useRef(null);

  const videoConstraints = {
    width: 600,
    height: 600,
    facingMode: "environment",
  };

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const getInwardNoDDL = async () => {
    //setIsLoading(true);
    await post(POST_GetVoucherSeriesDDLList, {
      TranType: 1, // 1 = Inward
      TranDate: InwardDate
        ? moment(InwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setInwardNoOptions(
            response?.VoucherSeriesList?.map((item) => ({
              label: item.VoucherSeries,
              value: item.VoucherSeriesIDEncrypt,
              IsTCNoBasedOnInwardNo: item.IsTCNoBasedOnInwardNo,
            })),
          );
          if (InwardNo) {
            if (
              response?.VoucherSeriesList?.filter(
                (x) => x.VoucherSeriesIDEncrypt == InwardNo,
              )?.length == 0
            ) {
              formik.setFieldValue("InwardNo", "");
            }
          } else {
            /*select the value when there is only one option while insert only*/
            if (response?.VoucherSeriesList?.length == 1 && !PrimaryIdParam) {
              formik.setFieldValue(
                "InwardNo",
                response?.VoucherSeriesList[0].VoucherSeriesIDEncrypt,
              );
              formik.setFieldValue(
                "IsTCNoBasedOnInwardNo",
                response?.VoucherSeriesList[0].IsTCNoBasedOnInwardNo,
              );
            }
          }
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTCNoDDL = async () => {
    //setIsLoading(true);
    await post(POST_GetVoucherSeriesDDLList, {
      TranType: 5, // 5 = TCNo
      TranDate: InwardDate
        ? moment(InwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTCNoOptions(
            response?.VoucherSeriesList?.map((item) => ({
              label: item?.VoucherSeries,
              value: item?.VoucherSeriesIDEncrypt,
            })),
          );
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTPICustomerDDL = async () => {
    //setIsLoading(true);
    await post(POST_GetCustomerDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TPIFlag: 1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTPICustomerOptions(
            response?.CustomerDDLList?.filter((x) => x.IsTPI == true)?.map(
              (item) => ({
                label: item.CustomerName,
                value: item.CustomerIDEncrypted,
              }),
            ),
          );
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getProjectDDL = async (customerID) => {
    //setIsLoading(true);
    await post(POST_GetCustomerProjectList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypt: customerID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setProjectOptions(
            response?.CustomerProjectDDLList?.map((item) => ({
              label: item.ProjectName,
              value: item.CustomerProjectIDEncrypt,
            })),
          );
          if (
            response?.CustomerProjectDDLList?.length >= 0 &&
            CustomerProjectIDEncrypted &&
            response?.CustomerProjectDDLList?.filter(
              (x) => x.CustomerProjectIDEncrypt == CustomerProjectIDEncrypted,
            ).length == 0
          ) {
            formik.setFieldValue("CustomerProjectIDEncrypted", "");
            formik.setFieldValue("CustomerProjectName", "");
          } else {
            /*select the value when there is only one option while insert only*/
            if (
              response?.CustomerProjectDDLList?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                "CustomerProjectIDEncrypted",
                response?.CustomerProjectDDLList[0].CustomerProjectIDEncrypt,
              );
              formik.setFieldValue(
                "CustomerProjectName",
                response?.CustomerProjectDDLList[0].ProjectName,
              );
            }
          }
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // const getStampWriteUpDDL = async () => {
  //   setIsLoading(true);
  //   await post(POST_GetCustomerContactPersonDDL, {
  //     CustomerIDEncrypted: CustomerIDEncrypted,
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setStampWriteUpOptions(
  //           response?.ListOfContactPersons?.filter(
  //             (x) => x.StempWriteup != "",
  //           )?.map((item) => ({
  //             label: item.StempWriteup,
  //             value: item.CustomerContactPersonIDEncrypted,
  //           })),
  //         );
  //         if (
  //           response?.ListOfContactPersons?.filter((x) => x.StempWriteup != "")
  //             ?.length > 0 &&
  //           StampWriteUpIDEncrypted &&
  //           response?.ListOfContactPersons?.filter(
  //             (x) => x.StempWriteup != "",
  //           )?.filter(
  //             (x) =>
  //               x.CustomerContactPersonIDEncrypted == StampWriteUpIDEncrypted,
  //           ).length == 0
  //         ) {
  //           formik.setFieldValue("StampWriteUpIDEncrypted", "");
  //         } else {
  //           /*select the value when there is only one option while insert only*/
  //           if (
  //             response?.ListOfContactPersons?.length == 1 &&
  //             !PrimaryIdParam
  //           ) {
  //             formik.setFieldValue(
  //               "StampWriteUpIDEncrypted",
  //               response?.ListOfContactPersons[0]
  //                 .CustomerContactPersonIDEncrypted,
  //             );
  //           }
  //         }

  //         response?.ListOfContactPersons?.map((item) => ({
  //           label: item.ContactPerson,
  //           value: item.CustomerContactPersonIDEncrypted,
  //         }));
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const getReferredByDDL = async () => {
    //setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypted: "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setReferredByOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
            })),
          );
          if (
            response?.ListOfContactPersons?.length > 0 &&
            ReferenceByIDEncrypted &&
            response?.ListOfContactPersons?.filter(
              (x) =>
                x.CustomerContactPersonIDEncrypted == ReferenceByIDEncrypted,
            ).length == 0
          ) {
            formik.setFieldValue("ReferenceByIDEncrypted", "");
          } else {
            /*select the value when there is only one option while insert only*/
            if (
              response?.ListOfContactPersons?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                "ReferenceByIDEncrypted",
                response?.ListOfContactPersons[0]
                  .CustomerContactPersonIDEncrypted,
              );
            }
          }
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTPIContactPersonDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: TPIIDEncrypted,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTPIContactPersonOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
              IsBilling: item.IsBilling,
              IsReporting: item.IsReporting,
              IsDispatch: item.IsDispatch,
              IsDispatchMaterial: item.IsDispatchMaterial,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getEmployeeDDL = async () => {
    //setIsLoading(true);
    await post(POST_GetEmployeeDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      UserType: AuthUser?.UserType,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setEmployeeOptions(
            response?.EmployeeList?.map((item) => ({
              label: item.EmployeeName,
              value: item.EmployeeIDEncrypted,
            })),
          );
          /*select the value when there is only one option while insert only*/
          if (response?.EmployeeList?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue(
              "MaterialTakenByUserEncrypted",
              response?.EmployeeList[0].EmployeeIDEncrypted,
            );
          }
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getSampleReceivedViaDDL = () => {
    setSampleReceivedViaOptions([
      {
        value: 1,
        label: "Hand to Hand",
      },
      {
        value: 2,
        label: "Courier",
        //label: "Post",
      },
    ]);
  };

  const getModeByDDL = () => {
    setModeByOptions([
      {
        value: 1,
        label: "Email",
      },
      {
        value: 2,
        label: "Post",
      },
      {
        value: 3,
        label: "Hand to Hand",
      },
      {
        value: 4,
        label: "Courier",
      },
    ]);
  };

  const getDispatchMaterialModeDDL = () => {
    setDispatchMaterialModeOptions([
      {
        value: 2,
        label: "Post",
      },
      {
        value: 3,
        label: "Hand to Hand",
      },
      {
        value: 4,
        label: "Courier",
      },
    ]);
  };

  const getProjectDDLModeDetails = async (customerID, index) => {
    if (customerID) {
      setIsLoading(true);

      await post(POST_GetCustomerProjectList, {
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        CustomerIDEncrypt: customerID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue(
              `ListOfModeDetails[${index}].projectOptions`,
              response?.CustomerProjectDDLList?.map((item) => ({
                label: item.ProjectName,
                value: item.CustomerProjectIDEncrypt,
              })),
            );
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      formik.setFieldValue(`ListOfModeDetails[${index}].projectOptions`, []);
      formik.setFieldValue(
        `ListOfModeDetails[${index}].CustomerProjectIDEncrypted`,
        "",
      );
    }
  };

  const getProjectAddressDDL = async (customerID, projectID, index) => {
    if (customerID && projectID) {
      setIsLoading(true);
      await post(POST_GetCustomerProjectAddressDDLList, {
        CustomerIDEncrypted: customerID,
        CustomerProjectIDEncrypted: projectID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue(
              `ListOfModeDetails[${index}].projectAddressOptions`,
              response?.ProjectAddressDDLList?.map((item) => ({
                label: item.Address,
                value: item.CustomerProjectAddressIDEncrypted,
              })),
            );
            /*select the value when there is only one option while insert only*/
            if (
              response?.ProjectAddressDDLList?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                `ListOfModeDetails[${index}].CustomerProjectAddressIDEncrypted`,
                response?.ProjectAddressDDLList[0]
                  .CustomerProjectAddressIDEncrypted,
              );
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      formik.setFieldValue(
        `ListOfModeDetails[${index}].projectAddressOptions`,
        [],
      );
      formik.setFieldValue(
        `ListOfModeDetails[${index}].CustomerProjectAddressIDEncrypted`,
        "",
      );
    }
  };

  const getContactPersonDDL = async (customerID, projectID, index) => {
    // if (customerID) {
    if (customerID && projectID) {
      setIsLoading(true);
      await post(POST_GetCustomerContactPersonDDLByCustomerProject, {
        CustomerIDEncrypted: customerID,
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        CustomerProjectIDEncrypted: projectID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue(
              `ListOfModeDetails[${index}].contactPersonOptions`,
              response?.ListOfContactPersons?.map((item) => ({
                label: item?.ContactPerson,
                value: item?.CustomerContactPersonIDEncrypted,
                IsBilling: item?.IsBilling,
                IsReporting: item?.IsReporting,
                IsDispatch: item?.IsDispatch,
                IsDispatchMaterial: item?.IsDispatchMaterial,
              })),
            );
            /*select the value when there is only one option while insert only*/
            if (
              response?.ListOfContactPersons?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                `ListOfModeDetails[${index}].CustomerContactPersonIDEncrypted`,
                response?.ListOfContactPersons[0]
                  .CustomerContactPersonIDEncrypted,
              );
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      formik.setFieldValue(
        `ListOfModeDetails[${index}].contactPersonOptions`,
        [],
      );
      formik.setFieldValue(
        `ListOfModeDetails[${index}].CustomerContactPersonIDEncrypted`,
        "",
      );
    }
  };

  const getCustomerReviewList = async () => {
    setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 7, //Customer Review
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ListOfReviews",
            response?.List?.map((item) => ({
              InwardReviewIDEncrypted: "",
              Review: item.CategoryName,
              CategoryID: item.CategoryID,
              StatusOfReview: false,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getProjectWorkDetailList = async () => {
    setIsLoading(true);
    post(POST_GetMaterialInwardProjectWorkDetailDDLList, {
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikWorkDetail.setFieldValue(
            "projectWorkDetailList",
            response?.ProjectWorkDetailDDLList?.map((item) => ({
              WorkDetail: item.ProjectDetails,
              IsSelected: false,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getDepartmentDDL = async () => {
    //setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TransactionDate: InwardDate
        ? moment(InwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDepartmentOptions(
            response?.List?.map((item) => ({
              label: item?.DepartmentName,
              value: item?.DepartmentIDEncrypted,
              IsNABLScopeExpired: item?.IsNABLScopeExpired,
            })),
          );
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getUnitDDL = async () => {
    // setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 8, //Unit
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setUnitOptions(
            response?.List?.map((item) => ({
              label: item?.CategoryName,
              value: item?.CategoryID,
            })),
          );
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const initMaterialTestDetail = {
    InwardMaterialTestDetailIDEncrypted: "",
    DepartmentIDEncrypted: "",
    ProductGroupIDEncrypted: "",
    MaterialTypeIDEncrypted: "",
    TestMasterIDEncrypted: "",
    TestMethodIDEncrypted: "",
    ReferenceStandardIDEncrypted: "",
    TestCount: "",
    BillingQty: AuthUser?.Permissions?.Account === 1 ? "" : 1,
    UnitID: "",
    Rate: "0.00",
    TestNote: "",
    productGroupOptions: [],
    materialTypeOptions: [],
    testOptions: [],
    testMethodOptions: [],
    referenceStandardOptions: [],
    refStandardSubGroupOptions: [],
    // parametersRangeList: [],
    IsDeleted: false,
    IsCancel: false,
    ListOfTestParameters: [],
    ListOfDefineMoreRates: [],
    // IsMixDesign: false,
  };

  const initMaterialInformation = {
    id: "",
    TCNoAllocated: false,
    InwardMaterialIDEncrypted: "",
    TCNo: "",
    ULRNo: "",
    Size: "",
    Condition: "",
    SampleDetail: "",
    IsMachining: false,
    ListOfMaterialPhotos: [],
    ListOfMaterialTestDetails: [initMaterialTestDetail],
    IsDeleted: false,
    IsErrorDisplay: false,
    IsHeaderDetailMaterialInformationChange: false,
    ListOfProcessThicknessDetailsFinal: [],
    IsHold: false,
    SamplePacking: "",
    LotNo: "",
    MfgDate: "",
    ExpDate: "",
    CustomerProvidedSampleDetail: "",
    Marking: "",
    SampleBatchCode: "",
    SamplingBy: "",
    SampleDrawnBy: "",
    TotalSampleMinimumQty: "",
    SampleQtyUnitID: "",
  };

  const initModeDetails = [
    {
      InwardModeDetailIDEncrypted: "",
      InwardIDEncrypted: "",
      ModeDetailID: 1,
      ModeType: 0,
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectAddressIDEncrypted: "",
      CustomerContactPersonIDEncrypted: "",
      projectOptions: [],
      projectAddressOptions: [],
      contactPersonOptions: [],
    },
    {
      InwardModeDetailIDEncrypted: "",
      InwardIDEncrypted: "",
      ModeDetailID: 2,
      ModeType: 0,
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectAddressIDEncrypted: "",
      CustomerContactPersonIDEncrypted: "",
      projectOptions: [],
      projectAddressOptions: [],
      contactPersonOptions: [],
    },
    {
      InwardModeDetailIDEncrypted: "",
      InwardIDEncrypted: "",
      ModeDetailID: 3,
      ModeType: 0,
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectAddressIDEncrypted: "",
      CustomerContactPersonIDEncrypted: "",
      projectOptions: [],
      projectAddressOptions: [],
      contactPersonOptions: [],
    },
    {
      InwardModeDetailIDEncrypted: "",
      InwardIDEncrypted: "",
      ModeDetailID: 4,
      ModeType: 0,
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectAddressIDEncrypted: "",
      CustomerContactPersonIDEncrypted: "",
      projectOptions: [],
      projectAddressOptions: [],
      contactPersonOptions: [],
    },
  ];

  const validationSchema = Yup.object().shape({
    btnSubmitType: Yup.number(),
    InwardNo: Yup.string().when("btnSubmitType", ([btnSubmitType], schema) => {
      if (btnSubmitType != 1)
        return Yup.string().required("Inward No is required field");
      return schema;
    }),
    InwardDate: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Inward Date is required field");
        return schema;
      },
    ),
    CustomerIDEncrypted: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Customer is required field");
        return schema;
      },
    ),
    CustomerProjectIDEncrypted: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Project is required field");
        return schema;
      },
    ),
    ChangeReason: Yup.string().when(
      "IsEditMaterialInwardHeaderDetail",
      ([IsEditMaterialInwardHeaderDetail], schema) => {
        if (IsEditMaterialInwardHeaderDetail == true)
          return Yup.string().required("Change Reason is required field");
        return schema;
      },
    ),
    CustomerProjectName: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1 && !CustomerProjectIDEncrypted)
          return Yup.string().required("Project is required field");
        return schema;
      },
    ),

    InwardIDsClubing: Yup.array().when(
      "InwardClubing",
      ([InwardClubing], schema) => {
        if (InwardClubing == true)
          return Yup.array()
            .required("Inward No is required field")
            .min(1, "Inward No is required field")
            .nullable();
        return schema;
      },
    ),

    RequestType: Yup.number().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.number()
            .min(1, "Request Type is required field")
            .required("Request Type is required field");
        return schema;
      },
    ),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, { setSubmitting }) =>
      handleValidSubmit(values, { setSubmitting }),
    initialValues: {
      InwardIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      InwardNo: "",
      InwardDate: new Date(),
      InwardCurrentStatus: 1,
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectName: "",
      ProjectDetails: "",
      LetterRefNo: "",
      StampWriteUpIDEncrypted: "",
      StampImageFilePath: "",
      MaterialReceiveViaID: "",
      ReceiveRemarks: "",
      MaterialTakenByUserEncrypted: "",
      ExpectedDateOfDelivery: "",
      EDDRemarks: "",
      ReferenceByIDEncrypted: "",
      IsMaterialReturnable: false,
      IsTPIRequired: false,
      ListOfLetterRefDoc: [],
      ListOfTPIDetails: [],
      ListOfMaterials: [initMaterialInformation],
      ListOfModeDetails: initModeDetails,
      ListOfReviews: [],
      selectedMaterialInfoRow: -1,
      btnSubmitType: 1, // 1 = Draft, 2 = Submit
      IsStampImageFileDeleted: false,
      IsTCNoBasedOnInwardNo: true,
      IsEditMaterialInwardHeaderDetail: editHeaderInwardIdParam ? true : false,
      AllowToChangeCustomerAndProject: true,
      IsHeaderDetailCustomerChange: false,
      originalCustomerID: "",
      originalCustomerName: "",
      IsHeaderDetailProjectChange: false,
      originalProjectID: "",
      originalProjectName: "",
      IsMaterialDispatched: false,
      IsHeaderDetailWorkDetailChange: false,
      originalWorkDetail: "",
      IsHeaderDetailLetterRefNoChange: false,
      originalLetterRefNo: "",
      // IsHeaderDetailTPIRequiredChange: false,
      // originalIsTPIRequired: false,
      // IsHeaderDetailTPIDetailChange: false,
      // originalListOfTPIDetails: [],
      originalListOfMaterials: [],
      ChangeReason: "",
      InwardClubing: false,
      InwardIDsClubing: [],
      IsAllowToEdit: 1,
      RequestType: 0,
      CustomerRepresentativeIDEncrypt: "",
      ListOfTestSampleQuantityInformation: [],
    },
    validateOnBlur: false,
  });

  const {
    values: {
      InwardNo,
      InwardDate,
      InwardCurrentStatus,
      CustomerIDEncrypted,
      CustomerName,
      CustomerProjectIDEncrypted,
      CustomerProjectName,
      IsMaterialReturnable,
      IsTPIRequired,
      ListOfReviews,
      ListOfLetterRefDoc,
      ListOfTPIDetails,
      ListOfMaterials,
      selectedMaterialInfoRow,
      ListOfModeDetails,
      StampWriteUpIDEncrypted,
      ReferenceByIDEncrypted,
      IsTCNoBasedOnInwardNo,
      AllowToChangeCustomerAndProject,
      InwardClubing,
      InwardIDsClubing,
      IsAllowToEdit,
      CustomerRepresentativeIDEncrypt,
      ListOfTestSampleQuantityInformation,
    },
  } = formik;

  const handleValidSubmit = (values, { setSubmitting }) => {
    if (ViewPrimaryIdParam) {
      return;
    }
    setIsLoading(true);
    if (values?.btnSubmitType == 2) {
      if (ListOfMaterials?.filter((x) => x.IsDeleted == false)?.length == 0) {
        formik.setFieldError(
          "ListOfMaterials",
          "Material Information is required",
        );
        formik.setFieldTouched("ListOfMaterials", true);
        setSubmitting(false);
        setIsLoading(false);
        return;
      } else {
        let IsmaterialInfoValid = true;
        let IsTestInfoValid = true;
        let IsTestRequiredValid = true;
        Promise.all(
          ListOfMaterials?.filter((x) => x.IsDeleted == false)?.map(
            (item, indx) => {
              if (
                (!item?.TCNo && IsTCNoBasedOnInwardNo == false) ||
                // !item?.DepartmentIDEncrypted ||
                // !item?.ProductGroupIDEncrypted ||
                // !item?.MaterialTypeIDEncrypted ||
                !item?.Size?.trim() ||
                !item?.Condition?.trim() ||
                !item?.SampleDetail?.trim()
              ) {
                IsmaterialInfoValid = false;
              } else {
                if (
                  item?.ListOfMaterialTestDetails?.filter(
                    (x) => x?.IsDeleted == false,
                  )?.length == 0
                ) {
                  IsTestRequiredValid = false;
                } else {
                  Promise.all(
                    item?.ListOfMaterialTestDetails?.filter(
                      (x) => x?.IsDeleted == false,
                    )?.map((test) => {
                      if (
                        !test?.DepartmentIDEncrypted ||
                        // !test?.ProductGroupIDEncrypted ||
                        // !test?.MaterialTypeIDEncrypted ||
                        !test?.TestMasterIDEncrypted
                        // ||
                        // !test?.TestMethodIDEncrypted ||
                        //!test?.ReferenceStandardIDEncrypted ||
                        // !test?.TestCount ||
                        // !test?.BillingQty
                        // ||
                        // !test?.UnitID ||
                        // !test?.Rate ||
                        // !test?.TestNote?.trim()
                      ) {
                        IsTestInfoValid = false;
                      }
                    }),
                  );
                }
              }
            },
          ),
        );

        let MainTotalSampleMinimumQty = 0;
        let IsMainTotalSampleMinimumQty = true;
        Promise.all(
          ListOfMaterials?.filter((x) => x.IsDeleted == false)?.map(
            (item, indx) => {
              if (!isNaN(item?.TotalSampleMinimumQty)) {
                if (
                  parseFloat(item?.Size) <
                  parseFloat(item?.TotalSampleMinimumQty)
                ) {
                  IsMainTotalSampleMinimumQty = false;
                }
              }
            },
          ),
        );

        if (IsMainTotalSampleMinimumQty == false) {
          setTimeout(() => {
            formik.setFieldError(
              "ListOfMaterials",
              "Sample Quantity must be at least the Minimum Test Sample Quantity.",
            );
            formik.setFieldTouched("ListOfMaterials", true);
          }, 800);
          setSubmitting(false);
          setIsLoading(false);
          return;
        }

        /* //Below code to highlight the error in Material Information
          let newList = [];
          newList = ListOfMaterials?.filter((x) => x.IsDeleted == false)?.map(
            (item, indx) => {
              if (
                (!item?.TCNo && IsTCNoBasedOnInwardNo == false) ||
                // !item?.DepartmentIDEncrypted ||
                // !item?.ProductGroupIDEncrypted ||
                // !item?.MaterialTypeIDEncrypted ||
                !item?.Size?.trim() ||
                !item?.Condition?.trim() ||
                !item?.SampleDetail?.trim()
              ) {
                return {
                  ...item,
                  IsErrorDisplay: true,
                };
              } else {
                return {
                  ...item,
                  IsErrorDisplay: false,
                };
              }
            }
          );
  
          formik.setFieldValue("ListOfMaterials", newList);
          */

        if (IsmaterialInfoValid == false) {
          // errorMessage(
          //   "Please fill all the above details of Material Information..."
          // );
          setTimeout(() => {
            formik.setFieldError(
              "ListOfMaterials",
              "Please fill all the above details of Material Information...",
            );
            formik.setFieldTouched("ListOfMaterials", true);
          }, 800);
          setSubmitting(false);
          setIsLoading(false);
          return;
        }

        if (IsTestRequiredValid == false) {
          // warningMessage("Test Detail is required");
          formik.setFieldError("TestError", "Test Detail is required");
          formik.setFieldTouched("TestError", true);
          setSubmitting(false);
          setIsLoading(false);
          return;
        } else {
          if (IsTestInfoValid == false) {
            // warningMessage(
            //   "Please fill all the details of Test..."
            // );
            formik.setFieldError(
              "TestError",
              "Please fill all the above details of Test...",
            );
            formik.setFieldTouched("TestError", true);
            setSubmitting(false);
            setIsLoading(false);
            return;
          }
          // else {
          //   let IsBillingQtyValid = true;
          //   Promise.all(
          //     ListOfMaterials?.filter((x) => x?.IsDeleted == false)?.map(
          //       (item, idxM) => {
          //         Promise.all(
          //           item?.ListOfMaterialTestDetails?.filter(
          //             (x) => x?.IsDeleted == false && x?.IsCancel == false
          //           )?.map((test) => {
          //             if (
          //               parseInt(test?.TestCount) < parseInt(test?.BillingQty)
          //             ) {
          //               IsBillingQtyValid = false;
          //             }
          //           })
          //         );
          //       }
          //     )
          //   );
          //   if (IsBillingQtyValid == false) {
          //     formik.setFieldError(
          //       "ListOfMaterials",
          //       "Billing Qty must be less then or equal to Test Count..."
          //     );
          //     formik.setFieldTouched("ListOfMaterials", true);
          //     setSubmitting(false);
          //     setIsLoading(false);
          //     return;
          //   }
          // }
        }
      }
    }

    //console.log("payload", values);

    setIsLoading(true);
    let payload = {
      InwardIDEncrypted: values?.InwardIDEncrypt,
      InwardNo: values?.InwardNo,
      InwardDate: values?.InwardDate
        ? moment(values?.InwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: values?.CustomerIDEncrypted,
      CustomerProjectIDEncrypted: values?.CustomerProjectIDEncrypted,
      IsMaterialReturnable: values?.IsMaterialReturnable,
      StampWriteUpIDEncrypted: values?.StampWriteUpIDEncrypted,
      ProjectDetails: values?.ProjectDetails.trim(),
      LetterRefNo: values?.LetterRefNo,
      IsTPIRequired: values?.IsTPIRequired,
      MaterialReceiveViaID: values?.MaterialReceiveViaID
        ? values?.MaterialReceiveViaID
        : null,
      ReceiveRemarks: values?.ReceiveRemarks,
      MaterialTakenByUserEncrypted: values?.MaterialTakenByUserEncrypted,
      CustomerRepresentativeIDEncrypt: values?.CustomerRepresentativeIDEncrypt,
      ExpectedDateOfDelivery: values?.ExpectedDateOfDelivery
        ? moment(values?.ExpectedDateOfDelivery)
            .format("YYYY-MM-DD")
            .replace(/^\-/, "")
        : "",
      EDDRemarks: values?.EDDRemarks,
      ReferenceByIDEncrypted: values?.ReferenceByIDEncrypted,
      InwardCurrentStatus: values?.btnSubmitType == 2 ? 4 : 1, // 1 = Draft, 4 = TC No Allocated
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
      IsCopyInward: CopyInwardIdParam ? true : false,
      IsHeaderDetailCustomerChange: values?.IsHeaderDetailCustomerChange,
      IsHeaderDetailProjectChange: values?.IsHeaderDetailProjectChange,
      IsHeaderDetailWorkDetailChange: values?.IsHeaderDetailWorkDetailChange,
      IsHeaderDetailLetterRefNoChange: values?.IsHeaderDetailLetterRefNoChange,
      ChangeReason: values?.ChangeReason?.trim(),
      IsInwardNoClubing: values?.InwardClubing,
      InwardIDsClubing: Array.from(
        values?.InwardIDsClubing,
        (x) => x.value,
      ).join(","),
      RequestType: values?.RequestType,
      ListOfTPIDetails: values?.ListOfTPIDetails?.map((x) => ({
        ...x,
        TPIExpectedDate: x.TPIExpectedDate
          ? moment(x.TPIExpectedDate).format("YYYY-MM-DD").replace(/^\-/, "")
          : "",
      })),
      ListOfMaterials: values?.ListOfMaterials?.map((x, i) => ({
        id: i + 1,
        InwardMaterialIDEncrypted: x.InwardMaterialIDEncrypted,
        TCNo: x.TCNo,
        Size: x.Size,
        Condition: x.Condition,
        SampleDetail: x.SampleDetail,
        IsMachining: x.IsMachining,
        IsHeaderDetailMaterialInformationChange:
          x.IsHeaderDetailMaterialInformationChange,
        IsDeleted: x.IsDeleted,
        SamplePacking: x.SamplePacking,
        LotNo: x.LotNo,
        MfgDate: x.MfgDate,
        ExpDate: x.ExpDate,
        CustomerProvidedSampleDetail: x.CustomerProvidedSampleDetail,
        Marking: x.Marking,
        SampleBatchCode: x.SampleBatchCode,
        SamplingBy: x.SamplingBy ? x.SamplingBy : 0,
        SampleDrawnBy: x.SampleDrawnBy,
        SampleQtyUnitID: x?.SampleQtyUnitID ? x?.SampleQtyUnitID : 0,
        // SampleMinimumQty: x?.SampleMinimumQty
        //   ? x?.SampleMinimumQty.toString()
        //   : "",
        ListOfTests: x?.ListOfMaterialTestDetails?.map((y, j) => ({
          id_test: j + 1,
          InwardMaterialTestDetailIDEncrypted:
            y.InwardMaterialTestDetailIDEncrypted,
          InwardMaterialIDEncrypted: x.InwardMaterialIDEncrypted,
          InwardIDEncrypted: values?.InwardIDEncrypt,
          DepartmentIDEncrypted: y.DepartmentIDEncrypted,
          ProductGroupIDEncrypted: y.ProductGroupIDEncrypted,
          MaterialTypeIDEncrypted: y.MaterialTypeIDEncrypted,
          TestMasterIDEncrypted: y.TestMasterIDEncrypted,
          TestMethodIDEncrypted: y.TestMethodIDEncrypted,
          ReferenceStandardIDEncrypted: y.ReferenceStandardIDEncrypted,
          RefStandardSubGroup: y.RefStandardSubGroup,
          TestNote: y.TestNote,
          IsDeleted: y.IsDeleted,
          ListOfParameters: y?.ListOfTestParameters?.filter(
            (x) => x.IsSelected == true,
          )?.map((z, k) => ({
            InwardMaterialTestDetailIDEncrypted:
              y.InwardMaterialTestDetailIDEncrypted,
            TestMasterIDEncrypted: y.TestMasterIDEncrypted,
            RefParameterIDEncrypted: z.RefParameterIDEncrypted,
            ParameterType: z.ParameterType,
          })),
          ListOfDefineMoreRates: y?.ListOfDefineMoreRates?.filter(
            (x) => x.IsSelected == true,
          )?.map((z, k) => ({
            InwardMaterialTestDetailIDEncrypted:
              y.InwardMaterialTestDetailIDEncrypted,
            TestMasterIDEncrypted: y.TestMasterIDEncrypted,
            RateType: z.RateType,
          })),
        })),
      })),
      ListOfModeDetails: values?.ListOfModeDetails,
      ListOfReviews: values?.ListOfReviews,
    };

    console.log("payload", payload);
    // return;

    let formData = new FormData();
    formData.append(
      "InwardDate",
      values?.InwardDate
        ? moment(values?.InwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
    );
    formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
    // formData.append("StampImageFile", stampImageFile ?? "");
    // formData.append("StampImageFilePath", values?.StampImageFilePath);
    // formData.append("IsStampImageFileDeleted", values?.IsStampImageFileDeleted);
    formData.append("StampImageFile", "");
    formData.append("StampImageFilePath", "");
    formData.append("IsStampImageFileDeleted", false);

    Promise.all(
      //ListOfLetterRefDoc
      values?.ListOfLetterRefDoc?.map((x, i) => {
        formData.append(
          `ListOfLetterRefDoc[${i}].InwardLetterRefImageIDEncrypted`,
          x.InwardLetterRefImageIDEncrypted,
        );
        formData.append(
          `ListOfLetterRefDoc[${i}].LetterRefImageFile`,
          x.LetterRefImageFile,
        );
        formData.append(
          `ListOfLetterRefDoc[${i}].LetterRefImageFilePath`,
          x.LetterRefImageFilePath,
        );
        formData.append(`ListOfLetterRefDoc[${i}].IsDeleted`, x.IsDeleted);
      }),
    );

    if (editHeaderInwardIdParam) {
      post(POST_MaterialInwardFoodTestingHeaderDetailChange, payload)
        .then((response) => {
          setIsLoading(true);
          if (response?.IsSuccess) {
            formData.append(
              "InwardIDEncrypted",
              window.atob(editHeaderInwardIdParam),
            );

            let mImgIdx = 0;
            let tImgIdx = 0;
            Promise.all(
              //ListOfMaterialPhotos
              values?.ListOfMaterials?.map((x, i) => {
                let id = i + 1;
                let inwardMaterialId = response?.ListOfMaterial_Id?.filter(
                  (f) => f.id == id,
                )[0]?.InwardMaterialIDEncrypted;
                x?.ListOfMaterialPhotos?.map((y, j) => {
                  formData.append(`ListOfMaterialPhotos[${mImgIdx}].id`, id);
                  formData.append(
                    `ListOfMaterialPhotos[${mImgIdx}].InwardMaterialIDEncrypted`,
                    inwardMaterialId,
                  );
                  formData.append(
                    `ListOfMaterialPhotos[${mImgIdx}].InwardMaterialPhotoIDEncrypted`,
                    y.InwardMaterialPhotoIDEncrypted,
                  );
                  formData.append(
                    `ListOfMaterialPhotos[${mImgIdx}].MaterialPhotoFile`,
                    y.MaterialPhotoFile,
                  );
                  formData.append(
                    `ListOfMaterialPhotos[${mImgIdx}].MaterialPhotoFilePath`,
                    y.MaterialPhotoFilePath,
                  );
                  formData.append(
                    `ListOfMaterialPhotos[${mImgIdx}].IsDeleted`,
                    y.IsDeleted,
                  );
                  mImgIdx = mImgIdx + 1;
                });
              }),
            );
            setIsLoading(true);
            postFormData(POST_MaterialInwardFoodTestingFilesSave, formData)
              .then((res) => {
                if (res?.IsSuccess) {
                  successMessage(response?.Message); //show success message from main api response
                  setTimeout(() => {
                    navigate(-1);
                  }, 1000);
                  setIsLoading(false);
                  setSubmitting(false);
                } else {
                  errorMessage(
                    "Record Save but files/images not save: ",
                    res?.Message,
                  );
                  setIsLoading(false);
                  setSubmitting(false);
                }
              })
              .catch((error) => {
                console.log(error);
                setIsLoading(false);
                setSubmitting(false);
              });
          } else {
            errorMessage(response?.Message);
            setIsLoading(false);
            setSubmitting(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
          setSubmitting(false);
        });
    } else {
      post(
        PrimaryIdParam
          ? POST_MaterialInwardFoodTestingUpdate
          : POST_MaterialInwardFoodTestingInsert,
        payload,
      )
        .then((response) => {
          setIsLoading(true);
          if (response?.IsSuccess) {
            let inwardId = PrimaryIdParam
              ? values?.InwardIDEncrypt
              : response?.InwardIDEncrypted;
            if (inwardId) {
              formData.append("InwardIDEncrypted", inwardId);

              let mImgIdx = 0;
              let tImgIdx = 0;
              Promise.all(
                //ListOfMaterialPhotos
                values?.ListOfMaterials?.map((x, i) => {
                  let id = i + 1;
                  let inwardMaterialId = response?.ListOfMaterial_Id?.filter(
                    (f) => f.id == id,
                  )[0]?.InwardMaterialIDEncrypted;
                  x?.ListOfMaterialPhotos?.map((y, j) => {
                    formData.append(`ListOfMaterialPhotos[${mImgIdx}].id`, id);
                    formData.append(
                      `ListOfMaterialPhotos[${mImgIdx}].InwardMaterialIDEncrypted`,
                      inwardMaterialId,
                    );
                    formData.append(
                      `ListOfMaterialPhotos[${mImgIdx}].InwardMaterialPhotoIDEncrypted`,
                      y.InwardMaterialPhotoIDEncrypted,
                    );
                    formData.append(
                      `ListOfMaterialPhotos[${mImgIdx}].MaterialPhotoFile`,
                      y.MaterialPhotoFile,
                    );
                    formData.append(
                      `ListOfMaterialPhotos[${mImgIdx}].MaterialPhotoFilePath`,
                      y.MaterialPhotoFilePath,
                    );
                    formData.append(
                      `ListOfMaterialPhotos[${mImgIdx}].IsDeleted`,
                      y.IsDeleted,
                    );
                    mImgIdx = mImgIdx + 1;
                  });
                }),
              );
              setIsLoading(true);
              postFormData(POST_MaterialInwardFoodTestingFilesSave, formData)
                .then((res) => {
                  if (res?.IsSuccess) {
                    successMessage(response?.Message); //show success message from main api response
                    setTimeout(() => {
                      navigate(-1);
                    }, 1000);
                    setIsLoading(false);
                    setSubmitting(false);
                  } else {
                    errorMessage(
                      "Record Save but files/images not save: ",
                      res?.Message,
                    );
                    setIsLoading(false);
                    setSubmitting(false);
                  }
                })
                .catch((error) => {
                  console.log(error);
                  setIsLoading(false);
                  setSubmitting(false);
                });
            } else {
              successMessage(response?.Message);
              setTimeout(() => {
                navigate(-1);
              }, 1000);
              setIsLoading(false);
              setSubmitting(false);
            }
          } else {
            errorMessage(response?.Message);
            setIsLoading(false);
            setSubmitting(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
          setSubmitting(false);
        });
    }
  };

  useEffect(() => {
    if (!InwardDate) {
      formik.setFieldValue("InwardDate", "");
    }
    if (InwardCurrentStatus == 1) {
      getInwardNoDDL();
    }
    getTCNoDDL();
    getDepartmentDDL();
  }, [InwardDate]);

  useEffect(() => {
    if (CustomerIDEncrypted) {
      getProjectDDL(CustomerIDEncrypted);
      getInwardNoClubingDDLList(CustomerIDEncrypted);
      getCustomerRepresentativeDDL(CustomerIDEncrypted);
    } else {
      setProjectOptions([]);
      formik.setFieldValue("CustomerProjectIDEncrypted", "");
      formik.setFieldValue("CustomerProjectName", "");
    }
    if (CustomerIDEncrypted && CustomerProjectIDEncrypted) {
      // getStampWriteUpDDL();
      getProjectWorkDetailList();
    } else {
      // setStampWriteUpOptions([]);
      // formik.setFieldValue("StampWriteUpIDEncrypted", "");
      formik.setFieldValue("ReferenceByIDEncrypted", "");
      formikWorkDetail.setFieldValue("projectWorkDetailList", []);
    }
  }, [CustomerIDEncrypted]);

  useEffect(() => {
    if (CustomerIDEncrypted && CustomerProjectIDEncrypted) {
      // getStampWriteUpDDL();
      getProjectWorkDetailList();

      if (!PrimaryIdParam && !CopyInwardIdParam && !editHeaderInwardIdParam) {
        /*Only in add b'coz edit mode it's effect the other fields */
        /*Set Inward selected Customer & Project to Mode Details List*/
        ListOfModeDetails?.map((item, index) => {
          //if (!item.CustomerIDEncrypted) {
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerIDEncrypted`,
            CustomerIDEncrypted,
          );
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerName`,
            CustomerName,
          );
          //}
          //if (!item.CustomerProjectIDEncrypted) {
          formik.setFieldValue(
            `ListOfModeDetails[${index}].projectOptions`,
            projectOptions,
          );
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerProjectIDEncrypted`,
            CustomerProjectIDEncrypted,
          );
          getProjectAddressDDL(
            CustomerIDEncrypted,
            CustomerProjectIDEncrypted,
            index,
          );
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerProjectAddressIDEncrypted`,
            "",
          );
          getContactPersonDDL(
            CustomerIDEncrypted,
            CustomerProjectIDEncrypted,
            index,
          );
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerContactPersonIDEncrypted`,
            "",
          );
          //}
        });
      }
    } else {
      // setStampWriteUpOptions([]);
      // formik.setFieldValue("StampWriteUpIDEncrypted", "");
      formik.setFieldValue("ReferenceByIDEncrypted", "");
      formikWorkDetail.setFieldValue("projectWorkDetailList", []);

      if (!PrimaryIdParam) {
        /*Only in add b'coz edit mode it's effect the other fields */
        /*Set Inward selected Customer & Project to Mode Details List*/
        ListOfModeDetails?.map((item, index) => {
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerIDEncrypted`,
            "",
          );
          formik.setFieldValue(`ListOfModeDetails[${index}].CustomerName`, "");
          formik.setFieldValue(
            `ListOfModeDetails[${index}].projectOptions`,
            [],
          );
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerProjectIDEncrypted`,
            "",
          );
          getProjectAddressDDL("", "", index);
          getContactPersonDDL("", "", index);
        });
      }
    }
  }, [CustomerProjectIDEncrypted]);

  const getCustomerRepresentativeDDL = (customerID) => {
    setIsLoading(true);
    post(POST_GetAllCustomerRepresentativeDropDown, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypted: customerID ? customerID : CustomerIDEncrypted,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          const options =
            response?.ListOfCustomerRepresentative?.map((item) => ({
              label: item?.ProjectHandleByName,
              value: item?.ProjectHandleByEncrypted,
              IsDefault: item?.IsDefault,
            })) || [];

          setCustomerRepresentativeOptions(options);

          const defaultRepresentative = options.find(
            (x) => x.IsDefault === true,
          );

          //if (CopyInwardIdParam == "") {
          if (defaultRepresentative) {
            formik.setFieldValue(
              "CustomerRepresentativeIDEncrypt",
              defaultRepresentative.value,
            );
          } else {
            formik.setFieldValue("CustomerRepresentativeIDEncrypt", "");
          }
          //}
        }

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getMaterialInwardDetailByID = async (inwardID) => {
    setIsLoading(true);
    await post(POST_GetMaterialInwardFoodTestingDetail, {
      InwardIDEncrypted: inwardID,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setIsLoading(true);
          formik.setValues({
            ...response,
            InwardIDEncrypt: response?.InwardIDEncrypted,
            InwardDate: response?.InwardDate
              ? new Date(response?.InwardDate)
              : "",
            ExpectedDateOfDelivery: response?.ExpectedDateOfDelivery
              ? new Date(response?.ExpectedDateOfDelivery)
              : "",
            ListOfLetterRefDoc: response?.ListOfLetterRefDoc?.map((x) => {
              return {
                ...x,
                LetterRefImageFile: "",
                viewFile: "",
                LetterRefImageFileName: x?.LetterRefImageFileName,
                IsDeleted: false,
              };
            }),
            ListOfTPIDetails: response?.ListOfTPIDetails?.map((x) => {
              return {
                ...x,
                TPIExpectedDate: x?.TPIExpectedDate
                  ? new Date(x?.TPIExpectedDate)
                  : "",
                displayTPIExpectedDate: x?.TPIExpectedDate,
                IsDeleted: false,
              };
            }),
            ListOfMaterials: response?.ListOfMaterials?.map((x, i) => {
              return {
                ...x,
                TCNoAllocated: x?.TCNo ? true : false,
                id: i + 1,
                ListOfMaterialPhotos: x.ListOfMaterialPhotos?.map((y, j) => {
                  return {
                    ...y,
                    id: i + 1,
                    viewFile: "",
                    MaterialPhotoFile: "",
                    IsDeleted: false,
                  };
                }),
                ListOfMaterialTestDetails:
                  x?.ListOfTests?.length > 0
                    ? x?.ListOfTests?.map((t) => {
                        return {
                          ...t,
                          // productGroupOptions: [], //get the options through api
                          // materialTypeOptions: [], //get the options through api
                          // testOptions: [], //get the options through api
                          // testMethodOptions: [], //get the options through api
                          // referenceStandardOptions: [], //get the options through api
                          productGroupOptions: t?.ProductGroupDDLOptions?.map(
                            (opt) => ({
                              label: opt?.ProductGroupName,
                              value: opt?.ProductGroupIDEncrypted,
                            }),
                          ),
                          materialTypeOptions: t?.MaterialTypeDDLOptions?.map(
                            (opt) => ({
                              label: opt.MaterialTypeName,
                              value: opt.MaterialTypeIDEncrypted,
                            }),
                          ),
                          testOptions: t?.TestMasterDDLOptions?.map((opt) => ({
                            label: opt?.TestName,
                            value: opt?.TestMasterIDEncrypted,
                            IsMixDesign: opt?.IsMixDesign,
                            TestGroup: opt?.TestGroup,
                            SampleMinimumQty: opt?.SampleMinimumQty,
                            SampleQtyUnitID: opt?.SampleQtyUnitID,
                            SampleMinimumUnitName: opt?.SampleMinimumUnitName,
                          })),
                          testMethodOptions: t?.TestMethodDDLOptions?.map(
                            (item) => ({
                              label: item?.TestMethod,
                              value: item?.TestMethodIDEncrypted,
                              IsExpiredTestMethod: item?.IsExpiredTestMethod,
                            }),
                          ),
                          referenceStandardOptions:
                            t?.ReferenceStandardDDLOptions?.map((opt) => ({
                              label: opt?.ReferenceStandard,
                              value: opt?.ReferenceStandardIDEncrypted,
                              IsExpiredReferenceStandard:
                                opt?.IsExpiredReferenceStandard,
                            })),
                          refStandardSubGroupOptions:
                            t?.RefStandardSubGroupOptions?.map((opt) => ({
                              label: opt?.SubGroup,
                              value: opt?.SubGroup,
                            })),
                          IsDeleted: false,
                          ListOfTestParameters:
                            t?.ListOfTestParameters?.filter(
                              (x) => x.IsSelected == true,
                            )?.length > 0
                              ? t?.ListOfTestParameters
                              : t?.ListOfTestParameters?.map((para) => ({
                                  ...para,
                                  IsSelected: true,
                                })),
                          ListOfDefineMoreRates:
                            t?.ListOfDefineMoreRates?.filter(
                              (x) => x.IsSelected == true,
                            )?.length > 0
                              ? t?.ListOfDefineMoreRates
                              : t?.ListOfDefineMoreRates?.map((para) => ({
                                  ...para,
                                  IsSelected: para.IsSelected,
                                })),
                        };
                      })
                    : response?.InwardCurrentStatus == 1
                      ? [initMaterialTestDetail]
                      : [],
                IsDeleted: false,
                IsErrorDisplay: false,
                IsHeaderDetailMaterialInformationChange: false,
                ListOfProcessThicknessDetailsFinal:
                  x.ListOfMachiningDetails?.map((t) => {
                    return {
                      ...t,
                      IsDeleted: false,
                    };
                  }),
                IsHold: false,
              };
            }),

            // ListOfModeDetails: response?.ListOfModeDetails?.map((x) => {
            //   return {
            //     ...x,
            //     projectOptions: [], //get the options through api
            //     projectAddressOptions: [], //get the options through api
            //     contactPersonOptions: [], //get the options through api
            //   };
            // }),

            selectedMaterialInfoRow: -1,
            btnSubmitType: 1, // 1 = Draft, 2 = Submit
            IsStampImageFileDeleted: false,
            IsEditMaterialInwardHeaderDetail: editHeaderInwardIdParam
              ? true
              : false,
            IsHeaderDetailCustomerChange: false,
            originalCustomerID: response?.CustomerIDEncrypted,
            originalCustomerName: response?.CustomerName,
            IsHeaderDetailProjectChange: false,
            originalProjectID: response?.CustomerProjectIDEncrypted,
            originalProjectName: response?.CustomerProjectName,
            IsHeaderDetailWorkDetailChange: false,
            originalWorkDetail: response?.ProjectDetails,
            IsHeaderDetailLetterRefNoChange: false,
            originalLetterRefNo: response?.LetterRefNo,
            originalListOfMaterials: response?.ListOfMaterials?.map((x, i) => {
              return {
                ...x,
                TCNoAllocated: x?.TCNo ? true : false,
                id: i + 1,
                ListOfMaterialPhotos: x.ListOfMaterialPhotos?.map((y, j) => {
                  return {
                    ...y,
                    id: i + 1,
                    viewFile: "",
                    MaterialPhotoFile: "",
                    IsDeleted: false,
                  };
                }),
                IsDeleted: false,
                IsErrorDisplay: false,
                IsHeaderDetailMaterialInformationChange: false,
                ListOfMaterialTestDetails:
                  x?.ListOfTests?.length > 0
                    ? x?.ListOfTests?.map((t) => {
                        return {
                          ...t,
                          // productGroupOptions: [], //get the options through api
                          // materialTypeOptions: [], //get the options through api
                          // testOptions: [], //get the options through api
                          // testMethodOptions: [], //get the options through api
                          // referenceStandardOptions: [], //get the options through api
                          productGroupOptions: t?.ProductGroupDDLOptions?.map(
                            (opt) => ({
                              label: opt?.ProductGroupName,
                              value: opt?.ProductGroupIDEncrypted,
                            }),
                          ),
                          materialTypeOptions: t?.MaterialTypeDDLOptions?.map(
                            (opt) => ({
                              label: opt.MaterialTypeName,
                              value: opt.MaterialTypeIDEncrypted,
                            }),
                          ),
                          testOptions: t?.TestMasterDDLOptions?.map((opt) => ({
                            label: opt?.TestName,
                            value: opt?.TestMasterIDEncrypted,
                            IsMixDesign: opt?.IsMixDesign,
                            TestGroup: opt?.TestGroup,
                            SampleMinimumQty: opt?.SampleMinimumQty,
                            SampleQtyUnitID: opt?.SampleQtyUnitID,
                            SampleMinimumUnitName: opt?.SampleMinimumUnitName,
                          })),
                          testMethodOptions: t?.TestMethodDDLOptions?.map(
                            (item) => ({
                              label: item?.TestMethod,
                              value: item?.TestMethodIDEncrypted,
                              IsExpiredTestMethod: item?.IsExpiredTestMethod,
                            }),
                          ),
                          referenceStandardOptions:
                            t?.ReferenceStandardDDLOptions?.map((opt) => ({
                              label: opt?.ReferenceStandard,
                              value: opt?.ReferenceStandardIDEncrypted,
                              IsExpiredReferenceStandard:
                                opt?.IsExpiredReferenceStandard,
                            })),
                          refStandardSubGroupOptions:
                            t?.RefStandardSubGroupOptions?.map((opt) => ({
                              label: opt?.SubGroup,
                              value: opt?.SubGroup,
                            })),
                          IsDeleted: false,
                          ListOfTestParameters:
                            t?.ListOfTestParameters?.filter(
                              (x) => x.IsSelected == true,
                            )?.length > 0
                              ? t?.ListOfTestParameters
                              : t?.ListOfTestParameters?.map((para) => ({
                                  ...para,
                                  IsSelected: true,
                                })),
                          ListOfDefineMoreRates:
                            t?.ListOfDefineMoreRates?.filter(
                              (x) => x.IsSelected == true,
                            )?.length > 0
                              ? t?.ListOfDefineMoreRates
                              : t?.ListOfDefineMoreRates?.map((para) => ({
                                  ...para,
                                  IsSelected: para.IsSelected,
                                })),
                        };
                      })
                    : response?.InwardCurrentStatus == 1
                      ? [initMaterialTestDetail]
                      : [],
              };
            }),
            ChangeReason: "",
            InwardClubing: response?.IsInwardNoClubing,
            InwardIDsClubing: response?.ListOfInwardNoClubing?.map((item) => ({
              label: item.InwardNo,
              value: item.MainInwardIDEncrypted,
            })),
          });

          formik.setFieldValue(
            "ListOfModeDetails",
            response?.ListOfModeDetails?.map((x) => {
              return {
                ...x,
                projectOptions: [], //get the options through api
                projectAddressOptions: [], //get the options through api
                contactPersonOptions: [], //get the options through api
              };
            }),
          );

          response?.ListOfModeDetails?.map((item, index) => {
            getProjectDDLModeDetails(item.CustomerIDEncrypted ?? "", index);
            getProjectAddressDDL(
              item.CustomerIDEncrypted,
              item.CustomerProjectIDEncrypted,
              index,
            );
            getContactPersonDDL(
              item.CustomerIDEncrypted,
              item.CustomerProjectIDEncrypted,
              index,
            );
          });

          // if (response?.StampImageFilePath) {
          //   setStampImage(response?.StampImageFilePath);
          // }
          /* getInwardNoDDL does not need to call as it's call on InwardDate change */
          // if (response?.InwardCurrentStatus == 1) {
          //   getInwardNoDDL();
          // }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCopyInwardDetails = async () => {
    setIsLoading(true);
    await post(POST_GetMaterialInwardFoodTestingDetail, {
      InwardIDEncrypted: window.atob(CopyInwardIdParam),
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "CustomerIDEncrypted",
            response?.CustomerIDEncrypted,
          );
          formik.setFieldValue("CustomerName", response?.CustomerName);
          formik.setFieldValue(
            "CustomerProjectIDEncrypted",
            response?.CustomerProjectIDEncrypted,
          );
          formik.setFieldValue(
            "CustomerProjectName",
            response?.CustomerProjectName,
          );
          formik.setFieldValue(
            "CustomerRepresentativeIDEncrypt",
            response?.CustomerRepresentativeIDEncrypt
              ? response?.CustomerRepresentativeIDEncrypt
              : CustomerRepresentativeIDEncrypt,
          );
          formik.setFieldValue(
            "ListOfMaterials",
            response?.ListOfMaterials?.map((x, i) => {
              return {
                ...x,
                TCNo: "",
                ULRNo: "",
                TCNoAllocated: false,
                id: i + 1,
                // ListOfMaterialPhotos: x.ListOfMaterialPhotos?.map((y, j) => {
                //   return {
                //     ...y,
                //     id: i + 1,
                //     viewFile: "",
                //     MaterialPhotoFile: "",
                //     IsDeleted: false,
                //   };
                // }),
                ListOfMaterialPhotos: [],
                // // productGroupOptions: [], //get the options through api
                // materialTypeOptions: [], //get the options through api
                IsDeleted: false,
                IsErrorDisplay: false,
                IsHeaderDetailMaterialInformationChange: false,
                ListOfMaterialTestDetails:
                  x?.ListOfTests?.length > 0
                    ? x?.ListOfTests?.map((t) => {
                        return {
                          ...t,
                          productGroupOptions: t?.ProductGroupDDLOptions?.map(
                            (opt) => ({
                              label: opt?.ProductGroupName,
                              value: opt?.ProductGroupIDEncrypted,
                            }),
                          ),
                          materialTypeOptions: t?.MaterialTypeDDLOptions?.map(
                            (opt) => ({
                              label: opt.MaterialTypeName,
                              value: opt.MaterialTypeIDEncrypted,
                            }),
                          ),
                          testOptions: t?.TestMasterDDLOptions?.map((opt) => ({
                            label: opt?.TestName,
                            value: opt?.TestMasterIDEncrypted,
                            IsMixDesign: opt?.IsMixDesign,
                            TestGroup: opt?.TestGroup,
                            SampleMinimumQty: opt?.SampleMinimumQty,
                            SampleQtyUnitID: opt?.SampleQtyUnitID,
                            SampleMinimumUnitName: opt?.SampleMinimumUnitName,
                          })),
                          testMethodOptions: t?.TestMethodDDLOptions?.map(
                            (item) => ({
                              label: item?.TestMethod,
                              value: item?.TestMethodIDEncrypted,
                              IsExpiredTestMethod: item?.IsExpiredTestMethod,
                            }),
                          ),
                          referenceStandardOptions:
                            t?.ReferenceStandardDDLOptions?.map((opt) => ({
                              label: opt?.ReferenceStandard,
                              value: opt?.ReferenceStandardIDEncrypted,
                              IsExpiredReferenceStandard:
                                opt?.IsExpiredReferenceStandard,
                            })),
                          refStandardSubGroupOptions:
                            t?.RefStandardSubGroupOptions?.map((opt) => ({
                              label: opt?.SubGroup,
                              value: opt?.SubGroup,
                            })),
                          ListOfTestParameters:
                            t?.ListOfTestParameters?.filter(
                              (x) => x.IsSelected == true,
                            )?.length > 0
                              ? t?.ListOfTestParameters
                              : t?.ListOfTestParameters?.map((para) => ({
                                  ...para,
                                  IsSelected: true,
                                })),
                          ListOfDefineMoreRates:
                            t?.ListOfDefineMoreRates?.filter(
                              (x) => x.IsSelected == true,
                            )?.length > 0
                              ? t?.ListOfDefineMoreRates
                              : t?.ListOfDefineMoreRates?.map((para) => ({
                                  ...para,
                                  IsSelected: para.IsSelected,
                                })),
                          IsDeleted: false,
                          IsCancel: false,
                        };
                      })
                    : [initMaterialTestDetail],
              };
            }),
          );
          formik.setFieldValue(
            "ListOfModeDetails",
            response?.ListOfModeDetails?.map((x) => {
              return {
                ...x,
                projectOptions: [], //get the options through api
                projectAddressOptions: [], //get the options through api
                contactPersonOptions: [], //get the options through api
              };
            }),
          );
          formik.setFieldValue("RequestType", response?.RequestType);
          response?.ListOfModeDetails?.map((item, index) => {
            getProjectDDLModeDetails(item.CustomerIDEncrypted ?? "", index);
            getProjectAddressDDL(
              item.CustomerIDEncrypted,
              item.CustomerProjectIDEncrypted,
              index,
            );
            getContactPersonDDL(
              item.CustomerIDEncrypted,
              item.CustomerProjectIDEncrypted,
              index,
            );
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    getTPICustomerDDL();

    getModeByDDL();
    getEmployeeDDL();
    getSampleReceivedViaDDL();
    getCustomerReviewList();
    getDispatchMaterialModeDDL();
    getReferredByDDL();
    getCustomerRepresentativeDDL();
    // getProcessNameDDL();
    getUnitDDL();
    //getTestingRemarksList();

    if (PrimaryIdParam) {
      getMaterialInwardDetailByID(window.atob(PrimaryIdParam));
    } else if (ViewPrimaryIdParam) {
      getMaterialInwardDetailByID(window.atob(ViewPrimaryIdParam));
    } else if (editHeaderInwardIdParam) {
      getMaterialInwardDetailByID(window.atob(editHeaderInwardIdParam));
    } else {
      //getInwardNoDDL();
      setIsLoading(false);
    }

    if (CopyInwardIdParam) {
      getCopyInwardDetails();
    }
  }, []);

  // const uploadStampImage = (e) => {
  //   if (e.target.files[0]) {
  //     const file = e.target.files[0];
  //     var pattern = /image-*/;
  //     if (!file.type.match(pattern)) {
  //       setStampImageFile(null);
  //       setStampImage(null);
  //       warningMessage("Select valid image file!");
  //     } else {
  //       setStampImageFile(file);
  //       setStampImage(URL.createObjectURL(file));
  //     }
  //     //formik.setFieldValue("StampImageFilePath", "");
  //   }
  // };

  const uploadLetterRefDoc = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      //console.log(file);
      if (file) {
        formik.setFieldValue("ListOfLetterRefDoc", [
          ...ListOfLetterRefDoc,
          {
            InwardLetterRefImageIDEncrypted: "",
            LetterRefImageFile: file,
            viewFile: URL.createObjectURL(file),
            LetterRefImageFileName: file?.name,
            LetterRefImageFilePath: "",
            IsDeleted: false,
          },
        ]);

        //successMessage("Letter Ref Doc Uploaded...");
      }
    }
  };

  const validationSchemaTPIDetail = Yup.object().shape({
    TPIIDEncrypted: Yup.string().required("TPI is required field"),
    TPIContactPersonIDEncrypted: Yup.string().required(
      "TPI Contact Person is required field",
    ),
  });

  const formikTPIDetail = useFormik({
    validationSchema: validationSchemaTPIDetail,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTPIDetail(values, formikHelpers),
    initialValues: {
      TPIIDEncrypted: "",
      TPIContactPersonIDEncrypted: "",
      TPIExpectedDate: "",
      TPIName: "",
      TPIContactPersonName: "",
      displayTPIExpectedDate: "",
      editIndexTPI: "",
      actionFlagTPI: 0, // 0 = Add,  1 = edit
      IsDeleted: false,
      isTPIForTesting: false,
    },
    validateOnBlur: false,
  });

  const {
    values: { TPIIDEncrypted, actionFlagTPI },
  } = formikTPIDetail;

  useEffect(() => {
    if (TPIIDEncrypted) {
      //formikTPIDetail.setFieldValue("TPIContactPersonIDEncrypted", "");
      getTPIContactPersonDDL();
    } else {
      setTPIContactPersonOptions([]);
      formikTPIDetail.setFieldValue("TPIContactPersonIDEncrypted", "");
    }
  }, [TPIIDEncrypted]);

  const handleValidSubmitTPIDetail = (values) => {
    // if (values?.isTPIForTesting == true) {
    //   //Testing TPI
    //   if (values?.editIndexTPI !== "") {
    //     //edit mode
    //     if (
    //       formikTesting?.values?.ListOfTPIDetails?.filter(
    //         (x, i) =>
    //           x?.TPIIDEncrypted == values?.TPIIDEncrypted &&
    //           x?.TPIContactPersonIDEncrypted ==
    //             values?.TPIContactPersonIDEncrypted &&
    //           x?.IsDeleted == false &&
    //           i != values?.editIndexTPI
    //       )?.length > 0
    //     ) {
    //       warningMessage("TPI detail already exists!");
    //       return;
    //     } else {
    //       formikTesting.setFieldValue(
    //         "ListOfTPIDetails",
    //         formikTesting?.values?.ListOfTPIDetails?.map((x, idx) => {
    //           if (idx == values?.editIndexTPI) {
    //             return {
    //               ...x,
    //               TPIIDEncrypted: values?.TPIIDEncrypted,
    //               TPIContactPersonIDEncrypted:
    //                 values?.TPIContactPersonIDEncrypted,
    //               TPIExpectedDate: values?.TPIExpectedDate,
    //               TPIName: values?.TPIName,
    //               TPIContactPersonName: values?.TPIContactPersonName,
    //               displayTPIExpectedDate: values?.TPIExpectedDate
    //                 ? moment(values?.TPIExpectedDate).format("DD-MMM-yyyy")
    //                 : "",
    //             };
    //           } else {
    //             return { ...x };
    //           }
    //         })
    //       );
    //     }
    //   } else {
    //     //add mode
    //     if (
    //       formikTesting?.values?.ListOfTPIDetails?.filter(
    //         (x) =>
    //           x?.TPIIDEncrypted == values?.TPIIDEncrypted &&
    //           x?.TPIContactPersonIDEncrypted ==
    //             values?.TPIContactPersonIDEncrypted &&
    //           x?.IsDeleted == false
    //       )?.length > 0
    //     ) {
    //       warningMessage("TPI detail already exists!");
    //       return;
    //     } else {
    //       formikTesting.setFieldValue("ListOfTPIDetails", [
    //         ...formikTesting?.values?.ListOfTPIDetails,
    //         {
    //           ...values,
    //           displayTPIExpectedDate: values?.TPIExpectedDate
    //             ? moment(values?.TPIExpectedDate).format("DD-MMM-yyyy")
    //             : "",
    //         },
    //       ]);
    //     }
    //   }
    // } else {
    //Inward TPI
    if (values?.editIndexTPI !== "") {
      if (
        ListOfTPIDetails?.filter(
          (x, i) =>
            x?.TPIIDEncrypted == values?.TPIIDEncrypted &&
            x?.TPIContactPersonIDEncrypted ==
              values?.TPIContactPersonIDEncrypted &&
            x?.IsDeleted == false &&
            i != values?.editIndexTPI,
        )?.length > 0
      ) {
        warningMessage("TPI detail already exists!");
        return;
      } else {
        formik.setFieldValue(
          "ListOfTPIDetails",
          ListOfTPIDetails?.map((x, idx) => {
            if (idx == values?.editIndexTPI) {
              return {
                ...x,
                TPIIDEncrypted: values?.TPIIDEncrypted,
                TPIContactPersonIDEncrypted:
                  values?.TPIContactPersonIDEncrypted,
                TPIExpectedDate: values?.TPIExpectedDate,
                TPIName: values?.TPIName,
                TPIContactPersonName: values?.TPIContactPersonName,
                displayTPIExpectedDate: values?.TPIExpectedDate
                  ? moment(values?.TPIExpectedDate).format("DD-MMM-yyyy")
                  : "",
              };
            } else {
              return { ...x };
            }
          }),
        );
      }
    } else {
      if (
        ListOfTPIDetails?.filter(
          (x) =>
            x?.TPIIDEncrypted == values?.TPIIDEncrypted &&
            x?.TPIContactPersonIDEncrypted ==
              values?.TPIContactPersonIDEncrypted &&
            x?.IsDeleted == false,
        )?.length > 0
      ) {
        warningMessage("TPI detail already exists!");
        return;
      } else {
        formik.setFieldValue("ListOfTPIDetails", [
          ...ListOfTPIDetails,
          {
            ...values,
            displayTPIExpectedDate: values?.TPIExpectedDate
              ? moment(values?.TPIExpectedDate).format("DD-MMM-yyyy")
              : "",
          },
        ]);
      }
    }
    // }
    setShowAddTPIDetailModal(false);
  };

  const addNewTPI = (isForTesting) => {
    if (CustomerProjectIDEncrypted) {
      formikTPIDetail.resetForm();
      formikTPIDetail.setFieldValue("isTPIForTesting", isForTesting);
      /*select the value when there is only one option while insert only*/
      if (tpiCustomerOptions?.length == 1) {
        formikTPIDetail.setFieldValue(
          "TPIIDEncrypted",
          tpiCustomerOptions[0].value,
        );
        formikTPIDetail.setFieldValue("TPIName", tpiCustomerOptions[0].label);
      }
      /*select the value when there is only one option while insert only*/
      if (tpiContactPersonOptions?.length == 1) {
        formikTPIDetail.setFieldValue(
          "TPIContactPersonIDEncrypted",
          tpiContactPersonOptions[0].value,
        );
        formikTPIDetail.setFieldValue(
          "TPIContactPersonName",
          tpiContactPersonOptions[0].label,
        );
      }
      setShowAddTPIDetailModal(true);
    } else {
      warningMessage("Please select Project first...");
    }
  };

  const editTPI = (i, isForTesting) => {
    let editData;
    // if (isForTesting == true) {
    //   editData = formikTesting?.values?.ListOfTPIDetails[i];
    // } else {
    editData = ListOfTPIDetails[i];
    // }
    // formikTPIDetail.setFieldValue("isTPIForTesting", isForTesting);
    formikTPIDetail.setValues({ ...editData, editIndexTPI: i });
    formikTPIDetail.setFieldValue("actionFlagTPI", 1); // 1 = edit
    setShowAddTPIDetailModal(true);
  };

  const deleteTPI = (i, isForTesting) => {
    // if (isForTesting == true) {
    //   if (
    //     formikTesting?.values?.ListOfTPIDetails[i]?.InwardTPIDetailIDEncrypted
    //   ) {
    //     formikTesting.setFieldValue(`ListOfTPIDetails[${i}].IsDeleted`, true);
    //   } else {
    //     formikTesting.setFieldValue(
    //       "ListOfTPIDetails",
    //       ListOfTPIDetails?.filter((x, ix) => ix != i)
    //     );
    //   }
    // } else {
    if (ListOfTPIDetails[i]?.InwardTPIDetailIDEncrypted) {
      formik.setFieldValue(`ListOfTPIDetails[${i}].IsDeleted`, true);
    } else {
      formik.setFieldValue(
        "ListOfTPIDetails",
        ListOfTPIDetails?.filter((x, ix) => ix != i),
      );
    }
    // }
  };

  const AddNewMaterialInformation = () => {
    formik.setFieldValue("ListOfMaterials", [
      ...ListOfMaterials,
      initMaterialInformation,
    ]);
  };

  const deleteMaterialInformation = (i) => {
    if (ListOfMaterials[i]?.InwardMaterialIDEncrypted) {
      formik.setFieldValue(`ListOfMaterials[${i}].IsDeleted`, true);
      formik.setFieldValue(
        `ListOfMaterials[${i}].ListOfMaterialPhotos`,
        ListOfMaterials[i]?.ListOfMaterialPhotos?.map((x) => {
          return { ...x, IsDeleted: true };
        }),
      );
    } else {
      formik.setFieldValue(
        "ListOfMaterials",
        ListOfMaterials?.filter((x, idx) => idx != i),
      );
    }
  };

  const validationMaterialInfoRepeatRow = Yup.object().shape({
    NoOfRepeatMaterialInfoRow: Yup.number()
      .min(1, "No of Repeat Row is required field")
      .required("No of Repeat Row is required field"),
  });

  const formikMaterialInfoRepeatRow = useFormik({
    validationSchema: validationMaterialInfoRepeatRow,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitMaterialInfoRepeatRow(values, formikHelpers),
    initialValues: {
      NoOfRepeatMaterialInfoRow: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formikMaterialInfoRepeatRow;

  const handleValidSubmitMaterialInfoRepeatRow = (values) => {
    setIsLoading(true);
    setTimeout(() => {
      let selectedRow = ListOfMaterials[selectedMaterialInfoRow];
      let newListOfMaterials = ListOfMaterials;
      for (let i = 0; i < values?.NoOfRepeatMaterialInfoRow; i++) {
        newListOfMaterials = [
          ...newListOfMaterials,
          {
            ...selectedRow,
            id: "",
            TCNo: "",
            TCNoAllocated: false,
            InwardMaterialIDEncrypted: "",
            ULRNo: "",
            ListOfMaterialPhotos: [],
            ListOfMaterialTestDetails:
              selectedRow?.ListOfMaterialTestDetails?.map((x) => {
                return {
                  ...x,
                  InwardMaterialTestDetailIDEncrypted: "",
                  ListOfTestParameters: x?.ListOfTestParameters?.map((y) => {
                    return { ...y, InwardMaterialTestDetailIDEncrypted: "" };
                  }),
                  // TestMixDesignDetail: {
                  //   ...x?.TestMixDesignDetail,
                  //   StipulationsProportioningIDEncrypted: "",
                  // },
                  // TestingDetails: {
                  //   ...x?.TestingDetails,
                  //   TestingIDEncrypted: "",
                  //   TestingStatus: 1,
                  //   ListTestingResultImages: [],
                  // },
                };
              }) ?? [],
            ListOfProcessThicknessDetailsFinal:
              selectedRow?.ListOfProcessThicknessDetailsFinal?.map((x) => {
                return {
                  ...x,
                  InwardMachiningDetailIDEncrypted: "",
                  InwardMaterialIDEncrypted: "",
                };
              }) ?? [],
          },
        ];
      }
      formik.setFieldValue("ListOfMaterials", newListOfMaterials);
      setShowMaterialInfoRepeatRowQtyModal(false);
      setIsLoading(false);
    }, 300);
  };

  const [materialPhoto, setMaterialPhoto] = useState(null);
  const [materialPhotoFile, setMaterialPhotoFile] = useState(null);

  const [fileKeyMaterialPhoto, setFileKeyMaterialPhoto] = useState();

  const [zoomMaterialPhoto, setZoomMaterialPhoto] = useState(0.5);

  const [openCropperModalMaterialPhoto, setOpenCropperModalMaterialPhoto] =
    useState(false);
  const [openWebCamModalMaterialImage, setOpenWebCamModalMaterialImage] =
    useState(false);
  const [imageMaterialPhoto, setImageMaterialPhoto] = useState();
  const [cropperMaterialPhoto, setCropperMaterialPhoto] = useState();

  const getCropDataMaterialPhoto = () => {
    if (typeof cropperMaterialPhoto !== "undefined") {
      handleUploadMaterialPhoto(
        cropperMaterialPhoto.getCroppedCanvas().toDataURL(),
      );
      setMaterialPhoto(cropperMaterialPhoto.getCroppedCanvas().toDataURL());
    }
  };

  const handleUploadMaterialPhoto = async (url) => {
    const outputFileMaterialPhoto = await dataUrlToFileUsingFetch(
      url,
      "output.png",
      "image/png",
    );
    //const file = dataUrlToFile(url, "output.png");
    setMaterialPhotoFile(outputFileMaterialPhoto);
  };

  const uploadMaterialPhoto = (event) => {
    if (event.target.files.length === 1) {
      var pattern = /image-*/;
      if (event.target.files[0].type.match(pattern)) {
        event.preventDefault();
        let files;
        if (event.dataTransfer) {
          files = event.dataTransfer.files;
        } else if (event.target) {
          files = event.target.files;
        }
        const reader = new FileReader();
        reader.onload = () => {
          setImageMaterialPhoto(reader.result);
        };
        reader.readAsDataURL(files[0]);
        setOpenCropperModalMaterialPhoto(true);
      } else {
        setMaterialPhotoFile(null);
        setMaterialPhoto(null);
        warningMessage("Select valid image file!");
      }
    }
  };

  const capturePhoto = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();

    if (imageSrc !== null) {
      setMaterialPhoto(imageSrc);
      const outputFileMaterialPhotoCapture = await dataUrlToFileUsingFetch(
        imageSrc,
        "output.png",
        "image/png",
      );
      setMaterialPhotoFile(outputFileMaterialPhotoCapture);
    } else {
      warningMessage("Webcam device not found.");
    }
    setOpenWebCamModalMaterialImage(false);
  }, [webcamRef]);

  const onUserMedia = (e) => {
    console.log(e);
  };

  const addMaterialImage = () => {
    //console.log(ListOfMaterials[selectedMaterialInfoRow]);
    formik.setFieldValue(
      `ListOfMaterials[${selectedMaterialInfoRow}].ListOfMaterialPhotos`,
      [
        ...ListOfMaterials[selectedMaterialInfoRow]?.ListOfMaterialPhotos,
        {
          id: "",
          InwardMaterialPhotoIDEncrypted: "",
          viewFile: URL.createObjectURL(materialPhotoFile),
          MaterialPhotoFile: materialPhotoFile,
          MaterialPhotoFilePath: "",
          IsDeleted: false,
        },
      ],
    );
    setMaterialPhoto(null);
    setMaterialPhotoFile(null);
  };

  const deleteMaterialImage = (i) => {
    if (
      ListOfMaterials[selectedMaterialInfoRow]?.ListOfMaterialPhotos[i]
        ?.InwardMaterialPhotoIDEncrypted
    ) {
      formik.setFieldValue(
        `ListOfMaterials[${selectedMaterialInfoRow}].ListOfMaterialPhotos[${i}].IsDeleted`,
        true,
      );
    } else {
      formik.setFieldValue(
        `ListOfMaterials[${selectedMaterialInfoRow}].ListOfMaterialPhotos`,
        ListOfMaterials[selectedMaterialInfoRow]?.ListOfMaterialPhotos?.filter(
          (x, idx) => idx != i,
        ),
      );
    }
  };

  const formikWorkDetail = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitWorkDetail(values, formikHelpers),
    initialValues: {
      projectWorkDetailList: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { projectWorkDetailList },
  } = formikWorkDetail;

  const handleValidSubmitWorkDetail = (values) => {
    formik.setFieldValue(
      "ProjectDetails",
      values?.projectWorkDetailList
        ?.filter((x) => x.IsSelected == true)
        ?.map((wd) => {
          return wd.WorkDetail;
        })
        .join(" "),
    );
    setShowWorkDetailModal(false);
  };

  const [refreshCustomerKey, setRefreshCustomerKey] = useState("0");

  const loadOptionsCutomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getCustomerDDL_AJAX = (inputValue) => {
    return post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const deleteLetterRefDoc = (i) => {
    if (ListOfLetterRefDoc[i]?.InwardLetterRefImageIDEncrypted) {
      formik.setFieldValue(`ListOfLetterRefDoc[${i}].IsDeleted`, true);
    } else {
      formik.setFieldValue(
        "ListOfLetterRefDoc",
        ListOfLetterRefDoc?.filter((x, ix) => ix != i),
      );
    }
  };

  const ValidateCustomerCredit = async (customerId) => {
    setIsLoading(true);
    await post(POST_ValidateCustomerCredit, {
      CustomerIDEncrypt: customerId,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess == false) {
          customConfirmDialog(
            response?.Message,
            "Do you want to create more Inwards?",
            fnCallbackValidateCustomerCredit,
            false,
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallbackValidateCustomerCredit = () => {
    navigate(-1);
  };

  const [letterRefDocPhoto, setLetterRefDocPhoto] = useState(null);
  const [letterRefDocPhotoFile, setLetterRefDocPhotoFile] = useState(null);
  const [
    openWebCamModalLetterRefDocImage,
    setOpenWebCamModalLetterRefDocImage,
  ] = useState(false);

  const [letterRefDocPhotoFileName, setLetterRefDocPhotoFileName] = useState();

  const addLetterRefDocFile = () => {
    formik.setFieldValue("ListOfLetterRefDoc", [
      ...ListOfLetterRefDoc,
      {
        InwardLetterRefImageIDEncrypted: "",
        LetterRefImageFile: letterRefDocPhotoFile,
        viewFile: URL.createObjectURL(letterRefDocPhotoFile),
        LetterRefImageFileName: letterRefDocPhotoFileName,
        LetterRefImageFilePath: "",
        IsDeleted: false,
      },
    ]);

    setLetterRefDocPhoto(null);
    setLetterRefDocPhotoFile(null);
  };

  const captureLetterRefDocPhoto = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();

    if (imageSrc !== null) {
      setLetterRefDocPhoto(imageSrc);
      const outputFileLetterRefDocPhotoCapture = await dataUrlToFileUsingFetch(
        imageSrc,
        "output.png",
        "image/png",
      );
      setLetterRefDocPhotoFile(outputFileLetterRefDocPhotoCapture);
      const fileName = outputFileLetterRefDocPhotoCapture.name;
      setLetterRefDocPhotoFileName(fileName);
    } else {
      warningMessage("Webcam device not found.");
    }
    setOpenWebCamModalLetterRefDocImage(false);
  }, [webcamRef]);

  const handleChangeHeaderDetailCustomerChange = (e) => {
    if (AllowToChangeCustomerAndProject == true) {
      customConfirmDialog(
        `Report Printing ${
          AuthUser?.Permissions?.UploadScanCopy == 1 ? "& Upload Scan Copy" : ""
        } transactions will be deleted if they exist.`,
        "Do you want to change Customer?",
        fnCallbackHandleChangeHeaderDetailCustomerChange,
        true,
      );
    } else {
      warningMessage(
        "Once an accounting transaction, such as a proforma invoice or an invoice, has been created, it cannot be changed.",
      );
    }
  };

  const fnCallbackHandleChangeHeaderDetailCustomerChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailCustomerChange",
      !formik?.values?.IsHeaderDetailCustomerChange,
    );
  };

  const cancelHeaderDetailCustomerChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailCustomerChange",
      !formik?.values?.IsHeaderDetailCustomerChange,
    );
    if (CustomerIDEncrypted !== formik?.values?.originalCustomerID) {
      formik.setFieldValue(
        "CustomerIDEncrypted",
        formik?.values?.originalCustomerID,
      );
      formik.setFieldValue(
        "CustomerName",
        formik?.values?.originalCustomerName,
      );
      getProjectDDL(formik?.values?.originalCustomerID);
      formik.setFieldValue(
        "CustomerProjectIDEncrypted",
        formik?.values?.originalProjectID,
      );
      formik.setFieldValue(
        "CustomerProjectName",
        formik?.values?.originalProjectName,
      );
    }
  };

  const handleChangeHeaderDetailProjectChange = (e) => {
    if (AllowToChangeCustomerAndProject == true) {
      customConfirmDialog(
        `Report Printing ${
          AuthUser?.Permissions?.UploadScanCopy == 1 ? "& Upload Scan Copy" : ""
        } transactions will be deleted if they exist.`,
        "Do you want to change Project?",
        fnCallbackHandleChangeHeaderDetailProjectChange,
        true,
      );
    } else {
      warningMessage(
        "Once an accounting transaction, such as a proforma invoice or an invoice, has been created, it cannot be changed.",
      );
    }
  };

  const fnCallbackHandleChangeHeaderDetailProjectChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailProjectChange",
      !formik?.values?.IsHeaderDetailProjectChange,
    );
  };

  const cancelHeaderDetailProjectChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailProjectChange",
      !formik?.values?.IsHeaderDetailProjectChange,
    );
    if (CustomerProjectIDEncrypted !== formik?.values?.originalProjectID) {
      formik.setFieldValue(
        "CustomerProjectIDEncrypted",
        formik?.values?.originalProjectID,
      );
      formik.setFieldValue(
        "CustomerProjectName",
        formik?.values?.originalProjectName,
      );
    }
  };

  const handleChangeHeaderDetailWorkDetailChange = (e) => {
    customConfirmDialog(
      `Report Printing ${
        AuthUser?.Permissions?.UploadScanCopy == 1 ? "& Upload Scan Copy" : ""
      } transactions will be deleted if they exist.`,
      "Do you want to change Work Detail?",
      fnCallbackHandleChangeHeaderDetailWorkDetailChange,
      true,
    );
  };

  const fnCallbackHandleChangeHeaderDetailWorkDetailChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailWorkDetailChange",
      !formik?.values?.IsHeaderDetailWorkDetailChange,
    );
  };

  const cancelHeaderDetailWorkDetailChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailWorkDetailChange",
      !formik?.values?.IsHeaderDetailWorkDetailChange,
    );
    if (formik?.values?.ProjectDetails !== formik?.values?.originalWorkDetail) {
      formik.setFieldValue(
        "ProjectDetails",
        formik?.values?.originalWorkDetail,
      );
    }
  };

  const handleChangeHeaderDetailLetterRefNoChange = (e) => {
    customConfirmDialog(
      `Report Printing ${
        AuthUser?.Permissions?.UploadScanCopy == 1 ? "& Upload Scan Copy" : ""
      } transactions will be deleted if they exist.`,
      "Do you want to change Letter Ref No?",
      fnCallbackHandleChangeHeaderDetailLetterRefNoChange,
      true,
    );
  };

  const fnCallbackHandleChangeHeaderDetailLetterRefNoChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailLetterRefNoChange",
      !formik?.values?.IsHeaderDetailLetterRefNoChange,
    );
  };

  const cancelHeaderDetailLetterRefNoChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailLetterRefNoChange",
      !formik?.values?.IsHeaderDetailLetterRefNoChange,
    );
    if (formik?.values?.LetterRefNo !== formik?.values?.originalLetterRefNo) {
      formik.setFieldValue("LetterRefNo", formik?.values?.originalLetterRefNo);
    }
  };

  const handleChangeIsTPIRequired = (e) => {
    // if (
    //   editHeaderInwardIdParam &&
    //   !IsTPIRequired !== formik?.values?.originalIsTPIRequired
    // ) {
    //   customConfirmDialog(
    //     `Report Printing & Upload Scan Copy transactions will be deleted if they exist.`,
    //     "Do you want to change TPI Required?",
    //     fnCallbackHandleChangeHeaderDetailIsTPIRequiredChange,
    //     true
    //   );
    // } else {
    formik.setFieldValue("IsTPIRequired", !IsTPIRequired);
    //   formik.setFieldValue("IsHeaderDetailTPIRequiredChange", false);
    //   if (!IsTPIRequired == false) {
    //     formik.setFieldValue("IsHeaderDetailTPIDetailChange", false);
    //   }
    // }
  };

  // const fnCallbackHandleChangeHeaderDetailIsTPIRequiredChange = () => {
  //   formik.setFieldValue("IsTPIRequired", !IsTPIRequired);
  //   formik.setFieldValue("IsHeaderDetailTPIRequiredChange", true);
  //   if (!IsTPIRequired == true) {
  //     formik.setFieldValue("IsHeaderDetailTPIDetailChange", true);
  //   }
  // };

  // const handleChangeHeaderDetailTPIDetailChange = (e) => {
  //   customConfirmDialog(
  //     `Report Printing & Upload Scan Copy transactions will be deleted if they exist.`,
  //     "Do you want to change TPI Details?",
  //     fnCallbackHandleChangeHeaderDetailTPIDetailChange,
  //     true
  //   );
  // };

  // const fnCallbackHandleChangeHeaderDetailTPIDetailChange = () => {
  //   formik.setFieldValue(
  //     "IsHeaderDetailTPIDetailChange",
  //     !formik?.values?.IsHeaderDetailTPIDetailChange
  //   );
  // };

  // const cancelHeaderDetailTPIDetailChange = () => {
  //   formik.setFieldValue(
  //     "IsHeaderDetailTPIDetailChange",
  //     !formik?.values?.IsHeaderDetailTPIDetailChange
  //   );
  //   if (
  //     formik?.values?.ListOfTPIDetails !==
  //     formik?.values?.originalListOfTPIDetails
  //   ) {
  //     formik.setFieldValue(
  //       "ListOfTPIDetails",
  //       formik?.values?.originalListOfTPIDetails
  //     );
  //   }
  // };

  const handleChangeHeaderDetailMaterialInformationChange = (mIndex) => {
    formik.setFieldValue(
      `ListOfMaterials[${mIndex}].IsHeaderDetailMaterialInformationChange`,
      !ListOfMaterials[mIndex].IsHeaderDetailMaterialInformationChange,
    );
  };

  const cancelHeaderDetailMaterialInformationChange = (mIndex) => {
    formik.setFieldValue(
      `ListOfMaterials[${mIndex}].IsHeaderDetailMaterialInformationChange`,
      !ListOfMaterials[mIndex].IsHeaderDetailMaterialInformationChange,
    );
    if (
      formik?.values?.ListOfMaterials[mIndex] !==
      formik?.values?.originalListOfMaterials[mIndex]
    ) {
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}]`,
        formik?.values?.originalListOfMaterials[mIndex],
      );
    }
  };

  const handleChangeInwardClubing = (e) => {
    formik.setFieldValue("InwardClubing", !InwardClubing);
  };

  const [inwardNoClubingOptions, setInwardNoClubingOptions] = useState([]);

  const getInwardNoClubingDDLList = async (customerID) => {
    if (customerID) {
      setIsLoading(true);
      await post(POST_DDLGetInwardListForInwardClubing, {
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
        CustomerIDEncrypted: customerID,
        InwardIDEncrypted: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      })
        .then((response) => {
          if (response?.IsSuccess) {
            setInwardNoClubingOptions(
              response?.ListOfInwardNo?.map((item) => ({
                label: item.InwardNo,
                value: item.InwardIDEncrypted,
              })),
            );
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setInwardNoClubingOptions([]);
      formik.setFieldValue("InwardIDsClubing", []);
    }
  };

  const handleChangeInwardNos = (e) => {
    let inwards = e ?? [];
    formik.setFieldValue("InwardIDsClubing", inwards);
  };

  // const handleChangeIsMachining = (indx, e, item) => {
  //   if (item?.IsHold == false) {
  //     formik.setFieldValue(
  //       `ListOfMaterials[${indx}].IsMachining`,
  //       !item?.IsMachining
  //     );

  //     formikMaterialProcessDetail.setFieldValue("MaterialListIndex", indx);

  //     getMaterialProcessDetails(
  //       indx,
  //       e.target.checked,
  //       item?.InwardMaterialIDEncrypted
  //     );
  //   }
  // };

  // const [showMaterialProcessModal, setShowMaterialProcessModal] =
  //   useState(false);
  // const [processNameOptions, setProcessNameOptions] = useState([]);

  // const getProcessNameDDL = async () => {
  //   //setIsLoading(true);
  //   await post(POST_GetMachiningProcessDDLList, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //     BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setProcessNameOptions(
  //           response?.List?.map((item) => ({
  //             label: item?.ProcessName,
  //             value: item?.MachiningConfigurationIDEncrypted,
  //             RateMatrix: item?.RateMatrix,
  //             VendorRate: item?.VendorRate,
  //             InvoiceRate: item?.InvoiceRate,
  //             //RateMatrixList: item.ListOfRateMatrix,
  //           }))
  //         );
  //       }
  //       //setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  // const initProcessThicknessDetails = {
  //   InwardMachiningDetailIDEncrypted: "",
  //   InwardMaterialIDEncrypted: "",
  //   InwardIDEncrypted: "",
  //   MachiningConfigurationIDEncrypted: "",
  //   MachiningNote: "",
  //   Qty: "",
  //   Length: "",
  //   Thickness: "",
  //   VendorRate: "",
  //   InvoiceRate: "",
  //   IsDeleted: false,
  // };

  // const validationMaterialProcessDetailSchema = Yup.object().shape({});

  // const formikMaterialProcessDetail = useFormik({
  //   validationMaterialProcessDetailSchema,
  //   onSubmit: (values, formikHelpers) =>
  //     handleValidMaterialProcessSubmit(values, formikHelpers),
  //   initialValues: {
  //     MaterialListIndex: -1,
  //     ListOfProcessThicknessDetails: [initProcessThicknessDetails],
  //   },
  //   validateOnBlur: false,
  // });

  // const {
  //   values: { ListOfProcessThicknessDetails },
  // } = formikMaterialProcessDetail;

  // const handleValidMaterialProcessSubmit = (values) => {
  //   formik.setFieldValue(
  //     `ListOfMaterials[${values.MaterialListIndex}].ListOfProcessThicknessDetailsFinal`,
  //     values?.ListOfProcessThicknessDetails?.filter(
  //       (x, ix) => ix?.MachiningConfigurationIDEncrypted != ""
  //     )
  //   );

  //   setShowMaterialProcessModal(false);
  // };

  // const getMaterialProcessDetails = (index, valueChecked, id) => {
  //   if (valueChecked == true) {
  //     formikMaterialProcessDetail.setFieldValue("MaterialListIndex", index);

  //     let newListOneRecord = ListOfMaterials[
  //       index
  //     ].ListOfProcessThicknessDetailsFinal?.filter(
  //       (x) => x.IsDeleted == false
  //     )?.map((item, idx) => {
  //       if (item?.MachiningConfigurationIDEncrypted == "") {
  //         return {
  //           ...item,
  //           IsDeleted: true,
  //         };
  //       } else {
  //         return {
  //           ...item,
  //           IsDeleted: false,
  //         };
  //       }
  //     });

  //     formikMaterialProcessDetail.setFieldValue(
  //       "ListOfProcessThicknessDetails",
  //       [
  //         // ...ListOfMaterials[index].ListOfProcessThicknessDetailsFinal,
  //         ...newListOneRecord,
  //         initProcessThicknessDetails,
  //       ]
  //     );

  //     setShowMaterialProcessModal(true);
  //   } else {
  //     setShowMaterialProcessModal(false);

  //     let newList = ListOfProcessThicknessDetails?.filter(
  //       (x) => x.IsDeleted == false
  //     )?.map((item, idx) => {
  //       if (item?.InwardMachiningDetailIDEncrypted == "") {
  //         return {
  //           ...item,
  //           IsDeleted: true,
  //         };
  //       } else {
  //         return {
  //           ...item,
  //           IsDeleted: false,
  //         };
  //       }
  //     });

  //     formikMaterialProcessDetail.setFieldValue(
  //       "ListOfProcessThicknessDetails",
  //       []
  //     );

  //     formik.setFieldValue(
  //       `ListOfMaterials[${index}].ListOfProcessThicknessDetailsFinal`,
  //       newList
  //     );
  //   }
  // };

  // const addNewProcess = (indxTest) => {
  //   formikMaterialProcessDetail.setFieldValue(`ListOfProcessThicknessDetails`, [
  //     ...ListOfProcessThicknessDetails,
  //     initProcessThicknessDetails,
  //   ]);
  // };

  // const removeProcess = (indxTest) => {
  //   let newList = ListOfProcessThicknessDetails?.filter(
  //     (x) => x?.IsDeleted == false
  //   )?.map((item, idx) => {
  //     if (indxTest == idx) {
  //       return {
  //         ...item,
  //         IsDeleted: true,
  //       };
  //     } else {
  //       return { ...item };
  //     }
  //   });

  //   formikMaterialProcessDetail.setFieldValue(
  //     `ListOfProcessThicknessDetails`,
  //     newList
  //   );
  // };

  // const checkValidationProcess = (id, index) => {
  //   ListOfProcessThicknessDetails?.filter((x) => x.IsDeleted == false)?.map(
  //     (x) => {
  //       if (x?.MachiningConfigurationIDEncrypted == id) {
  //         warningMessage("Process Already Exist!");

  //         formikMaterialProcessDetail.setFieldValue(
  //           `ListOfProcessThicknessDetails[${index}].MachiningConfigurationIDEncrypted`,
  //           ""
  //         );
  //         return;
  //       }
  //     }
  //   );
  // };

  const handleOnClickRepeatTestDetails = (indx) => {
    formik.setFieldValue("selectedMaterialInfoRow", indx);
    formikTestDetailsRepeat.resetForm();
    openRepeatTestDetailsModel(indx);
  };

  const [showTestDetailsRepeatModal, setShowTestDetailsRepeatModal] =
    useState(false);

  const validationTestDetailsRepeat = Yup.object().shape({});

  const formikTestDetailsRepeat = useFormik({
    validationSchema: validationTestDetailsRepeat,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestDetailsRepeat(values, formikHelpers),
    initialValues: {
      repeatTestDetailsProductGroupID: "",
      repeatTestDetailsProductGroupName: "",
      repeatTestDetailsMaterialTypeID: "",
      repeatTestDetailsMaterialTypeName: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      repeatTestDetailsProductGroupID,
      repeatTestDetailsProductGroupName,
      repeatTestDetailsMaterialTypeID,
      repeatTestDetailsMaterialTypeName,
    },
  } = formikTestDetailsRepeat;

  const openRepeatTestDetailsModel = (selectedIndex) => {
    setShowTestDetailsRepeatModal(true);
  };

  const handleValidSubmitTestDetailsRepeat = (values) => {
    setIsLoading(true);
    let selectedTestDetails = ListOfMaterials[
      selectedMaterialInfoRow
    ]?.ListOfMaterialTestDetails?.filter(
      (x) => x.IsDeleted == false && x.IsCancel == false,
    );

    formik.setFieldValue(
      "ListOfMaterials",
      ListOfMaterials?.map((x, i) => {
        if (
          selectedMaterialInfoRow != i &&
          // &&
          // repeatTestDetailsProductGroupID == x?.ProductGroupIDEncrypted &&
          // repeatTestDetailsMaterialTypeID == x?.MaterialTypeIDEncrypted
          x?.IsHold == false
        ) {
          return {
            ...x,
            ListOfMaterialTestDetails: [
              ...x?.ListOfMaterialTestDetails?.map((e) => {
                return { ...e, IsDeleted: true };
              }),
              ...selectedTestDetails?.map((t) => {
                return {
                  ...t,
                  InwardMaterialTestDetailIDEncrypted: "",
                  ListOfTestParameters: t?.ListOfTestParameters?.map((y) => {
                    return { ...y, InwardMaterialTestDetailIDEncrypted: "" };
                  }),
                  // TestMixDesignDetail: {
                  //   ...t?.TestMixDesignDetail,
                  //   StipulationsProportioningIDEncrypted: "",
                  // },
                  // TestingDetails: {
                  //   ...t?.TestingDetails,
                  //   TestingIDEncrypted: "",
                  //   TestingStatus: 1,
                  //   ListTestingResultImages: [],
                  // },
                };
              }),
            ],
          };
        } else {
          return { ...x };
        }
      }),
    );

    setShowTestDetailsRepeatModal(false);
    setIsLoading(false);
  };

  const getTestDDL = async (
    departmentID,
    productGroupID,
    materialTypeID,
    mIndex,
    tIndex,
    loaderOff = true,
  ) => {
    if (departmentID) {
      setIsLoading(true);
      await post(POST_GetDDLTestMasterByDepartmentProductGroupMaterialType, {
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        DepartmentIDEncrypted: departmentID,
        ProductGroupIDEncrypted: productGroupID,
        MaterialTypeIDEncrypted: materialTypeID,
        TestType: 1, // 0 - All, 1 - DT, 2 - NDT
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue(
              `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].testOptions`,
              response?.List?.map((item) => ({
                label: item?.TestName,
                value: item?.TestMasterIDEncrypted,
                IsMixDesign: item?.IsMixDesign,
                TestGroup: item?.TestGroup,
                SampleMinimumQty: item?.SampleMinimumQty,
                SampleQtyUnitID: item?.SampleQtyUnitID,
                SampleMinimumUnitName: item?.SampleMinimumUnitName,
              })),
            );
          }
          if (loaderOff == true) {
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const getTestMethodDDL_RefStandardDDL_TestDetailsByTest = async (
    testID,
    mIndex,
    tIndex,
    inwardDate,
    setDefault = true,
    loaderOff = true,
  ) => {
    if (testID) {
      // let IsTestAlreadyExist = false;
      //if (setDefault == true) {
      /*check if condition to handle undefine ListOfMaterials While get the data*/
      //   Promise.all(
      //     ListOfMaterials[mIndex]?.ListOfMaterialTestDetails?.filter(
      //       (x) => x?.IsDeleted == false && x?.IsCancel == false
      //     )?.map((item, idxM) => {
      //       if (item?.TestMasterIDEncrypted === testID && idxM != tIndex) {
      //         IsTestAlreadyExist = true;
      //       }
      //     })
      //   );
      // }

      // if (IsTestAlreadyExist) {
      //   formik.setFieldValue(
      //     `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].TestMasterIDEncrypted`,
      //     ""
      //   );
      //   warningMessage("Selected Test Name already Exist...!");
      //   return;
      // } else {
      setIsLoading(true);
      await post(
        POST_GetTestMethodDDL_ReferenceStandardDDL_TestMasterDetails_ByTestMasterID,
        {
          TestMasterIDEncrypted: testID,
          TranDate: inwardDate
            ? moment(inwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
            : "",
        },
      )
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue(
              `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].testMethodOptions`,
              response?.TestMethodList?.map((item) => ({
                label: item?.TestMethod,
                value: item?.TestMethodIDEncrypted,
                IsExpiredTestMethod: item?.IsExpiredTestMethod,
              })),
            );
            formik.setFieldValue(
              `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].referenceStandardOptions`,
              response?.ReferenceStandardList?.map((item) => ({
                label: item?.ReferenceStandard,
                value: item?.ReferenceStandardIDEncrypted,
                IsExpiredReferenceStandard: item?.IsExpiredReferenceStandard,
              })),
            );
            formik.setFieldValue(
              `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].productGroupOptions`,
              [
                {
                  label: response?.ProductGroupName,
                  value: response?.ProductGroupIDEncrypted,
                },
              ],
            );
            formik.setFieldValue(
              `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].materialTypeOptions`,
              response?.MaterialTypeList?.map((item) => ({
                label: item.MaterialTypeName,
                value: item.MaterialTypeIDEncrypted,
              })),
            );

            if (setDefault) {
              if (
                response?.TestMethodList?.length == 1 &&
                response?.TestMethodList[0]?.IsExpiredTestMethod == false
              ) {
                formik.setFieldValue(
                  `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].TestMethodIDEncrypted`,
                  response?.TestMethodList[0]?.TestMethodIDEncrypted,
                );
              }
              if (
                response?.ReferenceStandardList?.length == 1 &&
                response?.ReferenceStandardList[0]
                  ?.IsExpiredReferenceStandard == false
              ) {
                formik.setFieldValue(
                  `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].ReferenceStandardIDEncrypted`,
                  response?.ReferenceStandardList[0]
                    ?.ReferenceStandardIDEncrypted,
                );
                getReferenceStandardTestSubGroupDDL(
                  response?.ReferenceStandardList[0]
                    ?.ReferenceStandardIDEncrypted,
                  testID,
                  mIndex,
                  tIndex,
                );
              }
              formik.setFieldValue(
                `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].TestCount`,
                response?.DefaultTestCount,
              );
              // formik.setFieldValue(
              //   `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].IsMachining`,
              //   response?.MachiningRequired
              // );
              formik.setFieldValue(
                `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].ProductGroupIDEncrypted`,
                response?.ProductGroupIDEncrypted,
              );
              if (response?.MaterialTypeList?.length == 1) {
                formik.setFieldValue(
                  `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].MaterialTypeIDEncrypted`,
                  response?.MaterialTypeList[0]?.MaterialTypeIDEncrypted,
                );
              }
            }

            // formik.setFieldValue(
            //   `ListOfMaterials[${mIndex}].IsMachining`,
            //   response?.MachiningRequired
            // );
          }
          if (loaderOff == true) {
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
      // }
    } else {
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].testMethodOptions`,
        [],
      );
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].referenceStandardOptions`,
        [],
      );
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].refStandardSubGroupOptions`,
        [],
      );
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].parametersRangeList`,
        [],
      );
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].productGroupOptions`,
        [],
      );
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].materialTypeOptions`,
        [],
      );
    }
  };

  const AddNewMaterialTestInformation = (index) => {
    formik.setFieldValue(
      `ListOfMaterials[${index}].ListOfMaterialTestDetails`,
      [
        ...ListOfMaterials[index].ListOfMaterialTestDetails,
        initMaterialTestDetail,
      ],
    );

    // /*select the value when there is only one option while insert only*/
    // if (ListOfMaterials[index]?.testOptions?.length == 1) {
    //   let newIndex = ListOfMaterials[index].ListOfMaterialTestDetails?.length;
    //   formik.setFieldValue(
    //     `ListOfMaterials[${index}].ListOfMaterialTestDetails[${newIndex}].TestMasterIDEncrypted`,
    //     ListOfMaterials[index]?.testOptions[0].value
    //   );
    //   getTestMethodDDL_RefStandardDDL_TestDetailsByTest(
    //     ListOfMaterials[index]?.testOptions[0].value,
    //     index,
    //     newIndex
    //   );
    // }

    /*select the value when there is only one option while insert only*/
    if (ListOfMaterials[index]?.departmentOptions?.length == 1) {
      let newIndex = ListOfMaterials[index].ListOfMaterialTestDetails?.length;
      formik.setFieldValue(
        `ListOfMaterials[${index}].ListOfMaterialTestDetails[${newIndex}].DepartmentIDEncrypted`,
        ListOfMaterials[index]?.departmentOptions[0].value,
      );
      // getTestDDL(
      //   ListOfMaterials[index]?.departmentOptions[0].value,
      //   ListOfMaterials[index]?.ProductGroupIDEncrypted,
      //   ListOfMaterials[index]?.MaterialTypeIDEncrypted,
      //   index,
      //   newIndex
      // );
      getTestDDL(
        ListOfMaterials[index]?.departmentOptions[0].value,
        "",
        "",
        index,
        newIndex,
      );
    }
    /*select the value when there is only one option while insert only*/
    // if (unitOptions?.length == 1) {
    //   let newIndex = ListOfMaterials[index].ListOfMaterialTestDetails?.length;
    //   formik.setFieldValue(
    //     `ListOfMaterials[${index}].ListOfMaterialTestDetails[${newIndex}].UnitID`,
    //     unitOptions[0].value
    //   );
    // }
  };

  const deleteMaterialTestInformation = (mIndex, tIndex, sMinimumQty) => {
    // if (
    //   ListOfMaterials[mIndex]?.ListOfMaterialTestDetails[tIndex].IsMixDesign ==
    //     true &&
    //   ListOfMaterials[mIndex]?.ListOfMaterialTestDetails[tIndex]
    //     .TestMasterIDEncrypted
    // ) {
    //   deleteMixDesignIncludedTest(
    //     mIndex,
    //     ListOfMaterials[mIndex]?.ListOfMaterialTestDetails[tIndex]
    //       .TestMasterIDEncrypted,
    //     true
    //   );
    // } else {
    //SampleMinimumQty

    let TotalQty = 0;
    if (parseFloat(sMinimumQty) > 0 && !isNaN(sMinimumQty)) {
      TotalQty = ListOfMaterials[mIndex]?.TotalSampleMinimumQty;
      if (parseFloat(TotalQty) > 0 && !isNaN(TotalQty)) {
        formik.setFieldValue(
          `ListOfMaterials[${mIndex}].TotalSampleMinimumQty`,
          parseFloat(TotalQty) - parseFloat(sMinimumQty),
        );
      }
    }

    if (
      ListOfMaterials[mIndex]?.InwardMaterialIDEncrypted &&
      ListOfMaterials[mIndex]?.ListOfMaterialTestDetails[tIndex]
        ?.InwardMaterialTestDetailIDEncrypted
    ) {
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].IsDeleted`,
        true,
      );
    } else {
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails`,
        ListOfMaterials[mIndex]?.ListOfMaterialTestDetails?.filter(
          (x, idx) => idx != tIndex,
        ),
      );
    }
    //}
  };

  const handleChangeDepartment = (indx, indxTest, e) => {
    const path = `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}]`;
    let itemTest = ListOfMaterials[indx].ListOfMaterialTestDetails[indxTest];
    // let mixDesignTest = false;
    // if (itemTest.IsMixDesign == true) {
    //   mixDesignTest = true;
    //   setSelectedTCIndex(indx);
    //   setSelectedMixDesignTestID(itemTest.TestMasterIDEncrypted);
    // }

    formik.setFieldValue(`${path}.DepartmentIDEncrypted`, e?.value ?? "");
    formik.setFieldValue(`${path}.ProductGroupIDEncrypted`, "");
    formik.setFieldValue(`${path}.MaterialTypeIDEncrypted`, "");
    formik.setFieldValue(`${path}.TestMasterIDEncrypted`, "");
    formik.setFieldValue(`${path}.TestMethodIDEncrypted`, "");
    formik.setFieldValue(`${path}.ReferenceStandardIDEncrypted`, "");
    formik.setFieldValue(`${path}.RefStandardSubGroup`, "");
    formik.setFieldValue(`${path}.testOptions`, []);
    formik.setFieldValue(`${path}.testMethodOptions`, []);
    formik.setFieldValue(`${path}.referenceStandardOptions`, []);
    formik.setFieldValue(`${path}.refStandardSubGroupOptions`, []);
    formik.setFieldValue(`${path}.parametersRangeList`, []);
    formik.setFieldValue(`${path}.productGroupOptions`, []);
    formik.setFieldValue(`${path}.materialTypeOptions`, []);
    formik.setFieldValue(`${path}.ListOfTestParameters`, []);
    formik.setFieldValue(`${path}.IsMixDesign`, false);
    formik.setFieldValue(
      `${path}.TestMixDesignDetail`,
      initMaterialTestDetail.TestMixDesignDetail,
    );
    formik.setFieldValue(
      `${path}.TestingDetails`,
      initMaterialTestDetail.TestingDetails,
    );
    // getProductGroupDDL(
    //  e?.value ?? "",
    //   indx,
    //   indxTest
    // );
    getTestDDL(e?.value ?? "", "", "", indx, indxTest);

    // if (mixDesignTest == true) {
    //   setDeleteMixDesignIncludedTestActionStatus(true);
    // }
  };

  const handleChangeTestMaster = (indx, indxTest, e, itemTest) => {
    let IsTestAlreadyExist = false;
    const path = `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}]`;
    const Mainpath = `ListOfMaterials[${indx}]`;
    let mixDesignTest = false;
    // if (itemTest.IsMixDesign == true) {
    //   mixDesignTest = true;
    //   setSelectedTCIndex(indx);
    //   setSelectedMixDesignTestID(itemTest.TestMasterIDEncrypted);
    // }

    if (e && e?.value) {
      if (e?.value !== itemTest?.TestMasterIDEncrypted) {
        Promise.all(
          ListOfMaterials[indx]?.ListOfMaterialTestDetails?.filter(
            (x) => x?.IsDeleted == false && x?.IsCancel == false,
          )?.map((item, idxM) => {
            if (item?.TestMasterIDEncrypted === e?.value && idxM != indxTest) {
              IsTestAlreadyExist = true;
            }
          }),
        );

        formik.setFieldValue(`${path}.ListOfTestParameters`, []);
        formik.setFieldValue(`${path}.IsMixDesign`, false);
        // formik.setFieldValue(
        //   `${path}.TestMixDesignDetail`,
        //   initMaterialTestDetail.TestMixDesignDetail
        // );
        formik.setFieldValue(`${path}.TestMethodIDEncrypted`, "");
        formik.setFieldValue(`${path}.ReferenceStandardIDEncrypted`, "");
        formik.setFieldValue(`${path}.referenceStandardOptions`, []);
        formik.setFieldValue(`${path}.RefStandardSubGroup`, "");
        formik.setFieldValue(`${path}.refStandardSubGroupOptions`, []);
        formik.setFieldValue(`${path}.parametersRangeList`, []);
        formik.setFieldValue(`${path}.ProductGroupIDEncrypted`, "");
        formik.setFieldValue(`${path}.MaterialTypeIDEncrypted`, "");
        if (IsTestAlreadyExist) {
          let TotalQty = 0;
          let SampleMinimumQty = 0;

          TotalQty = parseFloat(ListOfMaterials[indx]?.TotalSampleMinimumQty);
          SampleMinimumQty = parseFloat(
            ListOfMaterials[indx]?.ListOfMaterialTestDetails[indxTest]
              ?.SampleMinimumQty,
          );

          if (isNaN(TotalQty)) {
            TotalQty = 0;
          }
          if (isNaN(SampleMinimumQty)) {
            SampleMinimumQty = 0;
          }

          formik.setFieldValue(
            `${Mainpath}.TotalSampleMinimumQty`,
            TotalQty - parseFloat(SampleMinimumQty),
          );

          formik.setFieldValue(`${path}.TestMasterIDEncrypted`, "");
          warningMessage("Selected Test Name already Exist...!");

          //return;
        } else {
          formik.setFieldValue(`${path}.TestMasterIDEncrypted`, e?.value ?? "");

          if (parseFloat(e?.SampleMinimumQty) > 0) {
            let TotalQty = 0;
            TotalQty = parseFloat(ListOfMaterials[indx]?.TotalSampleMinimumQty);

            if (isNaN(TotalQty)) {
              TotalQty = 0;
            }

            formik.setFieldValue(
              `${Mainpath}.TotalSampleMinimumQty`,
              TotalQty + parseFloat(e?.SampleMinimumQty),
            );
            formik.setFieldValue(
              `${path}.SampleMinimumQty`,
              parseFloat(e?.SampleMinimumQty),
            );
            formik.setFieldValue(`${path}.TestName`, e?.label);
            formik.setFieldValue(
              `${path}.SampleMinimumUnitName`,
              e?.SampleMinimumUnitName,
            );
          }

          // if (e?.IsMixDesign == true) {
          //   formikMixDesignTestDetails.resetForm();
          //   formikMixDesignTestDetails.setFieldValue(
          //     "MixDesignTestName",
          //     e?.label
          //   );
          //   formikMixDesignTestDetails.setFieldValue("tcIndex", indx);
          //   formikMixDesignTestDetails.setFieldValue("testIndex", indxTest);
          //   getMixDesignMasterDDLAll(e?.value ?? "", itemTest);
          //   setShowMixDesignTestDetailModal(true);
          // }
          formik.setFieldValue(`${path}.IsMixDesign`, e?.IsMixDesign);
          getInwardMaterialTestParametersList(
            itemTest?.InwardMaterialTestDetailIDEncrypted,
            e?.value,
            indx,
            indxTest,
          );
          // getInwardMaterialDefineMoreRatesList(
          //   itemTest?.InwardMaterialTestDetailIDEncrypted,
          //   e?.value,
          //   indx,
          //   indxTest
          // );
          getTestMethodDDL_RefStandardDDL_TestDetailsByTest(
            e?.value ?? "",
            indx,
            indxTest,
            InwardDate,
          );
        }
      }
    } else {
      formik.setFieldValue(`${path}.ListOfTestParameters`, []);
      formik.setFieldValue(`${path}.IsMixDesign`, false);
      // formik.setFieldValue(
      //   `${path}.TestMixDesignDetail`,
      //   initMaterialTestDetail.TestMixDesignDetail
      // );
      formik.setFieldValue(`${path}.TestMasterIDEncrypted`, e?.value ?? "");
      formik.setFieldValue(`${path}.TestMethodIDEncrypted`, "");
      formik.setFieldValue(`${path}.ReferenceStandardIDEncrypted`, "");
      formik.setFieldValue(`${path}.referenceStandardOptions`, []);
      formik.setFieldValue(`${path}.RefStandardSubGroup`, "");
      formik.setFieldValue(`${path}.refStandardSubGroupOptions`, []);
      formik.setFieldValue(`${path}.parametersRangeList`, []);
      formik.setFieldValue(`${path}.ProductGroupIDEncrypted`, "");
      formik.setFieldValue(`${path}.MaterialTypeIDEncrypted`, "");
    }

    // if (mixDesignTest == true) {
    //   setDeleteMixDesignIncludedTestActionStatus(true);
    // }
  };

  // const [showDefineMoreRatesModal, setShowDefineMoreRatesModal] =
  //   useState(false);

  // const getInwardMaterialDefineMoreRatesList = async (
  //   inwardMaterialTestDetailID,
  //   testMasterID,
  //   mIndex,
  //   tIndex
  // ) => {
  //   setIsLoading(true);
  //   await post(POST_GetTestWiseDefineMoreRatesList, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //     TestMasterIDEncrypted: testMasterID,
  //     InwardMaterialTestDetailIDEncrypted: inwardMaterialTestDetailID,
  //     CustomerIDEncrypted: CustomerIDEncrypted,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         formik.setFieldValue(
  //           `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].ListOfDefineMoreRates`,
  //           response?.ListOfDefineMoreRates?.filter((x) => x.IsSelected == true)
  //             ?.length > 0
  //             ? response?.ListOfDefineMoreRates
  //             : response?.ListOfDefineMoreRates?.map((para) => ({
  //                 ...para,
  //                 IsSelected: para?.IsSelected,
  //               }))
  //         );
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  // const handleOnClickDefineMoreRatesSelection = async (
  //   indx,
  //   indxTest,
  //   item,
  //   itemTest,
  //   testmasterid,
  //   TestDetailID
  // ) => {
  //   if (itemTest?.IsCancel == false && item?.IsHold == false) {
  //     formikDefineMoreRates.setFieldValue(
  //       "MoreTestRatesList",
  //       itemTest?.ListOfDefineMoreRates
  //     );

  //     formikDefineMoreRates.setFieldValue("materialIndexPara", indx);
  //     formikDefineMoreRates.setFieldValue("testIndexPara", indxTest);
  //     formikDefineMoreRates.setFieldValue("testmasterid", testmasterid);
  //     formikDefineMoreRates.setFieldValue("TestDetailID", TestDetailID);
  //     formikDefineMoreRates.setFieldValue("isDefineMoreRateForTesting", false);
  //     setShowDefineMoreRatesModal(true);
  //   }
  // };

  // const validationSchemaDefineMoreRates = Yup.object().shape({});

  // const formikDefineMoreRates = useFormik({
  //   validationSchema: validationSchemaDefineMoreRates,
  //   onSubmit: (values, formikHelpers) =>
  //     handleValidSubmitDefineMoreRates(values, formikHelpers),
  //   initialValues: {
  //     MoreTestRatesList: [],
  //     materialIndexPara: 0,
  //     testIndexPara: 0,
  //     FristtimeClickbtn: false,
  //     testmasterid: "",
  //     TestDetailID: "",
  //     isDefineMoreRateForTesting: false,
  //   },
  //   validateOnBlur: false,
  // });

  // const {
  //   values: { MoreTestRatesList, isDefineMoreRateForTesting },
  // } = formikDefineMoreRates;

  // const handleValidSubmitDefineMoreRates = (values) => {
  //   // if (isDefineMoreRateForTesting == true) {
  //   //   formikTesting.setFieldValue(
  //   //     "ListOfTestDefineMoreRates",
  //   //     values?.MoreTestRatesList?.map((itemsubRate) => ({
  //   //       InwardMaterialTestDetailIDEncrypted: values?.TestDetailID,
  //   //       TestMasterIDEncrypted: values?.testmasterid,
  //   //       RateType: itemsubRate?.RateType,
  //   //       RateTypeName: itemsubRate?.RateTypeName,
  //   //       IsSelected: itemsubRate?.IsSelected,
  //   //     }))
  //   //   );
  //   // } else {
  //   formik.setFieldValue(
  //     `ListOfMaterials[${values?.materialIndexPara}].ListOfMaterialTestDetails[${values?.testIndexPara}].ListOfDefineMoreRates`,
  //     values?.MoreTestRatesList?.map((itemsubRate) => ({
  //       InwardMaterialTestDetailIDEncrypted: values?.TestDetailID,
  //       TestMasterIDEncrypted: values?.testmasterid,
  //       RateType: itemsubRate?.RateType,
  //       RateTypeName: itemsubRate?.RateTypeName,
  //       IsSelected: itemsubRate?.IsSelected,
  //     }))
  //   );
  //   // }
  //   setShowDefineMoreRatesModal(false);
  // };

  const handleChangeReferenceStandard = (testMasterID, indx, indxTest, e) => {
    if (e?.IsExpiredReferenceStandard == true) {
      warningMessage("Reference Standard is Expired..!");
    } else {
      formik.setFieldValue(
        `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].ReferenceStandardIDEncrypted`,
        e?.value ?? "",
      );
      formik.setFieldValue(
        `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].refStandardSubGroupOptions`,
        [],
      );
      formik.setFieldValue(
        `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].RefStandardSubGroup`,
        "",
      );
      getReferenceStandardTestSubGroupDDL(
        e?.value ?? "",
        testMasterID,
        indx,
        indxTest,
      );
    }
  };

  const getInwardMaterialTestParametersList = async (
    inwardMaterialTestDetailID,
    testMasterID,
    mIndex,
    tIndex,
  ) => {
    setIsLoading(true);
    await post(POST_GetTestParametersList, {
      TestMasterIDEncrypted: testMasterID,
      CustomerIDEncrypted: CustomerIDEncrypted,
      InwardMaterialTestDetailIDEncrypted: inwardMaterialTestDetailID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].ListOfTestParameters`,
            response?.ParametersList?.filter((x) => x.IsSelected == true)
              ?.length > 0
              ? response?.ParametersList
              : response?.ParametersList?.map((para) => ({
                  ...para,
                  IsSelected: true,
                })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showTestParametersModal, setShowTestParametersModal] = useState(false);

  const validationTestParameters = Yup.object().shape({});

  const formikTestPrameters = useFormik({
    validationSchema: validationTestParameters,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestParameters(values, formikHelpers),
    initialValues: {
      ParametersTestName: "",
      ParametersList: [],
      materialIndexPara: 0,
      testIndexPara: 0,
      selectAllPara: false,
    },
    validateOnBlur: false,
  });

  const {
    values: { ParametersTestName, ParametersList, selectAllPara },
  } = formikTestPrameters;

  const handleValidSubmitTestParameters = (values) => {
    formik.setFieldValue(
      `ListOfMaterials[${values?.materialIndexPara}].ListOfMaterialTestDetails[${values?.testIndexPara}].ListOfTestParameters`,
      values?.ParametersList,
    );
    setShowTestParametersModal(false);
  };

  const handleChangeSelectAllPara = (isChecked) => {
    formikTestPrameters.setFieldValue("selectAllPara", isChecked);
    formikTestPrameters.setFieldValue(
      "ParametersList",
      ParametersList?.map((x) => {
        return { ...x, IsSelected: isChecked };
      }),
    );
  };

  const handleOnClickParameterSelection = (indx, indxTest, item, itemTest) => {
    if (itemTest?.IsCancel == false && item?.IsHold == false) {
      formikTestPrameters.setFieldValue(
        "ParametersTestName",
        itemTest?.testOptions?.filter(
          (x) => x?.value == itemTest?.TestMasterIDEncrypted,
        )[0]?.label,
      );
      formikTestPrameters.setFieldValue(
        "ParametersList",
        itemTest?.ListOfTestParameters,
      );
      formikTestPrameters.setFieldValue("materialIndexPara", indx);
      formikTestPrameters.setFieldValue("testIndexPara", indxTest);
      formikTestPrameters.setFieldValue(
        "selectAllPara",
        itemTest?.ListOfTestParameters?.filter((x) => x.IsSelected == false)
          ?.length > 0
          ? false
          : true,
      );
      setShowTestParametersModal(true);
    }
  };

  const getReferenceStandardTestSubGroupDDL = async (
    referenceStandardID,
    testMasterID,
    indx,
    indxTest,
  ) => {
    setIsLoading(true);
    await post(POST_GetReferenceStandardTestSubGroupDDL, {
      ReferenceStandardIDEncrypted: referenceStandardID,
      TestMasterIDEncrypted: testMasterID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].refStandardSubGroupOptions`,
            response?.SubGroupList?.map((item) => ({
              label: item?.SubGroup,
              value: item?.SubGroup,
            })),
          );
          /*select the value when there is only one option*/
          if (response?.SubGroupList?.length == 1) {
            formik.setFieldValue(
              `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].RefStandardSubGroup`,
              response?.SubGroupList[0].SubGroup,
            );
            getParameterPreferenceBasedOnRefStandardTestMap(
              response?.SubGroupList[0].SubGroup,
              referenceStandardID,
              testMasterID,
              indx,
              indxTest,
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getParameterPreferenceBasedOnRefStandardTestMap = async (
    refStandardSubGroup,
    referenceStandardID,
    testMasterID,
    indx,
    indxTest,
  ) => {
    if (
      AuthUser?.Permissions?.ParameterPreferenceLoadBasedOnRefStandardTestMap ==
      true
    ) {
      setIsLoading(true);
      await post(
        POST_GetParametersPreferenceListBasedOnRefStandardTestSubGroup,
        {
          TestMasterIDEncrypted: testMasterID,
          ReferenceStandardIDEncrypted: referenceStandardID,
          RefStandardSubGroup: refStandardSubGroup,
          BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
          CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
          CustomerIDEncrypted: CustomerIDEncrypted,
          InwardMaterialTestDetailIDEncrypted:
            ListOfMaterials[indx]?.ListOfMaterialTestDetails[indxTest]
              .InwardMaterialTestDetailIDEncrypted,
        },
      )
        .then((response) => {
          if (response?.IsSuccess) {
            /* set the list if any of the parameters is selected from the list based on preference */
            if (
              response?.ParametersList?.filter((x) => x.IsSelected == true)
                ?.length > 0
            ) {
              formik.setFieldValue(
                `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].ListOfTestParameters`,
                response?.ParametersList,
              );
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const handleChangeRefStandardSubGroup = (
    referenceStandardID,
    testMasterID,
    indx,
    indxTest,
    e,
  ) => {
    formik.setFieldValue(
      `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].RefStandardSubGroup`,
      e?.value ?? "",
    );
    getParameterPreferenceBasedOnRefStandardTestMap(
      e?.value ?? "",
      referenceStandardID,
      testMasterID,
      indx,
      indxTest,
    );
  };

  // For Pagination
  const PAGE_SIZE_OPTIONS = [20, 30, 50, 100];

  const [pageSize, setPageSize] = React.useState(20);
  const [page, setPage] = React.useState(0);

  const filteredMaterials = React.useMemo(() => {
    return ListOfMaterials?.filter((x) => x.IsDeleted === false) ?? [];
  }, [ListOfMaterials]);

  // const totalPages = Math.ceil(filteredMaterials.length / pageSize);
  const totalPages = React.useMemo(() => {
    if (ViewPrimaryIdParam) {
      setPageSize(filteredMaterials.length);
    }
    return Math.ceil(filteredMaterials.length / pageSize);
  }, [filteredMaterials.length]);

  const pagedMaterials = React.useMemo(() => {
    // setIsLoading(true);
    const start = page * pageSize;
    // setTimeout(() => {
    //   setIsLoading(false);
    // }, 300);
    return filteredMaterials.slice(start, start + pageSize);
  }, [filteredMaterials, page, pageSize]);

  React.useEffect(() => {
    setIsLoading(true);

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 300);

    return () => clearTimeout(timer);
  }, [page, pageSize]);

  const GetTestSampleQuantityInformation = (indxx) => {
    setShowTestQtyModal(true);
    formik.setFieldValue(
      "ListOfTestSampleQuantityInformation",
      ListOfMaterials[indxx].ListOfMaterialTestDetails,
    );
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {PrimaryIdParam || editHeaderInwardIdParam
                ? "Edit"
                : ViewPrimaryIdParam
                  ? "View"
                  : "Add"}{" "}
              Food Testing Material Inward
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={3}>
                    {!ViewPrimaryIdParam && InwardCurrentStatus == 1 ? (
                      <Field
                        label="Inward Date"
                        name="InwardDate"
                        placeholder={"Select Inward Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                          maxDate: new Date(),
                        }}
                        required
                      />
                    ) : (
                      <Field
                        label="Inward Date"
                        name="InwardDate"
                        component={CustomInput}
                        value={moment(InwardDate).format("DD-MMM-yyyy")}
                        required
                        disabled={true}
                      />
                    )}
                  </Col>
                  <Col lg={3}>
                    {!ViewPrimaryIdParam && InwardCurrentStatus == 1 ? (
                      <Field
                        label="Inward No"
                        name="InwardNo"
                        placeholder={"Select Inward No"}
                        options={inwardNoOptions}
                        component={CustomSelect}
                        required
                        autoFocus
                        onChange={(e) => {
                          //console.log(e);
                          formik.setFieldValue("InwardNo", e?.value ?? "");
                          formik.setFieldValue(
                            "IsTCNoBasedOnInwardNo",
                            e ? e?.IsTCNoBasedOnInwardNo : true,
                          );
                        }}
                      />
                    ) : (
                      <Field
                        label="Inward No"
                        name="InwardNo"
                        component={CustomInput}
                        required
                        disabled={true}
                      />
                    )}
                  </Col>
                  <Col lg={3}>
                    {/* <Field
                          label="Customer"
                          name="CustomerIDEncrypted"
                          placeholder={"Select Customer"}
                          options={customerOptions}
                          component={CustomSelect}
                          required
                        /> */}
                    {!PrimaryIdParam &&
                    !editHeaderInwardIdParam &&
                    !ViewPrimaryIdParam ? (
                      <>
                        {AuthUser?.UserType !== 1 ||
                        formsList?.filter((x) => x?.FormID == 10 && x?.IsAdd)
                          ?.length > 0 ? (
                          <Link
                            to="#"
                            className="icon-box icon-box-md bg-primary-light me-1"
                            title="New Customer"
                            style={{ float: "right" }}
                            // onClick={() => {
                            //   redirectToNewCustomer();
                            // }}
                            onClick={() => {
                              window.open(`/add-customer/${true}`, "_blank");
                            }}
                          >
                            <i className="fa fa-plus"></i>
                          </Link>
                        ) : (
                          ""
                        )}
                        <Link
                          to="#"
                          className="icon-box icon-box-md bg-primary-light me-1"
                          title="Reload Customer"
                          style={{ float: "right" }}
                          onClick={() => {
                            // loadOptionsCutomer("");
                            setRefreshCustomerKey(
                              Math.random().toString(9).substring(2, 9),
                            );
                          }}
                        >
                          <i className="fa fa-refresh"></i>
                        </Link>
                      </>
                    ) : (
                      ""
                    )}
                    {editHeaderInwardIdParam ? (
                      formik?.values?.IsHeaderDetailCustomerChange == false ? (
                        <Link
                          to="#"
                          className="me-1"
                          title="Edit"
                          style={{ float: "right" }}
                          onClick={handleChangeHeaderDetailCustomerChange}
                        >
                          {SVGICON.EditSquareDanger}{" "}
                          <label
                            className="mb-1 text-danger"
                            style={{ cursor: "pointer" }}
                          >
                            Edit
                          </label>
                        </Link>
                      ) : (
                        <Link
                          to="#"
                          className="me-1"
                          title="Cancel"
                          style={{ float: "right" }}
                          onClick={cancelHeaderDetailCustomerChange}
                        >
                          {SVGICON.EditSquareDanger}{" "}
                          <label
                            className="mb-1 text-danger"
                            style={{ cursor: "pointer" }}
                          >
                            Cancel
                          </label>
                        </Link>
                      )
                    ) : (
                      ""
                    )}

                    {(editHeaderInwardIdParam &&
                      formik?.values?.IsHeaderDetailCustomerChange == false) ||
                    IsAllowToEdit != 1 ||
                    ViewPrimaryIdParam ? (
                      <Field
                        label="Customer"
                        name="CustomerName"
                        component={CustomInput}
                        required
                        disabled={true}
                      />
                    ) : (
                      <Field
                        key={refreshCustomerKey}
                        label="Customer"
                        name="CustomerIDEncrypted"
                        placeholder={"Select Customer"}
                        //options={customerOptions}
                        loadOptionsFn={loadOptionsCutomer}
                        component={CustomSelectAsync}
                        title={CustomerName}
                        labelFieldName="CustomerName"
                        onChange={(e) => {
                          formik.setFieldValue(
                            "CustomerIDEncrypted",
                            e?.value ?? "",
                          );
                          formik.setFieldValue("CustomerName", e?.label ?? "");
                          if (e && e?.value && !editHeaderInwardIdParam) {
                            ValidateCustomerCredit(e?.value);
                          }
                        }}
                        required
                      />
                    )}
                  </Col>
                  <Col lg={3}>
                    {editHeaderInwardIdParam ? (
                      formik?.values?.IsHeaderDetailProjectChange == false ? (
                        <Link
                          to="#"
                          className="me-1"
                          title="Edit"
                          style={{ float: "right" }}
                          onClick={handleChangeHeaderDetailProjectChange}
                        >
                          {SVGICON.EditSquareDanger}{" "}
                          <label
                            className="mb-1 text-danger"
                            style={{ cursor: "pointer" }}
                          >
                            Edit
                          </label>
                        </Link>
                      ) : (
                        <Link
                          to="#"
                          className="me-1"
                          title="Cancel"
                          style={{ float: "right" }}
                          onClick={cancelHeaderDetailProjectChange}
                        >
                          {SVGICON.EditSquareDanger}{" "}
                          <label
                            className="mb-1 text-danger"
                            style={{ cursor: "pointer" }}
                          >
                            Cancel
                          </label>
                        </Link>
                      )
                    ) : (
                      ""
                    )}

                    {(editHeaderInwardIdParam &&
                      formik?.values?.IsHeaderDetailProjectChange == false) ||
                    IsAllowToEdit != 1 ||
                    ViewPrimaryIdParam ? (
                      <Field
                        label="Project"
                        name="CustomerProjectName"
                        component={CustomInput}
                        required
                        disabled={true}
                      />
                    ) : (
                      <Field
                        label="Project"
                        name="CustomerProjectIDEncrypted"
                        placeholder={"Select Project"}
                        options={projectOptions}
                        component={CustomSelect}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "CustomerProjectIDEncrypted",
                            e?.value ?? "",
                          );
                          formik.setFieldValue(
                            "CustomerProjectName",
                            e?.label ?? "",
                          );
                        }}
                        required
                      />
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    {!editHeaderInwardIdParam &&
                      IsAllowToEdit == 1 &&
                      !ViewPrimaryIdParam && (
                        <Link
                          to="#"
                          className="icon-box icon-box-md bg-primary-light me-1"
                          title="Select Work Detail"
                          style={{ float: "right" }}
                          onClick={() => {
                            setShowWorkDetailModal(true);
                          }}
                        >
                          <i className="fa fa-edit"></i>
                        </Link>
                      )}
                    {editHeaderInwardIdParam ? (
                      formik?.values?.IsHeaderDetailWorkDetailChange ==
                      false ? (
                        <Link
                          to="#"
                          className="me-1"
                          title="Edit"
                          style={{ float: "right" }}
                          onClick={handleChangeHeaderDetailWorkDetailChange}
                        >
                          {SVGICON.EditSquareDanger}{" "}
                          <label
                            className="mb-1 text-danger"
                            style={{ cursor: "pointer" }}
                          >
                            Edit
                          </label>
                        </Link>
                      ) : (
                        <Link
                          to="#"
                          className="me-1"
                          title="Cancel"
                          style={{ float: "right" }}
                          onClick={cancelHeaderDetailWorkDetailChange}
                        >
                          {SVGICON.EditSquareDanger}{" "}
                          <label
                            className="mb-1 text-danger"
                            style={{ cursor: "pointer" }}
                          >
                            Cancel
                          </label>
                        </Link>
                      )
                    ) : (
                      ""
                    )}
                    {/* <Field
                      label="Work Detail"
                      name="ProjectDetails"
                      placeholder={"Enter Work Detail"}
                      component={CustomTextArea}
                      rows={5}
                      // required
                      maxLength={500}
                      disabled={
                        (editHeaderInwardIdParam &&
                          formik?.values?.IsHeaderDetailWorkDetailChange ==
                            false) ||
                        IsAllowToEdit != 1 ||
                        ViewPrimaryIdParam
                      }
                    /> */}
                    <CustomTextAreaUncontrolled
                      label="Work Detail"
                      name="ProjectDetails"
                      placeholder={"Enter Work Detail"}
                      defaultValue={formik.values.ProjectDetails}
                      rows={5}
                      maxLength={2000}
                      disabled={
                        (editHeaderInwardIdParam &&
                          formik?.values?.IsHeaderDetailWorkDetailChange ==
                            false) ||
                        IsAllowToEdit != 1 ||
                        ViewPrimaryIdParam
                      }
                      onValueCommit={(val) => {
                        formik.setFieldValue("ProjectDetails", val);
                      }}
                    />
                  </Col>
                  <Col lg={6}>
                    <Row>
                      <Col lg={6}>
                        {editHeaderInwardIdParam ? (
                          formik?.values?.IsHeaderDetailLetterRefNoChange ==
                          false ? (
                            <Link
                              to="#"
                              className="me-1"
                              title="Edit"
                              style={{ float: "right" }}
                              onClick={
                                handleChangeHeaderDetailLetterRefNoChange
                              }
                            >
                              {SVGICON.EditSquareDanger}{" "}
                              <label
                                className="mb-1 text-danger"
                                style={{ cursor: "pointer" }}
                              >
                                Edit
                              </label>
                            </Link>
                          ) : (
                            <Link
                              to="#"
                              className="me-1"
                              title="Cancel"
                              style={{ float: "right" }}
                              onClick={cancelHeaderDetailLetterRefNoChange}
                            >
                              {SVGICON.EditSquareDanger}{" "}
                              <label
                                className="mb-1 text-danger"
                                style={{ cursor: "pointer" }}
                              >
                                Cancel
                              </label>
                            </Link>
                          )
                        ) : (
                          ""
                        )}
                        {/* <Field
                          label="Letter Ref No"
                          name="LetterRefNo"
                          placeholder={"Enter Letter Ref No"}
                          component={CustomInput}
                          maxLength={100}
                          disabled={
                            (editHeaderInwardIdParam &&
                              formik?.values?.IsHeaderDetailLetterRefNoChange ==
                                false) ||
                            ViewPrimaryIdParam
                          }
                        /> */}
                        <CustomInputUncontrolled
                          label="Letter Ref No"
                          name={`LetterRefNo`}
                          placeholder={"Enter Letter Ref No"}
                          defaultValue={formik.values.LetterRefNo}
                          maxLength={100}
                          disabled={
                            (editHeaderInwardIdParam &&
                              formik?.values?.IsHeaderDetailLetterRefNoChange ==
                                false) ||
                            ViewPrimaryIdParam
                          }
                          onValueCommit={(val) => {
                            formik.setFieldValue(`LetterRefNo`, val);
                          }}
                        />
                      </Col>
                      <Col lg={6}>
                        {ListOfLetterRefDoc.length > 0 ? (
                          <label
                            // style={{ color: "#4189e8" }}
                            className="text-primary"
                            title="File Uploaded"
                          >
                            Letter Ref Doc
                          </label>
                        ) : (
                          <label>Letter Ref Doc </label>
                        )}
                        <div className="mb-2">
                          <div className="input-group">
                            <span className="form-control form-control-sm ps-2">
                              <Link
                                to="#"
                                className="text-primary"
                                onClick={() => {
                                  setShowLetterRefDocModal(true);
                                }}
                              >
                                View Letter Ref Doc
                              </Link>
                            </span>
                            <div
                              className="input-group-text"
                              title="Choose File"
                              style={{
                                borderRadius: "0 0.375rem 0.375rem 0",
                              }}
                            >
                              <div className="open-file">
                                <input
                                  // type="file"
                                  id="LetterRefUpload"
                                  ////accept="image/png, image/gif, image/jpeg"
                                  //onChange={uploadLetterRefDoc}
                                  onClick={() => {
                                    setShowLetterRefDocModal(true);
                                  }}
                                />
                                <label
                                  htmlFor="LetterRefUpload"
                                  name=""
                                ></label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="d-flex">
                          <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 mb-1 me-1">
                            <label className="mb-1">TPI Required &nbsp;</label>
                          </text>
                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckIsTPIRequired"
                              title={IsTPIRequired == true ? "Yes" : "No"}
                              checked={IsTPIRequired}
                              onChange={handleChangeIsTPIRequired}
                              style={{ cursor: "pointer" }}
                              disabled={ViewPrimaryIdParam}
                            ></input>
                          </div>
                        </div>
                        {IsTPIRequired == true && (
                          <div className="mb-2">
                            <div className="input-group">
                              <span className="form-control form-control-sm ps-2">
                                <Link
                                  to="#"
                                  className="text-primary"
                                  onClick={() => {
                                    setShowTPIDetailModal(true);
                                  }}
                                >
                                  View TPI Details
                                </Link>
                              </span>
                              <div
                                className="input-group-text"
                                title="Add TPI Detail"
                                style={{
                                  borderRadius: "0 0.375rem 0.375rem 0",
                                  cursor: ViewPrimaryIdParam
                                    ? "not-allowed"
                                    : "pointer",
                                }}
                                onClick={() => {
                                  if (!ViewPrimaryIdParam) {
                                    addNewTPI();
                                  }
                                }}
                              >
                                <i className="fa fa-plus" />
                              </div>
                            </div>
                          </div>
                        )}
                      </Col>
                      <Col lg={6}>
                        <Field
                          label="Request Type"
                          name="RequestType"
                          placeholder={"Select Request Type"}
                          options={requestTypeOptions}
                          component={CustomSelect}
                          required
                        />
                      </Col>
                    </Row>
                  </Col>

                  {AuthUser?.Permissions?.InwardClubing == true &&
                    CustomerIDEncrypted && (
                      <Col lg={6}>
                        <div className="d-flex">
                          <div className="pt-2">
                            <label className="mb-1"></label>
                            <div className="d-flex mb-2">
                              <label className="mb-1">
                                Inward Clubing &nbsp;
                              </label>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckInwardClubing"
                                  title={InwardClubing == true ? "Yes" : "No"}
                                  checked={InwardClubing}
                                  onChange={handleChangeInwardClubing}
                                  style={{ cursor: "pointer" }}
                                  disabled={ViewPrimaryIdParam}
                                ></input>
                              </div>
                            </div>
                          </div>
                          &nbsp;&nbsp;&nbsp;
                          <div style={{ flex: 1 }}>
                            {InwardClubing ? (
                              <Field
                                label="Clubing Inward No"
                                name="InwardIDsClubing"
                                placeholder={"Select Inward No"}
                                options={inwardNoClubingOptions}
                                component={CustomMultiSelect}
                                isMulti={true}
                                menuPosition="fixed"
                                onChange={handleChangeInwardNos}
                                disabled={ViewPrimaryIdParam}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </Col>
                    )}
                </Row>
                <hr className="mt-1 mb-1"></hr>
                <Row>
                  <Col lg={6}>
                    <label>Material Information</label>
                  </Col>
                  {CopyInwardIdParam && (
                    <Col lg={6} style={{ textAlign: "right" }}>
                      <span className="text-warning fs-12">
                        [Note: Sample Images are not copied.]
                      </span>
                    </Col>
                  )}

                  {editHeaderInwardIdParam && (
                    <Col lg={6} style={{ textAlign: "right" }}>
                      <span className="text-danger fs-12">
                        [Note: Changed Sample information will result in the
                        deletion of related transactions, such as Report
                        Printing
                        {AuthUser?.Permissions?.UploadScanCopy == 1
                          ? " and Upload Scan Copy"
                          : ""}
                        , if they exist.]
                      </span>
                    </Col>
                  )}

                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="MaterialInfo-tbl_wrapper"
                        className="dataTables_wrapper table-responsive no-footer"
                      >
                        <table
                          id="MaterialInfo-tbl"
                          className="table table-bordered no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="2%">
                                {!editHeaderInwardIdParam &&
                                  !ViewPrimaryIdParam && (
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md bg-primary-light"
                                      title="Add New"
                                      onClick={() => {
                                        AddNewMaterialInformation();
                                      }}
                                    >
                                      <i className="fa fa-plus"></i>
                                    </Link>
                                  )}
                              </th>
                              {/* <th width="14%">Department</th> */}
                              <th width="160px">TC No</th>
                              <th width="250px">Sample Detail</th>
                              <th width="180px">Condition</th>
                              <th width="180px">
                                Size(Sample Quantity){" "}
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md bg-primary-light"
                                  title="Test Qty"
                                  onClick={() => {
                                    GetTestSampleQuantityInformation(0);
                                  }}
                                >
                                  <i className="fa fa-cubes"></i>
                                </Link>
                              </th>
                              <th width="180px">Sample Packing</th>
                              <th width="180px">Lot No</th>
                              <th width="120px" style={{ textAlign: "left" }}>
                                Mfg. Date
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* {ListOfMaterials?.filter(
                              (x) => x.IsDeleted == false,
                            )?.length > 0 ? (
                              ListOfMaterials?.map((item, indx) => ( 
                                <React.Fragment key={indx}>
                                    <tr
                                      className="repeatTableHeader"
                                      style={{
                                        display: `${indx == 0 ? "none" : ""}`,
                                      }}
                                    >*/}
                            {pagedMaterials?.filter((x) => x.IsDeleted == false)
                              ?.length > 0 ? (
                              pagedMaterials?.map((item, indxx) => {
                                const indx = page * pageSize + indxx;
                                return (
                                  <React.Fragment key={indx}>
                                    <tr
                                      className="repeatTableHeader"
                                      style={{
                                        display: `${indxx == 0 ? "none" : ""}`,
                                      }}
                                    >
                                      <th width="2%">
                                        {!editHeaderInwardIdParam &&
                                          !ViewPrimaryIdParam && (
                                            <Link
                                              to="#"
                                              className="icon-box icon-box-md bg-primary-light"
                                              title="Add New"
                                              onClick={() => {
                                                AddNewMaterialInformation();
                                              }}
                                            >
                                              <i className="fa fa-plus"></i>
                                            </Link>
                                          )}
                                      </th>
                                      {/* <th width="14%">Department</th> */}
                                      <th width="160px">TC No</th>
                                      <th width="250px">Sample Detail</th>
                                      <th width="180px">Condition</th>
                                      <th width="180px">
                                        Size (Sample Quantity)
                                        <Link
                                          to="#"
                                          className="icon-box icon-box-md bg-primary-light"
                                          title="Test Qty"
                                          onClick={() => {
                                            GetTestSampleQuantityInformation(
                                              indxx,
                                            );
                                          }}
                                        >
                                          <i className="fa fa-cubes"></i>
                                        </Link>
                                      </th>
                                      <th width="180px">Sample Packing</th>
                                      <th width="180px">Lot No</th>
                                      <th
                                        width="120px"
                                        style={{ textAlign: "left" }}
                                      >
                                        Mfg. Date
                                      </th>
                                    </tr>
                                    <tr
                                      key={indx}
                                      style={{
                                        display:
                                          item.IsDeleted == true ? "none" : "",
                                        backgroundColor:
                                          item?.IsErrorDisplay == true
                                            ? "#f69393"
                                            : "",
                                      }}
                                    >
                                      <td
                                        className="p-1"
                                        style={{
                                          borderBottomColor: "transparent",
                                        }}
                                      >
                                        {editHeaderInwardIdParam ? (
                                          item?.IsHeaderDetailMaterialInformationChange ==
                                          false ? (
                                            <Link
                                              to="#"
                                              className="me-1"
                                              title="Edit"
                                              onClick={() => {
                                                handleChangeHeaderDetailMaterialInformationChange(
                                                  indx,
                                                );
                                              }}
                                            >
                                              {SVGICON.EditSquareDanger}{" "}
                                              <label
                                                className="mb-1 text-danger"
                                                style={{ cursor: "pointer" }}
                                              >
                                                Edit
                                              </label>
                                            </Link>
                                          ) : (
                                            <Link
                                              to="#"
                                              className="me-1"
                                              title="Cancel"
                                              style={{ float: "right" }}
                                              onClick={() => {
                                                cancelHeaderDetailMaterialInformationChange(
                                                  indx,
                                                );
                                              }}
                                            >
                                              {SVGICON.EditSquareDanger}{" "}
                                              <label
                                                className="mb-1 text-danger"
                                                style={{ cursor: "pointer" }}
                                              >
                                                Cancel
                                              </label>
                                            </Link>
                                          )
                                        ) : (
                                          !ViewPrimaryIdParam && (
                                            <>
                                              <Link
                                                to="#"
                                                className="icon-box icon-box-md me-1"
                                                title="Delete"
                                                onClick={() => {
                                                  //deleteMaterialInformation(indx);
                                                  delete_RecordWithoutApi(
                                                    deleteMaterialInformation,
                                                    indx,
                                                  );
                                                }}
                                              >
                                                {SVGICON.DeleteDanger}
                                              </Link>

                                              <Link
                                                to="#"
                                                className="icon-box icon-box-md"
                                                title="Repeat"
                                                onClick={() => {
                                                  formik.setFieldValue(
                                                    "selectedMaterialInfoRow",
                                                    indx,
                                                  );
                                                  formikMaterialInfoRepeatRow.resetForm();
                                                  setShowMaterialInfoRepeatRowQtyModal(
                                                    true,
                                                  );
                                                }}
                                              >
                                                <i className="fa fa-repeat" />
                                              </Link>
                                            </>
                                          )
                                        )}
                                      </td>
                                      {IsTCNoBasedOnInwardNo == false ||
                                      (InwardCurrentStatus > 1 &&
                                        (PrimaryIdParam ||
                                          editHeaderInwardIdParam ||
                                          ViewPrimaryIdParam)) ? (
                                        <td
                                          className="p-1"
                                          style={{ minWidth: "160px" }}
                                        >
                                          {(item.TCNoAllocated == false ||
                                            !item.InwardMaterialIDEncrypted) &&
                                          IsTCNoBasedOnInwardNo == false ? (
                                            <Field
                                              name={`ListOfMaterials[${indx}].TCNo`}
                                              placeholder={"TC No"}
                                              options={tcNoOptions}
                                              component={CustomSelect}
                                              noMarginBottom={true}
                                              menuPosition="fixed"
                                            />
                                          ) : item.TCNoAllocated == false ||
                                            !item.InwardMaterialIDEncrypted ? (
                                            ""
                                          ) : (
                                            <Field
                                              name={`ListOfMaterials[${indx}].TCNo`}
                                              placeholder={"TC No"}
                                              component={CustomInput}
                                              disabled={true}
                                              noMarginBottom={true}
                                            />
                                          )}
                                        </td>
                                      ) : (
                                        <td
                                          className="p-1"
                                          style={{ minWidth: "160px" }}
                                        ></td>
                                      )}
                                      <td
                                        className="p-1"
                                        style={{ minWidth: "250px" }}
                                      >
                                        {/* <Field
                                        name={`ListOfMaterials[${indx}].SampleDetail`}
                                        placeholder={"Sample Detail"}
                                        component={CustomInput}
                                        maxLength={2000}
                                        noMarginBottom={true}
                                        disabled={
                                          (editHeaderInwardIdParam &&
                                            item?.IsHeaderDetailMaterialInformationChange ==
                                              false) ||
                                          ViewPrimaryIdParam
                                        }
                                      /> */}
                                        <CustomInputUncontrolled
                                          name={`ListOfMaterials[${indx}].SampleDetail`}
                                          placeholder={"Sample Detail"}
                                          defaultValue={item.SampleDetail}
                                          maxLength={2000}
                                          noMarginBottom={true}
                                          disabled={
                                            (editHeaderInwardIdParam &&
                                              item?.IsHeaderDetailMaterialInformationChange ==
                                                false) ||
                                            ViewPrimaryIdParam
                                          }
                                          onValueCommit={(val) => {
                                            formik.setFieldValue(
                                              `ListOfMaterials[${indx}].SampleDetail`,
                                              val,
                                            );
                                          }}
                                        />
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{ minWidth: "180px" }}
                                      >
                                        {/* <Field
                                        name={`ListOfMaterials[${indx}].Condition`}
                                        placeholder={"Condition"}
                                        component={CustomInput}
                                        maxLength={500}
                                        noMarginBottom={true}
                                        disabled={
                                          (editHeaderInwardIdParam &&
                                            item?.IsHeaderDetailMaterialInformationChange ==
                                              false) ||
                                          ViewPrimaryIdParam
                                        }
                                      /> */}
                                        <CustomInputUncontrolled
                                          name={`ListOfMaterials[${indx}].Condition`}
                                          placeholder={"Condition"}
                                          defaultValue={item.Condition}
                                          maxLength={500}
                                          noMarginBottom={true}
                                          disabled={
                                            (editHeaderInwardIdParam &&
                                              item?.IsHeaderDetailMaterialInformationChange ==
                                                false) ||
                                            ViewPrimaryIdParam
                                          }
                                          onValueCommit={(val) => {
                                            formik.setFieldValue(
                                              `ListOfMaterials[${indx}].Condition`,
                                              val,
                                            );
                                          }}
                                        />
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{ minWidth: "200px" }}
                                      >
                                        {/* <Field
                                        name={`ListOfMaterials[${indx}].Size`}
                                        placeholder={"Size (Sample Quantity)"}
                                        component={CustomInput}
                                        maxLength={500}
                                        noMarginBottom={true}
                                        disabled={
                                          (editHeaderInwardIdParam &&
                                            item?.IsHeaderDetailMaterialInformationChange ==
                                              false) ||
                                          ViewPrimaryIdParam
                                        }
                                      /> */}
                                        <div className="d-flex">
                                          {/* <label
                                            style={{
                                              fontSize: "11px",
                                              marginTop: "10px",
                                            }}
                                          >
                                            <b>Qty :</b>
                                            {item?.TotalSampleMinimumQty}
                                          </label>{" "} */}
                                          <CustomInputUncontrolled
                                            type="number"
                                            name={`ListOfMaterials[${indx}].Size`}
                                            placeholder={"Sample Quantity"}
                                            defaultValue={item.Size}
                                            maxLength={500}
                                            noMarginBottom={true}
                                            numberTypeWithoutDot={false}
                                            disabled={
                                              (editHeaderInwardIdParam &&
                                                item?.IsHeaderDetailMaterialInformationChange ==
                                                  false) ||
                                              ViewPrimaryIdParam
                                            }
                                            onValueCommit={(val) => {
                                              formik.setFieldValue(
                                                `ListOfMaterials[${indx}].Size`,
                                                val,
                                              );
                                            }}
                                          />
                                          <div style={{ width: "60%" }}>
                                            <Field
                                              name={`ListOfMaterials[${indx}].SampleQtyUnitID`}
                                              placeholder={"Unit"}
                                              options={unitOptions}
                                              component={CustomSelect}
                                              noMarginBottom={true}
                                              menuPosition="fixed"
                                              isDisabled={
                                                (editHeaderInwardIdParam &&
                                                  item?.IsHeaderDetailMaterialInformationChange ==
                                                    false) ||
                                                ViewPrimaryIdParam
                                              }
                                            />
                                          </div>
                                        </div>
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{ minWidth: "180px" }}
                                      >
                                        {/* <Field
                                        name={`ListOfMaterials[${indx}].SamplePacking`}
                                        placeholder={"Sample Packing"}
                                        component={CustomInput}
                                        maxLength={500}
                                        noMarginBottom={true}
                                        disabled={
                                          (editHeaderInwardIdParam &&
                                            item?.IsHeaderDetailMaterialInformationChange ==
                                              false) ||
                                          ViewPrimaryIdParam
                                        }
                                      /> */}
                                        <CustomInputUncontrolled
                                          name={`ListOfMaterials[${indx}].SamplePacking`}
                                          placeholder={"Sample Packing"}
                                          defaultValue={item.SamplePacking}
                                          maxLength={500}
                                          noMarginBottom={true}
                                          disabled={
                                            (editHeaderInwardIdParam &&
                                              item?.IsHeaderDetailMaterialInformationChange ==
                                                false) ||
                                            ViewPrimaryIdParam
                                          }
                                          onValueCommit={(val) => {
                                            formik.setFieldValue(
                                              `ListOfMaterials[${indx}].SamplePacking`,
                                              val,
                                            );
                                          }}
                                        />
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{ minWidth: "180px" }}
                                      >
                                        {/* <Field
                                        name={`ListOfMaterials[${indx}].LotNo`}
                                        placeholder={"Lot No"}
                                        component={CustomInput}
                                        maxLength={500}
                                        noMarginBottom={true}
                                        disabled={
                                          (editHeaderInwardIdParam &&
                                            item?.IsHeaderDetailMaterialInformationChange ==
                                              false) ||
                                          ViewPrimaryIdParam
                                        }
                                      /> */}
                                        <CustomInputUncontrolled
                                          name={`ListOfMaterials[${indx}].LotNo`}
                                          placeholder={"Lot No"}
                                          defaultValue={item.LotNo}
                                          maxLength={500}
                                          noMarginBottom={true}
                                          disabled={
                                            (editHeaderInwardIdParam &&
                                              item?.IsHeaderDetailMaterialInformationChange ==
                                                false) ||
                                            ViewPrimaryIdParam
                                          }
                                          onValueCommit={(val) => {
                                            formik.setFieldValue(
                                              `ListOfMaterials[${indx}].LotNo`,
                                              val,
                                            );
                                          }}
                                        />
                                      </td>

                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "120px",
                                          textAlign: "left",
                                        }}
                                      >
                                        {/* <Field
                                        name={`ListOfMaterials[${indx}].MfgDate`}
                                        placeholder={"Mfg. Date"}
                                        component={CustomInput}
                                        maxLength={500}
                                        noMarginBottom={true}
                                        disabled={
                                          (editHeaderInwardIdParam &&
                                            item?.IsHeaderDetailMaterialInformationChange ==
                                              false) ||
                                          ViewPrimaryIdParam
                                        }
                                      /> */}
                                        <CustomInputUncontrolled
                                          name={`ListOfMaterials[${indx}].MfgDate`}
                                          placeholder={"Mfg. Date"}
                                          defaultValue={item.MfgDate}
                                          maxLength={500}
                                          noMarginBottom={true}
                                          disabled={
                                            (editHeaderInwardIdParam &&
                                              item?.IsHeaderDetailMaterialInformationChange ==
                                                false) ||
                                            ViewPrimaryIdParam
                                          }
                                          onValueCommit={(val) => {
                                            formik.setFieldValue(
                                              `ListOfMaterials[${indx}].MfgDate`,
                                              val,
                                            );
                                          }}
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          borderBottomColor: "transparent",
                                        }}
                                      ></td>
                                      <td
                                        colSpan={7}
                                        className="p-0"
                                        style={{ textAlign: "left" }}
                                      >
                                        <table
                                          id="MaterialInfo-tbl"
                                          className="table table-bordered no-footer mb-0"
                                        >
                                          <thead>
                                            <tr>
                                              <th
                                                width="160px"
                                                style={{
                                                  textTransform: "none",
                                                }}
                                              >
                                                Exp. Date
                                              </th>
                                              <th
                                                width="250px"
                                                style={{
                                                  textTransform: "none",
                                                }}
                                              >
                                                Customer Provided Sample Detail
                                              </th>
                                              <th
                                                width="180px"
                                                style={{
                                                  textTransform: "none",
                                                }}
                                              >
                                                Marking
                                              </th>
                                              <th width="180px">
                                                Sample Batch Code
                                              </th>
                                              <th width="180px">Sampling By</th>
                                              <th width="180px">
                                                Sample Drawn By
                                              </th>
                                              {/* {AuthUser?.Permissions?.Machining ==
                                            1 ? (
                                              <th width="180px">Machining</th>
                                            ) : (
                                              ""
                                            )} */}
                                              <th
                                                width="120px"
                                                style={{ textAlign: "left" }}
                                              >
                                                Images
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr
                                              key={`tc_${indx}`}
                                              style={{
                                                display:
                                                  item.IsDeleted == true
                                                    ? "none"
                                                    : "",
                                              }}
                                            >
                                              <td
                                                className="p-1"
                                                style={{ width: "160px" }}
                                              >
                                                {/* <Field
                                                name={`ListOfMaterials[${indx}].ExpDate`}
                                                placeholder={"Exp. Date"}
                                                component={CustomInput}
                                                maxLength={500}
                                                noMarginBottom={true}
                                                disabled={
                                                  (editHeaderInwardIdParam &&
                                                    item?.IsHeaderDetailMaterialInformationChange ==
                                                      false) ||
                                                  ViewPrimaryIdParam
                                                }
                                              /> */}
                                                <CustomInputUncontrolled
                                                  name={`ListOfMaterials[${indx}].ExpDate`}
                                                  placeholder={"Exp. Date"}
                                                  defaultValue={item.ExpDate}
                                                  maxLength={500}
                                                  noMarginBottom={true}
                                                  disabled={
                                                    (editHeaderInwardIdParam &&
                                                      item?.IsHeaderDetailMaterialInformationChange ==
                                                        false) ||
                                                    ViewPrimaryIdParam
                                                  }
                                                  onValueCommit={(val) => {
                                                    formik.setFieldValue(
                                                      `ListOfMaterials[${indx}].ExpDate`,
                                                      val,
                                                    );
                                                  }}
                                                />
                                              </td>
                                              <td
                                                className="p-1"
                                                style={{ width: "250px" }}
                                              >
                                                {/* <Field
                                                name={`ListOfMaterials[${indx}].CustomerProvidedSampleDetail`}
                                                placeholder={
                                                  "Customer Provided Sample Detail"
                                                }
                                                component={CustomInput}
                                                maxLength={500}
                                                noMarginBottom={true}
                                                menuPosition="fixed"
                                                disabled={
                                                  (editHeaderInwardIdParam &&
                                                    item?.IsHeaderDetailMaterialInformationChange ==
                                                      false) ||
                                                  ViewPrimaryIdParam
                                                }
                                              /> */}
                                                <CustomInputUncontrolled
                                                  name={`ListOfMaterials[${indx}].CustomerProvidedSampleDetail`}
                                                  placeholder={
                                                    "Customer Provided Sample Detail"
                                                  }
                                                  defaultValue={
                                                    item.CustomerProvidedSampleDetail
                                                  }
                                                  maxLength={500}
                                                  noMarginBottom={true}
                                                  menuPosition="fixed"
                                                  disabled={
                                                    (editHeaderInwardIdParam &&
                                                      item?.IsHeaderDetailMaterialInformationChange ==
                                                        false) ||
                                                    ViewPrimaryIdParam
                                                  }
                                                  onValueCommit={(val) => {
                                                    formik.setFieldValue(
                                                      `ListOfMaterials[${indx}].CustomerProvidedSampleDetail`,
                                                      val,
                                                    );
                                                  }}
                                                />
                                              </td>

                                              <td
                                                className="p-1"
                                                style={{ width: "180px" }}
                                              >
                                                {/* <Field
                                                name={`ListOfMaterials[${indx}].Marking`}
                                                placeholder={"Marking"}
                                                component={CustomInput}
                                                maxLength={500}
                                                noMarginBottom={true}
                                                disabled={
                                                  (editHeaderInwardIdParam &&
                                                    item?.IsHeaderDetailMaterialInformationChange ==
                                                      false) ||
                                                  ViewPrimaryIdParam
                                                }
                                              /> */}
                                                <CustomInputUncontrolled
                                                  name={`ListOfMaterials[${indx}].Marking`}
                                                  placeholder={"Marking"}
                                                  defaultValue={item.Marking}
                                                  maxLength={500}
                                                  noMarginBottom={true}
                                                  disabled={
                                                    (editHeaderInwardIdParam &&
                                                      item?.IsHeaderDetailMaterialInformationChange ==
                                                        false) ||
                                                    ViewPrimaryIdParam
                                                  }
                                                  onValueCommit={(val) => {
                                                    formik.setFieldValue(
                                                      `ListOfMaterials[${indx}].Marking`,
                                                      val,
                                                    );
                                                  }}
                                                />
                                              </td>

                                              <td
                                                className="p-1"
                                                style={{ width: "180px" }}
                                              >
                                                {/* <Field
                                                name={`ListOfMaterials[${indx}].SampleBatchCode`}
                                                placeholder={
                                                  "Sample Batch Code"
                                                }
                                                component={CustomInput}
                                                maxLength={500}
                                                noMarginBottom={true}
                                                menuPosition="fixed"
                                                disabled={
                                                  (editHeaderInwardIdParam &&
                                                    item?.IsHeaderDetailMaterialInformationChange ==
                                                      false) ||
                                                  ViewPrimaryIdParam
                                                }
                                              /> */}
                                                <CustomInputUncontrolled
                                                  name={`ListOfMaterials[${indx}].SampleBatchCode`}
                                                  placeholder={
                                                    "Sample Batch Code"
                                                  }
                                                  defaultValue={
                                                    item.SampleBatchCode
                                                  }
                                                  maxLength={500}
                                                  noMarginBottom={true}
                                                  menuPosition="fixed"
                                                  disabled={
                                                    (editHeaderInwardIdParam &&
                                                      item?.IsHeaderDetailMaterialInformationChange ==
                                                        false) ||
                                                    ViewPrimaryIdParam
                                                  }
                                                  onValueCommit={(val) => {
                                                    formik.setFieldValue(
                                                      `ListOfMaterials[${indx}].SampleBatchCode`,
                                                      val,
                                                    );
                                                  }}
                                                />
                                              </td>

                                              <td
                                                className="p-1"
                                                style={{ width: "180px" }}
                                              >
                                                <Field
                                                  name={`ListOfMaterials[${indx}].SamplingBy`}
                                                  placeholder={"Sampling By"}
                                                  options={samplingByOptions}
                                                  component={CustomSelect}
                                                  noMarginBottom={true}
                                                  menuPosition="fixed"
                                                  isDisabled={
                                                    (editHeaderInwardIdParam &&
                                                      item?.IsHeaderDetailMaterialInformationChange ==
                                                        false) ||
                                                    ViewPrimaryIdParam
                                                  }
                                                />
                                              </td>

                                              <td
                                                className="p-1"
                                                style={{ width: "180px" }}
                                              >
                                                {/* <Field
                                                name={`ListOfMaterials[${indx}].SampleDrawnBy`}
                                                placeholder={"Sample Drawn By"}
                                                component={CustomInput}
                                                maxLength={500}
                                                noMarginBottom={true}
                                                disabled={
                                                  (editHeaderInwardIdParam &&
                                                    item?.IsHeaderDetailMaterialInformationChange ==
                                                      false) ||
                                                  ViewPrimaryIdParam
                                                }
                                              /> */}
                                                <CustomInputUncontrolled
                                                  name={`ListOfMaterials[${indx}].SampleDrawnBy`}
                                                  placeholder={
                                                    "Sample Drawn By"
                                                  }
                                                  defaultValue={
                                                    item.SampleDrawnBy
                                                  }
                                                  maxLength={500}
                                                  noMarginBottom={true}
                                                  disabled={
                                                    (editHeaderInwardIdParam &&
                                                      item?.IsHeaderDetailMaterialInformationChange ==
                                                        false) ||
                                                    ViewPrimaryIdParam
                                                  }
                                                  onValueCommit={(val) => {
                                                    formik.setFieldValue(
                                                      `ListOfMaterials[${indx}].SampleDrawnBy`,
                                                      val,
                                                    );
                                                  }}
                                                />
                                              </td>

                                              {/* {AuthUser?.Permissions?.Machining ==
                                            1 ? (
                                              <td
                                                className="p-1"
                                                style={{ width: "180px" }}
                                              >
                                                <div className="form-check form-switch ms-4">
                                                  <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id="flexSwitchCheckMachining"
                                                    title={
                                                      item?.IsMachining == true
                                                        ? "Yes"
                                                        : "No"
                                                    }
                                                    checked={item?.IsMachining}
                                                    onChange={(e) => {
                                                      handleChangeIsMachining(
                                                        indx,
                                                        e,
                                                        item
                                                      );
                                                    }}
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    disabled={
                                                      item?.IsHold ||
                                                      ViewPrimaryIdParam
                                                    }
                                                  ></input>
                                                  &nbsp;
                                                  {item?.IsMachining == true ? (
                                                    <Link
                                                      to="#"
                                                      className="text-primary"
                                                      title="View Machining Details"
                                                      onClick={() => {
                                                        if (
                                                          item?.IsHold == false
                                                        ) {
                                                          getMaterialProcessDetails(
                                                            indx,
                                                            item?.IsMachining,
                                                            item?.InwardMaterialIDEncrypted
                                                          );
                                                        }
                                                      }}
                                                      disabled={item?.IsHold}
                                                    >
                                                      View
                                                    </Link>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>
                                              </td>
                                            ) : (
                                              ""
                                            )} */}

                                              <td
                                                className="p-1"
                                                style={{
                                                  textAlign: "left",
                                                  width: "120px",
                                                }}
                                              >
                                                <Link
                                                  to="#"
                                                  // className="icon-box icon-box-md bg-primary-light"
                                                  className="icon-box icon-box-md ms-4"
                                                  onClick={() => {
                                                    if (
                                                      editHeaderInwardIdParam &&
                                                      item?.IsHeaderDetailMaterialInformationChange ==
                                                        false
                                                    ) {
                                                    } else {
                                                      setShowMaterialInfoImagesModal(
                                                        true,
                                                      );
                                                      formik.setFieldValue(
                                                        "selectedMaterialInfoRow",
                                                        indx,
                                                      );
                                                      setMaterialPhotoFile(
                                                        null,
                                                      );
                                                      setMaterialPhoto(null);
                                                    }
                                                  }}
                                                  disabled={
                                                    editHeaderInwardIdParam &&
                                                    item?.IsHeaderDetailMaterialInformationChange ==
                                                      false
                                                  }
                                                >
                                                  <i className="fa fa-cloud-upload"></i>
                                                </Link>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                    <tr
                                      key={`iRow_${indx}`}
                                      style={{
                                        display:
                                          item.IsDeleted == true ? "none" : "",
                                      }}
                                    >
                                      <td
                                        className="p-1 pt-3"
                                        style={{
                                          verticalAlign: "top",
                                          textAlign: "right",
                                        }}
                                      >
                                        {!ViewPrimaryIdParam ? (
                                          <>
                                            {ListOfMaterials?.filter(
                                              (x) => x.IsDeleted == false,
                                            )?.length > 1 &&
                                              item?.ListOfMaterialTestDetails?.filter(
                                                (x) => x.IsDeleted == false,
                                              )?.length > 0 && (
                                                <Link
                                                  to="#"
                                                  // className="icon-box icon-box-md bg-primary-light"
                                                  className="icon-box icon-box-md"
                                                  title="Repeat Test Details"
                                                  onClick={() => {
                                                    handleOnClickRepeatTestDetails(
                                                      indx,
                                                    );
                                                  }}
                                                >
                                                  <i className="fa fa-repeat" />
                                                </Link>
                                              )}
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td
                                        colSpan={14}
                                        className="p-1"
                                        style={{
                                          textAlign: "left",
                                          maxWidth: "500px",
                                        }}
                                      >
                                        <Accordion
                                          className="accordion accordion-solid-bg"
                                          defaultActiveKey="0"
                                        >
                                          <Accordion.Item
                                            className="accordion-item m-0"
                                            key={indx}
                                            eventKey={"0"}
                                          >
                                            <Accordion.Header className="accordion-header rounded-lg">
                                              Test Details
                                            </Accordion.Header>
                                            <Accordion.Collapse eventKey={"0"}>
                                              <div className="accordion-body p-0">
                                                <div className="table-responsive active-projects style-1 shorting">
                                                  <div
                                                    id="MaterialTestInfo-tbl_wrapper"
                                                    className="dataTables_wrapper table-responsive no-footer"
                                                  >
                                                    <table
                                                      id="MaterialTestInfo-tbl"
                                                      className="table table-bordered no-footer mb-0"
                                                    >
                                                      <thead>
                                                        <tr>
                                                          <th
                                                            width="2%"
                                                            className="ps-2 newPara"
                                                          >
                                                            {!ViewPrimaryIdParam &&
                                                            !editHeaderInwardIdParam ? (
                                                              <>
                                                                {item?.IsHold ==
                                                                  false && (
                                                                  <Link
                                                                    to="#"
                                                                    className="icon-box icon-box-md bg-primary-light"
                                                                    title="Add New"
                                                                    onClick={() => {
                                                                      AddNewMaterialTestInformation(
                                                                        indx,
                                                                      );
                                                                    }}
                                                                  >
                                                                    <i className="fa fa-plus"></i>
                                                                  </Link>
                                                                )}
                                                              </>
                                                            ) : (
                                                              ""
                                                            )}
                                                          </th>
                                                          <th
                                                            width="14%"
                                                            className="newPara"
                                                          >
                                                            Department
                                                          </th>
                                                          <th
                                                            width="18%"
                                                            className="newPara"
                                                          >
                                                            Test
                                                          </th>
                                                          {/* <th className="newPara"></th> */}
                                                          <th
                                                            width="12%"
                                                            className="newPara"
                                                          >
                                                            Material Group
                                                          </th>
                                                          <th
                                                            width="12%"
                                                            className="newPara"
                                                          >
                                                            Material Type
                                                          </th>
                                                          {/* <th
                                                                                            width="13%"
                                                                                            className="newPara"
                                                                                          >
                                                                                            Test Method
                                                                                          </th> */}
                                                          <th
                                                            width="13%"
                                                            className="newPara"
                                                          >
                                                            Test Method
                                                          </th>
                                                          <th
                                                            width="14%"
                                                            className="newPara"
                                                          >
                                                            Ref. Standard
                                                          </th>
                                                          <th
                                                            width="6%"
                                                            className="newPara"
                                                          >
                                                            Group
                                                          </th>
                                                          <th className="newPara"></th>
                                                          {/* <th
                                                          width="5%"
                                                          className="newPara"
                                                        >
                                                          Test Count
                                                        </th>
                                                        <th
                                                          width="5%"
                                                          className="newPara"
                                                        >
                                                          Billing Qty
                                                        </th> */}
                                                          <th
                                                            width="9%"
                                                            style={{
                                                              textAlign: "left",
                                                            }}
                                                            className="newPara"
                                                          >
                                                            Note
                                                          </th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {item?.ListOfMaterialTestDetails?.filter(
                                                          (x) =>
                                                            x.IsDeleted ==
                                                            false,
                                                        )?.length > 0 ? (
                                                          item?.ListOfMaterialTestDetails?.map(
                                                            (
                                                              itemTest,
                                                              indxTest,
                                                            ) => (
                                                              <tr
                                                                key={`test_${indxTest}`}
                                                                style={{
                                                                  display:
                                                                    itemTest?.IsDeleted ==
                                                                    true
                                                                      ? "none"
                                                                      : "",
                                                                }}
                                                              >
                                                                <td className="p-1">
                                                                  {itemTest?.IsCancel ==
                                                                  false ? (
                                                                    item?.IsHold ==
                                                                      false &&
                                                                    (!ViewPrimaryIdParam &&
                                                                    !editHeaderInwardIdParam ? (
                                                                      <Link
                                                                        to="#"
                                                                        // className="icon-box icon-box-md bg-danger-light"
                                                                        className="icon-box icon-box-md"
                                                                        title="Delete"
                                                                        onClick={() => {
                                                                          //deleteMaterialTestInformation(indx,indxTest);
                                                                          delete_RecordWithoutApi(
                                                                            deleteMaterialTestInformation,
                                                                            indx,
                                                                            indxTest,
                                                                            itemTest?.SampleMinimumQty,
                                                                          );
                                                                        }}
                                                                      >
                                                                        {
                                                                          SVGICON.DeleteDanger
                                                                        }
                                                                      </Link>
                                                                    ) : (
                                                                      ""
                                                                    ))
                                                                  ) : (
                                                                    <i
                                                                      className="fa fa-ban ps-2 text-danger"
                                                                      title="Cancelled"
                                                                    ></i>
                                                                  )}
                                                                </td>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "150px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].DepartmentIDEncrypted`}
                                                                    placeholder={
                                                                      "Department"
                                                                    }
                                                                    options={
                                                                      departmentOptions
                                                                    }
                                                                    component={
                                                                      CustomSelect
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    menuPosition="fixed"
                                                                    isDisabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam ||
                                                                      editHeaderInwardIdParam
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) => {
                                                                      if (
                                                                        e &&
                                                                        e?.value &&
                                                                        e?.IsNABLScopeExpired ==
                                                                          true
                                                                      ) {
                                                                        customConfirmDialog(
                                                                          `${e?.label} Scope is Expired`,
                                                                          `Do you want to continue?`,
                                                                          () => {
                                                                            handleChangeDepartment(
                                                                              indx,
                                                                              indxTest,
                                                                              e,
                                                                            );
                                                                          },
                                                                          true,
                                                                        );
                                                                      } else {
                                                                        handleChangeDepartment(
                                                                          indx,
                                                                          indxTest,
                                                                          e,
                                                                        );
                                                                      }
                                                                    }}
                                                                  />
                                                                </td>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "150px",
                                                                    borderRight:
                                                                      "1px solid transparent",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestMasterIDEncrypted`}
                                                                    placeholder={
                                                                      "Test"
                                                                    }
                                                                    // options={
                                                                    //   item.testOptions
                                                                    // }
                                                                    options={
                                                                      itemTest?.testOptions
                                                                    }
                                                                    component={
                                                                      CustomSelect
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    isDisabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam ||
                                                                      editHeaderInwardIdParam
                                                                    }
                                                                    menuPosition="fixed"
                                                                    onChange={(
                                                                      e,
                                                                    ) => {
                                                                      handleChangeTestMaster(
                                                                        indx,
                                                                        indxTest,
                                                                        e,
                                                                        itemTest,
                                                                      );
                                                                    }}
                                                                  />
                                                                </td>
                                                                {/* <td className="p-1">
                                                                <>
                                                                  {itemTest?.TestMasterIDEncrypted && (
                                                                    <>
                                                                      {AuthUser
                                                                        ?.Permissions
                                                                        ?.Account ==
                                                                      1 ? (
                                                                        <Link
                                                                          to="#"
                                                                          className="icon-box icon-box-md bg-primary-light"
                                                                          title="Define More Rates Selection"
                                                                          disabled={
                                                                            itemTest?.IsCancel ||
                                                                            item?.IsHold
                                                                          }
                                                                          onClick={() => {
                                                                            handleOnClickDefineMoreRatesSelection(
                                                                              indx,
                                                                              indxTest,
                                                                              item,
                                                                              itemTest,
                                                                              itemTest?.TestMasterIDEncrypted,
                                                                              itemTest?.InwardMaterialTestDetailIDEncrypted
                                                                            );
                                                                          }}
                                                                        >
                                                                          {
                                                                            SVGICON.Rates
                                                                          }
                                                                        </Link>
                                                                      ) : (
                                                                        ""
                                                                      )}
                                                                    </>
                                                                  )}
                                                                   {itemTest?.TestMasterIDEncrypted &&
                                                                    itemTest?.IsMixDesign ==
                                                                      true && (
                                                                      <Link
                                                                        to="#"
                                                                        className="icon-box icon-box-md bg-primary-light ms-1"
                                                                        title="Mix Design Details"
                                                                        disabled={
                                                                          itemTest?.IsCancel ||
                                                                          item?.IsHold ||
                                                                          itemTest
                                                                            ?.TestingDetails
                                                                            ?.TestingStatus >
                                                                            1
                                                                        }
                                                                        onClick={() => {
                                                                          handleOnClickMixDesignDetail(
                                                                            indx,
                                                                            indxTest,
                                                                            item,
                                                                            itemTest
                                                                          );
                                                                        }}
                                                                      >
                                                                        {
                                                                          SVGICON.Setting2
                                                                        }
                                                                      </Link>
                                                                    )} 
                                                                </>
                                                              </td> */}
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "150px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].ProductGroupIDEncrypted`}
                                                                    placeholder={
                                                                      "Material Group"
                                                                    }
                                                                    options={
                                                                      itemTest?.productGroupOptions
                                                                    }
                                                                    component={
                                                                      CustomSelect
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    isDisabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam ||
                                                                      editHeaderInwardIdParam
                                                                    }
                                                                    menuPosition="fixed"
                                                                    // onChange={(
                                                                    //   e
                                                                    // ) => {
                                                                    //   formik.setFieldValue(
                                                                    //     `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].ProductGroupIDEncrypted`,
                                                                    //     e?.value ??
                                                                    //       ""
                                                                    //   );
                                                                    //   // formik.setFieldValue(
                                                                    //   //   `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].MaterialTypeIDEncrypted`,
                                                                    //   //   ""
                                                                    //   // );
                                                                    //   // getTestDDL(
                                                                    //   //   itemTest?.DepartmentIDEncrypted,
                                                                    //   //   e?.value ??
                                                                    //   //     "",
                                                                    //   //   "",
                                                                    //   //   indx,
                                                                    //   //   indxTest
                                                                    //   // );
                                                                    // }}
                                                                  />
                                                                </td>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "150px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].MaterialTypeIDEncrypted`}
                                                                    placeholder={
                                                                      "Material Type"
                                                                    }
                                                                    options={
                                                                      itemTest?.materialTypeOptions
                                                                    }
                                                                    component={
                                                                      CustomSelect
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    isDisabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam ||
                                                                      editHeaderInwardIdParam
                                                                    }
                                                                    menuPosition="fixed"
                                                                    // onChange={(
                                                                    //   e
                                                                    // ) => {
                                                                    //   formik.setFieldValue(
                                                                    //     `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].MaterialTypeIDEncrypted`,
                                                                    //     e?.value ??
                                                                    //       ""
                                                                    //   );
                                                                    //   // getTestDDL(
                                                                    //   //   itemTest?.DepartmentIDEncrypted,
                                                                    //   //   itemTest?.ProductGroupIDEncrypted,
                                                                    //   //   e?.value ??
                                                                    //   //     "",
                                                                    //   //   indx,
                                                                    //   //   indxTest
                                                                    //   // );
                                                                    // }}
                                                                  />
                                                                </td>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "150px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestMethodIDEncrypted`}
                                                                    placeholder={
                                                                      "Test Method"
                                                                    }
                                                                    options={
                                                                      itemTest?.testMethodOptions
                                                                    }
                                                                    component={
                                                                      CustomSelect
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    menuPosition="fixed"
                                                                    isDisabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam ||
                                                                      editHeaderInwardIdParam
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) => {
                                                                      if (
                                                                        e?.IsExpiredTestMethod ==
                                                                        true
                                                                      ) {
                                                                        warningMessage(
                                                                          "Test Method is Expired..!",
                                                                        );
                                                                      } else {
                                                                        formik.setFieldValue(
                                                                          `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestMethodIDEncrypted`,
                                                                          e?.value ??
                                                                            "",
                                                                        );
                                                                      }
                                                                    }}
                                                                  />
                                                                </td>

                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "150px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].ReferenceStandardIDEncrypted`}
                                                                    placeholder={
                                                                      "Ref. Standard"
                                                                    }
                                                                    options={
                                                                      itemTest?.referenceStandardOptions
                                                                    }
                                                                    component={
                                                                      CustomSelect
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    menuPosition="fixed"
                                                                    isDisabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam ||
                                                                      editHeaderInwardIdParam
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) => {
                                                                      handleChangeReferenceStandard(
                                                                        itemTest?.TestMasterIDEncrypted,
                                                                        indx,
                                                                        indxTest,
                                                                        e,
                                                                      );
                                                                    }}
                                                                  />
                                                                </td>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "100px",
                                                                    borderRight:
                                                                      "1px solid transparent",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].RefStandardSubGroup`}
                                                                    placeholder={
                                                                      "Group"
                                                                    }
                                                                    options={
                                                                      itemTest?.refStandardSubGroupOptions
                                                                    }
                                                                    component={
                                                                      CustomSelect
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    menuPosition="fixed"
                                                                    isDisabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam ||
                                                                      editHeaderInwardIdParam
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) => {
                                                                      handleChangeRefStandardSubGroup(
                                                                        itemTest?.ReferenceStandardIDEncrypted,
                                                                        itemTest?.TestMasterIDEncrypted,
                                                                        indx,
                                                                        indxTest,
                                                                        e,
                                                                      );
                                                                    }}
                                                                  />
                                                                </td>
                                                                <td className="p-1">
                                                                  {itemTest?.TestMasterIDEncrypted && (
                                                                    <Link
                                                                      to="#"
                                                                      className="icon-box icon-box-md bg-primary-light"
                                                                      title="Parameters Selection"
                                                                      disabled={
                                                                        itemTest?.IsCancel ||
                                                                        item?.IsHold ||
                                                                        itemTest
                                                                          ?.TestingDetails
                                                                          ?.TestingStatus >
                                                                          1 ||
                                                                        editHeaderInwardIdParam
                                                                      }
                                                                      onClick={() => {
                                                                        handleOnClickParameterSelection(
                                                                          indx,
                                                                          indxTest,
                                                                          item,
                                                                          itemTest,
                                                                        );
                                                                      }}
                                                                    >
                                                                      <i className="fa fa-tags"></i>
                                                                    </Link>
                                                                  )}
                                                                </td>
                                                                {/* <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "105px",
                                                                }}
                                                              >
                                                                <Field
                                                                  name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestCount`}
                                                                  placeholder={
                                                                    "Test Count"
                                                                  }
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  type="number"
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  numberTypeWithoutDot={
                                                                    true
                                                                  }
                                                                  disabled={
                                                                    itemTest?.IsCancel ||
                                                                    item?.IsHold ||
                                                                    ViewPrimaryIdParam ||
                                                                    itemTest
                                                                      ?.TestingDetails
                                                                      ?.TestingStatus >
                                                                      1
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    handleChangeTestCount(
                                                                      indx,
                                                                      indxTest,
                                                                      e
                                                                    );
                                                                  }}
                                                                />
                                                              </td>
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "105px",
                                                                }}
                                                              >
                                                                <Field
                                                                  name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].BillingQty`}
                                                                  placeholder={
                                                                    "Billing Qty"
                                                                  }
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  type="number"
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  numberTypeWithoutDot={
                                                                    true
                                                                  }
                                                                  disabled={
                                                                    itemTest?.IsCancel ||
                                                                    item?.IsHold ||
                                                                    ViewPrimaryIdParam
                                                                  }
                                                                />
                                                              </td> */}
                                                                {/*
                                                                                                <td
                                                                                                  className="p-1"
                                                                                                  style={{
                                                                                                    minWidth:
                                                                                                      "130px",
                                                                                                  }}
                                                                                                >
                                                                                                  <Field
                                                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].UnitID`}
                                                                                                    placeholder={
                                                                                                      "Unit"
                                                                                                    }
                                                                                                    options={
                                                                                                      unitOptions
                                                                                                    }
                                                                                                    component={
                                                                                                      CustomSelect
                                                                                                    }
                                                                                                    noMarginBottom={
                                                                                                      true
                                                                                                    }
                                                                                                    menuPosition="fixed"
                                                                                                    isDisabled={
                                                                                                      itemTest?.IsCancel
                                                                                                    }
                                                                                                  />
                                                                                                </td>
                                                                                                <td
                                                                                                  className="p-1"
                                                                                                  style={{
                                                                                                    minWidth:
                                                                                                      "110px",
                                                                                                  }}
                                                                                                >
                                                                                                  <Field
                                                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].Rate`}
                                                                                                    placeholder={
                                                                                                      "Rate"
                                                                                                    }
                                                                                                    component={
                                                                                                      CustomInput
                                                                                                    }
                                                                                                    type="number"
                                                                                                    noMarginBottom={
                                                                                                      true
                                                                                                    }
                                                                                                    disabled={
                                                                                                      itemTest?.IsCancel
                                                                                                    }
                                                                                                  />
                                                                                                </td> */}
                                                                {/* <td
                                                                                                  className="p-1"
                                                                                                  style={{
                                                                                                    display:
                                                                                                      "none",
                                                                                                  }}
                                                                                                >
                                                                                                  <div className="form-check form-switch ms-4">
                                                                                                    <input
                                                                                                      className="form-check-input"
                                                                                                      type="checkbox"
                                                                                                      role="switch"
                                                                                                      id="flexSwitchCheckMachiningTestWise"
                                                                                                      title={
                                                                                                        itemTest.IsMachining ==
                                                                                                        true
                                                                                                          ? "Yes"
                                                                                                          : "No"
                                                                                                      }
                                                                                                      checked={
                                                                                                        itemTest.IsMachining
                                                                                                      }
                                                                                                      onChange={() => {
                                                                                                        formik.setFieldValue(
                                                                                                          `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].IsMachining`,
                                                                                                          !itemTest.IsMachining
                                                                                                        );
                                                                                                      }}
                                                                                                      style={{
                                                                                                        cursor:
                                                                                                          "pointer",
                                                                                                      }}
                                                                                                    ></input>
                                                                                                  </div>
                                                                                                </td> */}
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    textAlign:
                                                                      "left",
                                                                    minWidth:
                                                                      "150px",
                                                                    borderRight:
                                                                      "1px solid transparent",
                                                                  }}
                                                                >
                                                                  {/* <Field
                                                                  name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestNote`}
                                                                  placeholder={
                                                                    "Note"
                                                                  }
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  maxLength={
                                                                    500
                                                                  }
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  disabled={
                                                                    itemTest?.IsCancel ||
                                                                    item?.IsHold ||
                                                                    ViewPrimaryIdParam ||
                                                                    editHeaderInwardIdParam
                                                                  }
                                                                /> */}
                                                                  <CustomInputUncontrolled
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestNote`}
                                                                    placeholder={
                                                                      "Note"
                                                                    }
                                                                    defaultValue={
                                                                      itemTest.TestNote
                                                                    }
                                                                    maxLength={
                                                                      500
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    disabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam ||
                                                                      editHeaderInwardIdParam
                                                                    }
                                                                    onValueCommit={(
                                                                      val,
                                                                    ) => {
                                                                      formik.setFieldValue(
                                                                        `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestNote`,
                                                                        val,
                                                                      );
                                                                    }}
                                                                  />
                                                                </td>
                                                              </tr>
                                                            ),
                                                          )
                                                        ) : (
                                                          <tr>
                                                            <td
                                                              colSpan={13}
                                                              style={{
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                            >
                                                              <div>
                                                                {
                                                                  "No Record Found..."
                                                                }
                                                              </div>
                                                            </td>
                                                          </tr>
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </div>
                                            </Accordion.Collapse>
                                          </Accordion.Item>
                                        </Accordion>
                                      </td>
                                    </tr>
                                    <tr className="border-0 p-0">
                                      <td colSpan={9} className="p-0">
                                        <hr className="m-0 customHR"></hr>
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan={9} style={{ textAlign: "left" }}>
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <ErrorMessage
                        name={"ListOfMaterials"}
                        component="div"
                        className="invalid-feedback animated fadeInUp"
                        style={{ display: "block" }}
                      />
                      <ErrorMessage
                        name={`TestError`}
                        component="div"
                        className="invalid-feedback animated fadeInUp"
                        style={{ display: "block" }}
                      />
                      {filteredMaterials?.length > 20 &&
                        !ViewPrimaryIdParam && (
                          <div className="d-flex justify-content-end align-items-center gap-2 mt-2 mb-2">
                            {/* PAGE SIZE DROPDOWN */}
                            <div className="d-flex align-items-center gap-2">
                              {/* <span>Show</span>
                          <select
                            className="form-select form-select-sm"
                            style={{ width: "70px", isDisabled: true }}
                            value={pageSize}
                            // onChange={(e) =>
                            //   setPageSize(Number(e.target.value))
                            // }
                          >
                            {PAGE_SIZE_OPTIONS.map((size) => (
                              <option key={size} value={size}>
                                {size}
                              </option>
                            ))}
                          </select>
                          <span>Records</span> */}
                              Showing{" "}
                              {filteredMaterials.length > 0
                                ? (page + 1 - 1) * pageSize + 1
                                : 0}{" "}
                              to{" "}
                              {filteredMaterials.length > (page + 1) * pageSize
                                ? (page + 1) * pageSize
                                : filteredMaterials.length}{" "}
                              of {filteredMaterials.length} records
                            </div>

                            {/* PAGINATION */}
                            <div className="d-flex align-items-center gap-2">
                              <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                disabled={page === 0}
                                onClick={() => setPage((p) => p - 1)}
                              >
                                Prev
                              </button>

                              <span>
                                Page {page + 1} of {totalPages}
                              </span>

                              <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                disabled={page >= totalPages - 1}
                                onClick={() => setPage((p) => p + 1)}
                              >
                                Next
                              </button>
                            </div>
                          </div>
                        )}
                    </div>
                  </Col>
                </Row>
                <hr className="mt-1 mb-1"></hr>
                <Row>
                  <label>Mode</label>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="Mode-tbl_wrapper"
                        className="dataTables_wrapper table-responsive no-footer"
                      >
                        <table
                          id="Mode-tbl"
                          className="table table-bordered no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="14%">Mode Type</th>
                              <th width="14%">Mode By </th>
                              <th width="18%">Customer</th>
                              <th width="18%">Project</th>
                              <th width="20%">Address</th>
                              <th width="16%" style={{ textAlign: "left" }}>
                                Contact Person
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ListOfModeDetails?.map((item, idx) => (
                              <tr
                                key={idx}
                                style={{
                                  display:
                                    item.ModeDetailID == 4 &&
                                    IsMaterialReturnable == false
                                      ? "none"
                                      : "",
                                }}
                              >
                                <td
                                  className="p-1 ps-3"
                                  style={{ minWidth: "150px" }}
                                >
                                  <label>
                                    {item.ModeDetailID == 1
                                      ? "Sample Submitted By"
                                      : item.ModeDetailID == 2
                                        ? "Reporting"
                                        : item.ModeDetailID == 3
                                          ? "Billing"
                                          : item.ModeDetailID == 4
                                            ? "Dispatch"
                                            : ""}
                                  </label>
                                </td>
                                <td
                                  className="p-1"
                                  style={{ minWidth: "150px" }}
                                >
                                  {ViewPrimaryIdParam ? (
                                    <Field
                                      name={`ListOfModeDetails[${idx}].ModeTypeName`}
                                      placeholder={"Mode Type"}
                                      component={CustomInput}
                                      maxLength={100}
                                      noMarginBottom={true}
                                      disabled={ViewPrimaryIdParam}
                                    />
                                  ) : item.ModeDetailID > 1 ? (
                                    item.ModeDetailID == 4 ? (
                                      <Field
                                        name={`ListOfModeDetails[${idx}].ModeType`}
                                        placeholder={"Mode By"}
                                        options={dispatchMaterialModeOptions}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                      />
                                    ) : (
                                      <Field
                                        name={`ListOfModeDetails[${idx}].ModeType`}
                                        placeholder={"Mode By"}
                                        options={modeByOptions}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                      />
                                    )
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td
                                  className="p-1"
                                  style={{ minWidth: "160px" }}
                                >
                                  {ViewPrimaryIdParam ? (
                                    <Field
                                      name={`ListOfModeDetails[${idx}].CustomerName`}
                                      placeholder={"Customer Name"}
                                      component={CustomInput}
                                      maxLength={500}
                                      noMarginBottom={true}
                                      disabled={ViewPrimaryIdParam}
                                    />
                                  ) : (
                                    <Field
                                      name={`ListOfModeDetails[${idx}].CustomerIDEncrypted`}
                                      placeholder={"Customer"}
                                      //options={customerOptions}
                                      loadOptionsFn={loadOptionsCutomer}
                                      component={CustomSelectAsync}
                                      title={item?.CustomerName}
                                      labelFieldName={`ListOfModeDetails[${idx}].CustomerName`}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          `ListOfModeDetails[${idx}].CustomerIDEncrypted`,
                                          e?.value ?? "",
                                        );
                                        formik.setFieldValue(
                                          `ListOfModeDetails[${idx}].CustomerName`,
                                          e?.label ?? "",
                                        );
                                        getProjectDDLModeDetails(
                                          e?.value ?? "",
                                          idx,
                                        );
                                        formik.setFieldValue(
                                          `ListOfModeDetails[${idx}].CustomerProjectIDEncrypted`,
                                          "",
                                        );
                                        getProjectAddressDDL(
                                          e?.value ?? "",
                                          "",
                                          idx,
                                        );
                                        getContactPersonDDL(
                                          e?.value ?? "",
                                          "",
                                          idx,
                                        );
                                      }}
                                    />
                                  )}
                                </td>
                                <td
                                  className="p-1"
                                  style={{ minWidth: "160px" }}
                                >
                                  {ViewPrimaryIdParam ? (
                                    <Field
                                      name={`ListOfModeDetails[${idx}].ProjectName`}
                                      placeholder={"Project Name"}
                                      component={CustomInput}
                                      maxLength={500}
                                      noMarginBottom={true}
                                      disabled={ViewPrimaryIdParam}
                                    />
                                  ) : (
                                    <Field
                                      name={`ListOfModeDetails[${idx}].CustomerProjectIDEncrypted`}
                                      placeholder={"Project"}
                                      options={item.projectOptions}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          `ListOfModeDetails[${idx}].CustomerProjectIDEncrypted`,
                                          e?.value ?? "",
                                        );
                                        getProjectAddressDDL(
                                          item.CustomerIDEncrypted,
                                          e?.value ?? "",
                                          idx,
                                        );
                                        formik.setFieldValue(
                                          `ListOfModeDetails[${idx}].CustomerProjectAddressIDEncrypted`,
                                          "",
                                        );
                                        getContactPersonDDL(
                                          item.CustomerIDEncrypted,
                                          e?.value ?? "",
                                          idx,
                                        );
                                        formik.setFieldValue(
                                          `ListOfModeDetails[${idx}].CustomerContactPersonIDEncrypted`,
                                          "",
                                        );
                                      }}
                                    />
                                  )}
                                </td>
                                <td
                                  className="p-1"
                                  style={{ minWidth: "180px" }}
                                >
                                  {ViewPrimaryIdParam ? (
                                    <Field
                                      name={`ListOfModeDetails[${idx}].ProjectAddress`}
                                      placeholder={"Address"}
                                      component={CustomInput}
                                      maxLength={500}
                                      title={item?.ProjectAddress}
                                      noMarginBottom={true}
                                      disabled={ViewPrimaryIdParam}
                                    />
                                  ) : (
                                    <Field
                                      name={`ListOfModeDetails[${idx}].CustomerProjectAddressIDEncrypted`}
                                      placeholder={"Address"}
                                      options={item.projectAddressOptions}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                    />
                                  )}
                                </td>
                                {ViewPrimaryIdParam ? (
                                  <td
                                    className="p-1"
                                    style={{
                                      textAlign: "left",
                                      minWidth: "150px",
                                    }}
                                  >
                                    <Field
                                      name={`ListOfModeDetails[${idx}].ContactPerson`}
                                      placeholder={"Contact Person"}
                                      component={CustomInput}
                                      maxLength={500}
                                      noMarginBottom={true}
                                      disabled={ViewPrimaryIdParam}
                                    />
                                  </td>
                                ) : (
                                  <td
                                    className="p-1"
                                    style={{
                                      textAlign: "left",
                                      minWidth: "150px",
                                    }}
                                  >
                                    {item.ModeDetailID == 2 ? (
                                      <Field
                                        name={`ListOfModeDetails[${idx}].CustomerContactPersonIDEncrypted`}
                                        placeholder={"Contact Person"}
                                        // options={item.contactPersonOptions}
                                        options={item.contactPersonOptions.filter(
                                          (x) => x.IsReporting == true,
                                        )}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                        menuStyles={{
                                          position: "absolute",
                                          right: 0,
                                        }}
                                      />
                                    ) : item.ModeDetailID == 3 ? (
                                      <Field
                                        name={`ListOfModeDetails[${idx}].CustomerContactPersonIDEncrypted`}
                                        placeholder={"Contact Person"}
                                        // options={item.contactPersonOptions}
                                        options={item.contactPersonOptions.filter(
                                          (x) => x.IsBilling == true,
                                        )}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                        menuStyles={{
                                          position: "absolute",
                                          right: 0,
                                        }}
                                      />
                                    ) : item.ModeDetailID == 4 ? (
                                      <Field
                                        name={`ListOfModeDetails[${idx}].CustomerContactPersonIDEncrypted`}
                                        placeholder={"Contact Person"}
                                        // options={item.contactPersonOptions}
                                        options={item.contactPersonOptions.filter(
                                          (x) => x.IsDispatch == true,
                                        )}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                        menuStyles={{
                                          position: "absolute",
                                          right: 0,
                                        }}
                                      />
                                    ) : (
                                      <Field
                                        name={`ListOfModeDetails[${idx}].CustomerContactPersonIDEncrypted`}
                                        placeholder={"Contact Person"}
                                        options={item.contactPersonOptions}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                        menuStyles={{
                                          position: "absolute",
                                          right: 0,
                                        }}
                                      />
                                    )}
                                  </td>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
                <hr className="mt-1 mb-1"></hr>
                <Row>
                  <Col lg={2}>
                    {ViewPrimaryIdParam ? (
                      <Field
                        label="Expected Delivery Date"
                        name="ExpectedDateOfDelivery"
                        placeholder={"Select Expected Delivery Date"}
                        component={CustomInput}
                        value={
                          formik?.values?.ExpectedDateOfDelivery
                            ? moment(
                                formik?.values?.ExpectedDateOfDelivery,
                              ).format("DD-MMM-yyyy")
                            : ""
                        }
                        required
                        disabled={true}
                      />
                    ) : (
                      <Field
                        label="Expected Delivery Date"
                        name="ExpectedDateOfDelivery"
                        placeholder={"Select Expected Delivery Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                          minDate: InwardDate ? InwardDate : new Date(),
                        }}
                      />
                    )}
                  </Col>
                  <Col lg={2}>
                    <Field
                      label="Material Taken By Employee"
                      name="MaterialTakenByUserEncrypted"
                      placeholder={"Select Material Taken By"}
                      options={employeeOptions}
                      component={CustomSelect}
                      isDisabled={ViewPrimaryIdParam}
                    />
                  </Col>
                  <Col lg={2}>
                    <Field
                      label="Sample Received Via"
                      name="MaterialReceiveViaID"
                      placeholder={"Select Sample Received Via"}
                      options={sampleReceivedViaOptions}
                      component={CustomSelect}
                      isDisabled={ViewPrimaryIdParam}
                    />
                  </Col>
                  <Col lg={2}>
                    <Field
                      label="Reference By"
                      name="ReferenceByIDEncrypted"
                      placeholder={"Select Reference By"}
                      options={referredByOptions}
                      component={CustomSelect}
                      menuStyles={{
                        position: "absolute",
                        right: 0,
                      }}
                      isDisabled={ViewPrimaryIdParam}
                    />
                  </Col>
                  <Col lg={2}>
                    <Field
                      label="Representative"
                      name="CustomerRepresentativeIDEncrypt"
                      placeholder={"Select Representative"}
                      options={customerRepresentativeOptions}
                      component={CustomSelect}
                      isDisabled={ViewPrimaryIdParam}
                    />
                  </Col>
                  <Col lg={6}>
                    <Field
                      label="Delivery Remarks"
                      name="EDDRemarks"
                      placeholder={"Enter Delivery Remarks"}
                      component={CustomTextArea}
                      rows={2}
                      maxLength={200}
                      disabled={ViewPrimaryIdParam}
                    />
                  </Col>
                  <Col lg={6}>
                    <Field
                      label="Received Remarks"
                      name="ReceiveRemarks"
                      placeholder={"Enter Received Remarks"}
                      component={CustomTextArea}
                      rows={2}
                      maxLength={100}
                      disabled={ViewPrimaryIdParam}
                    />
                  </Col>
                </Row>
                {ListOfReviews?.length > 0 && (
                  <>
                    <hr className="mt-1 mb-1"></hr>
                    <Row>
                      <label>Customer Review</label>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting mb-2">
                          <div
                            id="Review-tbl_wrapper"
                            className="dataTables_wrapper table-responsive no-footer"
                          >
                            <table
                              id="Review-tbl"
                              className="table table-bordered no-footer mb-0"
                            >
                              <thead>
                                <tr>
                                  <th width="4%"></th>
                                  <th width="82%">Points Reviewed</th>
                                  <th width="14%" style={{ textAlign: "left" }}>
                                    Status of review
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ListOfReviews?.length > 0 ? (
                                  ListOfReviews?.map((item, indx) => (
                                    <tr key={indx}>
                                      <td
                                        className="p-1 text-center"
                                        style={{ minWidth: "40px" }}
                                      >
                                        {indx + 1}
                                      </td>

                                      <td
                                        className="p-1"
                                        style={{ minWidth: "180px" }}
                                      >
                                        {item.Review}
                                      </td>

                                      <td
                                        className="p-1"
                                        style={{
                                          textAlign: "left",
                                          minWidth: "150px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfReviews[${indx}].StatusOfReview`}
                                          placeholder={"Select"}
                                          options={yesNoOptions}
                                          component={CustomSelect}
                                          noMarginBottom={true}
                                          menuPosition="fixed"
                                          isClearable={false}
                                        />
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={3}
                                      style={{ textAlign: "left" }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
                {editHeaderInwardIdParam && (
                  <Row>
                    <Col lg={6}>
                      <Field
                        label="Change Reason"
                        name="ChangeReason"
                        placeholder={"Enter Change Reason"}
                        component={CustomTextArea}
                        rows={5}
                        maxLength={500}
                        required
                      />
                    </Col>
                  </Row>
                )}
                <div className="stickyBottomButtons">
                  <hr className="mt-1 mb-2"></hr>
                  {!ViewPrimaryIdParam ? (
                    <>
                      {InwardCurrentStatus == 1 && (
                        <>
                          <button
                            type="submit"
                            // className="btn btn-primary"
                            className="btn btn-primary btn-sm me-2"
                            onClick={() => {
                              formik.setFieldValue("btnSubmitType", 1);
                            }}
                            disabled={formik.isSubmitting}
                          >
                            <i className="fa-solid fa-bookmark"></i>{" "}
                            {formik.isSubmitting ? "Drafting..." : "Draft"}
                          </button>
                        </>
                      )}
                      <button
                        type="submit"
                        // className="btn btn-primary"
                        className="btn btn-primary btn-sm me-2"
                        onClick={() => {
                          formik.setFieldValue("btnSubmitType", 2);
                        }}
                        disabled={formik.isSubmitting}
                      >
                        <i className="fa-solid fa-floppy-disk"></i>{" "}
                        {formik.isSubmitting ? "Submitting..." : "Submit"}
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                  <button
                    type="button"
                    // className="btn btn-danger light"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </div>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={showLetterRefDocModal}
          onHide={setShowLetterRefDocModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Letter Ref Doc</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowLetterRefDocModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  {!ViewPrimaryIdParam && (
                    <div className="mb-2">
                      <label></label>
                      <div className="avatar-file">
                        <input
                          type="file"
                          id="LetterRefUpload2"
                          //accept="image/png, image/gif, image/jpeg"
                          onChange={uploadLetterRefDoc}
                          //key={fileKeyLetterRefDocPhoto || ""}
                        />
                        <label htmlFor="LetterRefUpload2" name=""></label>
                      </div>
                      <div
                        id="webCam"
                        className="avatar-camera"
                        onClick={() => {
                          setOpenWebCamModalLetterRefDocImage(true);
                        }}
                        style={{ marginLeft: "50px" }}
                      >
                        <input type="hidden" />
                        <label htmlFor="webCam" name=""></label>
                      </div>
                    </div>
                  )}
                  {/* <div style={{ float: "right", marginRight: "2rem" }}>
                    + Add
                    <div
                      className="open-file mt-2"
                      style={{ marginLeft: "2rem" }}
                    >
                      <input
                        type="file"
                        id="LetterRefUpload2"
                        //accept="image/png, image/gif, image/jpeg"
                        onChange={uploadLetterRefDoc}
                      />
                      <label htmlFor="LetterRefUpload2" name=""></label>
                    </div>
                  </div> */}
                </Col>
                {letterRefDocPhoto && (
                  <Col lg={12}>
                    <div className="d-flex">
                      <div className="image-placeholder companyLogo-placeholder mt-0 ms-0">
                        <div className="avatar-preview">
                          <div id="imagePreview">
                            <img
                              id="saveImageFile"
                              src={
                                letterRefDocPhoto ? letterRefDocPhoto : img200
                              }
                              alt={"Material Image"}
                              style={{
                                maxHeight: "100px",
                                maxWidth: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-primary me-1"
                          onClick={() => {
                            addLetterRefDocFile();
                          }}
                        >
                          <i className="fa fa-cloud-upload"></i> Upload
                        </button>
                        <button
                          // className="btn btn-sm btn-danger light"
                          className="btn btn-sm btn-danger"
                          onClick={() => {
                            setLetterRefDocPhoto(null);
                            setLetterRefDocPhotoFile(null);
                          }}
                        >
                          <i className="fa fa-cancel"></i> Cancel
                        </button>
                      </div>
                    </div>
                  </Col>
                )}
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="LetterRefDoc-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="LetterRefDoc-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%"></th>
                            <th width="96%" style={{ textAlign: "left" }}>
                              File Name
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfLetterRefDoc?.filter(
                            (x) => x.IsDeleted == false,
                          )?.length > 0 ? (
                            ListOfLetterRefDoc?.map((item, indx) => (
                              <tr
                                key={indx}
                                style={{
                                  display: item.IsDeleted == true ? "none" : "",
                                }}
                              >
                                <td>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="View"
                                    onClick={() => {
                                      window.open(
                                        item.LetterRefImageFilePath
                                          ? item.LetterRefImageFilePath
                                          : item.viewFile,
                                      );
                                    }}
                                  >
                                    <i className="fa fa-eye" />
                                  </Link>
                                  {!ViewPrimaryIdParam && (
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="Delete"
                                      onClick={() => {
                                        //deleteLetterRefDoc(indx);
                                        delete_RecordWithoutApi(
                                          deleteLetterRefDoc,
                                          indx,
                                        );
                                      }}
                                    >
                                      {SVGICON.DeleteDanger}
                                    </Link>
                                  )}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {item.LetterRefImageFileName}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={2} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {openWebCamModalLetterRefDocImage == true && (
                <div className="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowLetterRefDocModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={openWebCamModalLetterRefDocImage}
          onHide={setOpenWebCamModalLetterRefDocImage}
        >
          <Modal.Header>
            <Modal.Title>Letter Ref Doc</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setOpenWebCamModalLetterRefDocImage(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12">
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  mirrored={true}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                  onUserMedia={onUserMedia}
                  className="webCam"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              // className="btn btn-primary "
              variant="primary btn-sm"
              onClick={captureLetterRefDocPhoto}
            >
              <i className="fa fa-camera"></i> Capture
            </Button>

            <Button
              // className="btn btn-danger light"
              variant="danger btn-sm"
              onClick={() => {
                setOpenWebCamModalLetterRefDocImage(false);
              }}
            >
              <i className="fa fa-cancel"></i> Cancel
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          className="fade"
          show={showAddTPIDetailModal}
          onHide={setShowAddTPIDetailModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTPIDetail}>
              <Form onSubmit={formikTPIDetail.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>
                    {actionFlagTPI == 1 ? "Edit" : "Add"} TPI Detail
                  </Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowAddTPIDetailModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        label="TPI"
                        name="TPIIDEncrypted"
                        placeholder={"Select TPI"}
                        options={tpiCustomerOptions}
                        component={CustomSelect}
                        required
                        onChange={(e) => {
                          formikTPIDetail.setFieldValue(
                            "TPIIDEncrypted",
                            e?.value ?? "",
                          );
                          formikTPIDetail.setFieldValue(
                            "TPIName",
                            e?.label ?? "",
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="TPI Contact Person"
                        name="TPIContactPersonIDEncrypted"
                        placeholder={"Select Contact Person"}
                        options={tpiContactPersonOptions}
                        component={CustomSelect}
                        required
                        onChange={(e) => {
                          formikTPIDetail.setFieldValue(
                            "TPIContactPersonIDEncrypted",
                            e?.value ?? "",
                          );
                          formikTPIDetail.setFieldValue(
                            "TPIContactPersonName",
                            e?.label ?? "",
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="TPI Expected Date"
                        name="TPIExpectedDate"
                        placeholder={"Select Expected Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                          minDate: InwardDate
                            ? moment(InwardDate).format("DD-MM-YYYY")
                            : new Date(),
                          static: true, //to solve month dropdown not visible inside modal
                        }}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // variant="primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>
                  <Button
                    // variant="danger light"
                    variant="danger btn-sm"
                    onClick={() => setShowAddTPIDetailModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showTPIDetailModal}
          onHide={setShowTPIDetailModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>TPI Detail</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowTPIDetailModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                {/* <Col lg={12}>
                  <div className="mb-1" style={{ float: "right" }}>
                    <button
                      // className="btn btn-sm btn-primary"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => {
                        addNewTPI(false);
                      }}
                    >
                      <i className="fa-solid fa-plus"></i> Add
                    </button>
                  </div>
                </Col> */}
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="TPIdetail-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="TPIdetail-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            {!ViewPrimaryIdParam && (
                              <th width="4%">
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md bg-primary-light me-1"
                                  title="Add TPI Detail"
                                  onClick={() => {
                                    addNewTPI(false);
                                  }}
                                >
                                  <i className="fa fa-plus"></i>
                                </Link>
                              </th>
                            )}
                            <th width="46%">TPI</th>
                            <th width="30%">TPI Contact Person</th>
                            <th width="20%" style={{ textAlign: "left" }}>
                              TPI Expected Date
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfTPIDetails?.filter((x) => x.IsDeleted == false)
                            ?.length > 0 ? (
                            ListOfTPIDetails?.map((item, indx) => (
                              <tr
                                key={indx}
                                style={{
                                  display: item.IsDeleted == true ? "none" : "",
                                }}
                              >
                                {!ViewPrimaryIdParam && (
                                  <td>
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-primary-light me-1"
                                      className="icon-box icon-box-md me-1"
                                      title="Edit"
                                      onClick={() => {
                                        editTPI(indx, false);
                                      }}
                                    >
                                      {SVGICON.EditPrimary}
                                    </Link>
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-danger-light"
                                      className="icon-box icon-box-md me-1"
                                      title="Delete"
                                      onClick={() => {
                                        //deleteTPI(indx);
                                        delete_RecordWithoutApi(
                                          deleteTPI,
                                          indx,
                                          false,
                                        );
                                      }}
                                    >
                                      {SVGICON.DeleteDanger}
                                    </Link>
                                  </td>
                                )}
                                <td>{item.TPIName}</td>
                                <td>{item.TPIContactPersonName}</td>
                                <td style={{ textAlign: "left" }}>
                                  {item.displayTPIExpectedDate}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={4} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {showAddTPIDetailModal == true && (
                <div class="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowTPIDetailModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showMaterialInfoImagesModal}
          onHide={setShowMaterialInfoImagesModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Images - Material Information</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowMaterialInfoImagesModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                {!ViewPrimaryIdParam && (
                  <Col lg={12}>
                    <div className="mb-2">
                      <label></label>
                      <div className="avatar-file">
                        <input
                          type="file"
                          id="imageUploadMaterial"
                          accept="image/png, image/gif, image/jpeg"
                          onChange={uploadMaterialPhoto}
                          key={fileKeyMaterialPhoto || ""}
                        />
                        <label htmlFor="imageUploadMaterial" name=""></label>
                      </div>
                      <div
                        id="webCam"
                        className="avatar-camera"
                        onClick={() => {
                          setOpenWebCamModalMaterialImage(true);
                        }}
                        style={{ marginLeft: "50px" }}
                      >
                        <input type="hidden" />
                        <label htmlFor="webCam" name=""></label>
                      </div>
                    </div>
                  </Col>
                )}
                {materialPhoto && (
                  <Col lg={12}>
                    <div className="d-flex">
                      <div className="image-placeholder companyLogo-placeholder mt-0 ms-0">
                        <div className="avatar-preview">
                          <div id="imagePreview">
                            <img
                              id="saveImageFile"
                              src={materialPhoto ? materialPhoto : img200}
                              alt={"Material Image"}
                              style={{
                                maxHeight: "100px",
                                maxWidth: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-primary me-1"
                          onClick={() => {
                            addMaterialImage();
                          }}
                        >
                          <i className="fa fa-cloud-upload"></i> Upload
                        </button>
                        <button
                          // className="btn btn-sm btn-danger light"
                          className="btn btn-sm btn-danger"
                          onClick={() => {
                            setMaterialPhoto(null);
                            setMaterialPhotoFile(null);
                          }}
                        >
                          <i className="fa fa-cancel"></i> Cancel
                        </button>
                      </div>
                    </div>
                  </Col>
                )}
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting">
                    <div
                      id="MaterialPhotos-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="MaterialPhotos-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%"></th>
                            <th width="96%" style={{ textAlign: "left" }}>
                              Image
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfMaterials[
                            selectedMaterialInfoRow
                          ]?.ListOfMaterialPhotos?.filter(
                            (x) => x.IsDeleted == false,
                          )?.length > 0 ? (
                            ListOfMaterials[
                              selectedMaterialInfoRow
                            ]?.ListOfMaterialPhotos?.map((item, indx) => (
                              <tr
                                key={indx}
                                style={{
                                  display: item.IsDeleted == true ? "none" : "",
                                }}
                              >
                                <td>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="View"
                                    onClick={() => {
                                      window.open(
                                        item.MaterialPhotoFilePath
                                          ? item.MaterialPhotoFilePath
                                          : item.viewFile,
                                      );
                                    }}
                                  >
                                    <i className="fa fa-eye" />
                                  </Link>
                                  {!ViewPrimaryIdParam && (
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-danger-light"
                                      className="icon-box icon-box-md me-1"
                                      title="Delete"
                                      onClick={() => {
                                        //deleteMaterialImage(indx);
                                        delete_RecordWithoutApi(
                                          deleteMaterialImage,
                                          indx,
                                        );
                                      }}
                                    >
                                      {SVGICON.DeleteDanger}
                                    </Link>
                                  )}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  <img
                                    src={
                                      item.MaterialPhotoFilePath
                                        ? item.MaterialPhotoFilePath
                                        : item.viewFile
                                    }
                                    alt={"Material Image"}
                                    style={{
                                      maxHeight: "50px",
                                      maxWidth: "50px",
                                    }}
                                  />
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={2} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {(openCropperModalMaterialPhoto == true ||
                openWebCamModalMaterialImage == true) && (
                <div class="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowMaterialInfoImagesModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={openCropperModalMaterialPhoto}
          onHide={setOpenCropperModalMaterialPhoto}
          backdrop="static"
        >
          <Modal.Header>
            <Modal.Title>Material Image</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setOpenCropperModalMaterialPhoto(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <Cropper
                  style={{ height: 400, width: 400 }}
                  // zoomTo={0.5}
                  zoomTo={zoomMaterialPhoto}
                  initialAspectRatio={1 / 1}
                  // aspectRatio={1 / 1}
                  src={imageMaterialPhoto}
                  // viewMode={1}
                  // minCropBoxHeight={500}
                  // minCropBoxWidth={500}
                  // maxCropBoxHeight={500}
                  // maxCropBoxWidth={500}
                  background={false}
                  responsive={true}
                  // autoCropArea={1}
                  checkOrientation={false}
                  onInitialized={(instance) => {
                    setCropperMaterialPhoto(instance);
                  }}
                  //guides={false}
                  checkCrossOrigin={false}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              // variant="secondary light"
              variant="secondary light btn-sm"
              onClick={() => {
                setZoomMaterialPhoto(zoomMaterialPhoto + 0.5);
              }}
              title="zoom-in"
            >
              <i className="fa fa-search-plus"></i>
            </Button>
            <Button
              // variant="secondary light"
              variant="secondary light btn-sm"
              onClick={() => {
                setZoomMaterialPhoto(
                  zoomMaterialPhoto > 0.5
                    ? zoomMaterialPhoto - 0.5
                    : zoomMaterialPhoto,
                );
              }}
              title="zoom-out"
            >
              <i className="fa fa-search-minus"></i>
            </Button>
            <Button
              // className="btn btn-primary"
              variant="primary btn-sm"
              onClick={() => {
                getCropDataMaterialPhoto();
                setOpenCropperModalMaterialPhoto(false);
                setFileKeyMaterialPhoto(
                  Math.random().toString(9).substring(2, 9),
                );
              }}
            >
              <i className="fa fa-crop"></i> Crop Image
            </Button>
            <Button
              // className="btn btn-danger light"
              variant="danger btn-sm"
              onClick={() => {
                setOpenCropperModalMaterialPhoto(false);
                setFileKeyMaterialPhoto(
                  Math.random().toString(9).substring(2, 9),
                );
              }}
            >
              <i className="fa fa-cancel"></i> Cancel
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          className="fade"
          show={openWebCamModalMaterialImage}
          onHide={setOpenWebCamModalMaterialImage}
        >
          <Modal.Header>
            <Modal.Title>Material Image</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setOpenWebCamModalMaterialImage(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12">
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  mirrored={true}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                  onUserMedia={onUserMedia}
                  className="webCam"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              // className="btn btn-primary "
              variant="primary btn-sm"
              onClick={capturePhoto}
            >
              <i className="fa fa-camera"></i> Capture
            </Button>

            <Button
              // className="btn btn-danger light"
              variant="danger btn-sm"
              onClick={() => {
                setOpenWebCamModalMaterialImage(false);
              }}
            >
              <i className="fa fa-cancel"></i> Cancel
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          className="fade"
          show={showMaterialInfoRepeatRowQtyModal}
          onHide={setShowMaterialInfoRepeatRowQtyModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikMaterialInfoRepeatRow}>
              <Form onSubmit={formikMaterialInfoRepeatRow.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Repeat Row - Material Information</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowMaterialInfoRepeatRowQtyModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        type="number"
                        label="No of Repeat Row"
                        name="NoOfRepeatMaterialInfoRow"
                        placeholder={"Enter No of Repeat Row"}
                        component={CustomInput}
                        numberTypeWithoutDot={true}
                        required
                        onChange={(e) => {
                          let nRow = e?.target?.value ?? 0;
                          if (nRow >= 0 && nRow < 1000) {
                            formikMaterialInfoRepeatRow.setFieldValue(
                              "NoOfRepeatMaterialInfoRow",
                              e?.target?.value ?? "",
                            );
                          }
                        }}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // className="btn btn-primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>

                  <Button
                    // className="btn btn-danger light"
                    variant="danger btn-sm"
                    onClick={() => {
                      setShowMaterialInfoRepeatRowQtyModal(false);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showWorkDetailModal}
          onHide={setShowWorkDetailModal}
          size="lg"
        >
          <FormikProvider value={formikWorkDetail}>
            <Form onSubmit={formikWorkDetail.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Work Detail</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowWorkDetailModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="table-responsive active-projects style-1 shorting mb-0">
                      <div
                        id="workDetail-tbl_wrapper"
                        className="dataTables_wrapper table-responsive no-footer"
                      >
                        <table
                          id="workDetail-tbl"
                          className="table table-bordered no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="5%"></th>
                              <th width="95%" style={{ textAlign: "left" }}>
                                Work Detail
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {projectWorkDetailList?.length > 0 ? (
                              projectWorkDetailList?.map((item, indx) => (
                                <tr key={indx}>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      padding: "0.5rem",
                                      width: "5%",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkWorkDetail${indx}`}
                                      name={`chkWorkDetail${indx}`}
                                      checked={item.IsSelected}
                                      onChange={(e) => {
                                        formikWorkDetail.setFieldValue(
                                          "projectWorkDetailList",
                                          projectWorkDetailList?.map(
                                            (x, idx) => {
                                              if (idx == indx) {
                                                return {
                                                  ...x,
                                                  IsSelected: true,
                                                };
                                              } else {
                                                return {
                                                  ...x,
                                                  IsSelected: false,
                                                };
                                              }
                                            },
                                          ),
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      padding: "0.5rem",
                                      width: "95%",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.WorkDetail}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={2} style={{ textAlign: "left" }}>
                                  <div>{"No record found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  type="submit"
                  // className="btn btn-primary"
                  variant="primary btn-sm"
                >
                  <i className="fa-solid fa-plus"></i> Add
                </Button>

                <Button
                  // className="btn btn-danger light"
                  variant="danger btn-sm"
                  onClick={() => {
                    setShowWorkDetailModal(false);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Modal>
        {/* <Modal
          className="fade"
          show={showMaterialProcessModal}
          onHide={setShowMaterialProcessModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikMaterialProcessDetail}>
              <Form onSubmit={formikMaterialProcessDetail.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Machining Details</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowMaterialProcessModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div className="table-responsive active-projects style-1 shorting mb-2">
                        <div
                          id="MaterialProcess-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="MaterialProcess-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead>
                              <tr>
                                {!ViewPrimaryIdParam ? (
                                  <th width="4%"></th>
                                ) : (
                                  ""
                                )}
                                <th width="28%">Process Name</th>
                                <th width="24%">Process Note</th>
                                <th width="12%">Qty</th>
                                <th width="12%">Length</th>
                                <th width="20%" style={{ textAlign: "left" }}>
                                  Thickness
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ListOfProcessThicknessDetails?.length > 0 ? (
                                ListOfProcessThicknessDetails?.map(
                                  (itemTest, indxTest) => (
                                    <tr
                                      key={indxTest}
                                      style={{
                                        display:
                                          itemTest.IsDeleted == true
                                            ? "none"
                                            : "",
                                      }}
                                    >
                                      {!ViewPrimaryIdParam ? (
                                        <td className="p-1">
                                          <Link
                                            to="#"
                                            className="icon-box icon-box-md bg-primary-light"
                                            title="New Process"
                                            onClick={(e) => {
                                              addNewProcess(indxTest);
                                              e.preventDefault();
                                            }}
                                          >
                                            <i className="fa fa-plus"></i>
                                          </Link>
                                          {ListOfProcessThicknessDetails?.filter(
                                            (x) => x.IsDeleted == false
                                          )?.length > 1 ? (
                                            <Link
                                              to="#"
                                              className="icon-box icon-box-md bg-danger-light ms-1"
                                              title="Remove Process"
                                              onClick={(e) => {
                                                removeProcess(indxTest);
                                                e.preventDefault();
                                              }}
                                            >
                                              <i className="fa fa-minus"></i>
                                            </Link>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                      ) : (
                                        ""
                                      )}
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "150px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfProcessThicknessDetails[${indxTest}].MachiningConfigurationIDEncrypted`}
                                          placeholder={"Process Name"}
                                          options={processNameOptions}
                                          component={CustomSelect}
                                          noMarginBottom={true}
                                          menuPosition="fixed"
                                          onChange={(e) => {
                                            formikMaterialProcessDetail.setFieldValue(
                                              `ListOfProcessThicknessDetails[${indxTest}].MachiningConfigurationIDEncrypted`,
                                              e?.value ?? ""
                                            );

                                            formikMaterialProcessDetail.setFieldValue(
                                              `ListOfProcessThicknessDetails[${indxTest}].VendorRate`,
                                              e?.RateMatrix == false
                                                ? e?.VendorRate ?? ""
                                                : ""
                                            );

                                            formikMaterialProcessDetail.setFieldValue(
                                              `ListOfProcessThicknessDetails[${indxTest}].InvoiceRate`,
                                              e?.RateMatrix == false
                                                ? e?.InvoiceRate ?? ""
                                                : ""
                                            );

                                            checkValidationProcess(
                                              e?.value,
                                              indxTest
                                            );
                                          }}
                                        />
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "150px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfProcessThicknessDetails[${indxTest}].MachiningNote`}
                                          placeholder={"Process Note"}
                                          component={CustomInput}
                                          maxLength={100}
                                          noMarginBottom={true}
                                        />
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "105px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfProcessThicknessDetails[${indxTest}].Qty`}
                                          placeholder={"Qty"}
                                          component={CustomInput}
                                          type="number"
                                          noMarginBottom={true}
                                          numberTypeWithoutDot={true}
                                          onChange={(e) => {
                                            if (e?.target?.value < 1000) {
                                              formikMaterialProcessDetail.setFieldValue(
                                                `ListOfProcessThicknessDetails[${indxTest}].Qty`,
                                                e?.target?.value ?? ""
                                              );
                                            }
                                          }}
                                        />
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "105px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfProcessThicknessDetails[${indxTest}].Length`}
                                          placeholder={"Length"}
                                          component={CustomInput}
                                          type="number"
                                          noMarginBottom={true}
                                        />
                                      </td>

                                      <td
                                        className="p-1"
                                        style={{
                                          textAlign: "left",
                                          minWidth: "150px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfProcessThicknessDetails[${indxTest}].Thickness`}
                                          placeholder={"Thickness"}
                                          type="number"
                                          component={CustomInput}
                                          maxLength={100}
                                          noMarginBottom={true}
                                        />
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan={10}
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {showAddTPIDetailModal == true && (
                    <div className="fade modal-backdrop show"></div>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  {!ViewPrimaryIdParam ? (
                    <Button
                      type="submit"
                      // className="btn btn-primary"
                      variant="primary btn-sm"
                    >
                      <i className="fa-solid fa-plus"></i> Add
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    // variant="secondary light"
                    variant="danger btn-sm"
                    onClick={() => setShowMaterialProcessModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal> */}
        <Modal
          className="fade"
          show={showTestDetailsRepeatModal}
          onHide={setShowTestDetailsRepeatModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTestDetailsRepeat}>
              <Form onSubmit={formikTestDetailsRepeat.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Repeat - Test Details</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowTestDetailsRepeatModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <ul className="unorder-list ps-4 mb-2">
                        <li>
                          Selected Material Information(TC) Test Details should
                          be repeat in all the Material Information(TC).
                          {/* which is
                                  having Material Group is{" "}
                                  <b>"{repeatTestDetailsProductGroupName}"</b> and
                                  Material Type is{" "}
                                  <b>"{repeatTestDetailsMaterialTypeName}"</b>. */}
                        </li>
                        <li>
                          Repeat Test Details should be replace with existing
                          Test Details if exists.
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // className="btn btn-primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>

                  <Button
                    // className="btn btn-danger light"
                    variant="danger btn-sm"
                    onClick={() => {
                      setShowTestDetailsRepeatModal(false);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showTestParametersModal}
          onHide={setShowTestParametersModal}
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTestPrameters}>
              <Form onSubmit={formikTestPrameters.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>{ParametersTestName}</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowTestParametersModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div
                        className="table-responsive active-projects style-1 shorting"
                        style={{ maxHeight: "450px" }}
                      >
                        <div
                          id="TestParameters-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="TestParameters-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead className="fixedheader">
                              <tr>
                                <th width="3%" className="ps-1">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`chkSelectAllPara`}
                                    name={`chkSelectAllPara`}
                                    checked={selectAllPara}
                                    onChange={(e) => {
                                      handleChangeSelectAllPara(
                                        e?.target?.checked,
                                      );
                                    }}
                                  />
                                </th>
                                <th width="97%" style={{ textAlign: "left" }}>
                                  Parameters
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ParametersList?.length > 0 ? (
                                ParametersList?.map((para, iPara) => (
                                  <tr key={`para_${iPara}`}>
                                    <td className="p-1">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`chkIsSelected${iPara}`}
                                        name={`chkIsSelected${iPara}`}
                                        checked={para.IsSelected}
                                        onChange={(e) => {
                                          formikTestPrameters.setFieldValue(
                                            `ParametersList[${iPara}].IsSelected`,
                                            e?.target?.checked,
                                          );
                                        }}
                                      />
                                    </td>
                                    <td
                                      className="p-1"
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      {para?.ParameterName}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={2}
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  {!ViewPrimaryIdParam && !editHeaderInwardIdParam ? (
                    <Button
                      // className="btn btn-primary"
                      variant="primary btn-sm"
                      type="submit"
                    >
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    // className="btn btn-danger light"
                    variant="danger btn-sm"
                    onClick={() => {
                      setShowTestParametersModal(false);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showTestQtyModal}
          onHide={setShowTestQtyModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Test Sample Quantity</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowTestQtyModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="TestQtydetail-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="TestQtydetail-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%">Sr. No</th>
                            <th width="46%">Test Name</th>
                            <th width="20%" style={{ textAlign: "left" }}>
                              Sample Minimum Qty
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfTestSampleQuantityInformation?.filter(
                            (x) =>
                              x.IsDeleted == false &&
                              x?.SampleMinimumQty > 0 &&
                              x?.TestName != "",
                          )?.length > 0 ? (
                            ListOfTestSampleQuantityInformation?.map(
                              (item, indx) => (
                                <tr
                                  key={indx}
                                  style={{
                                    display:
                                      item.IsDeleted == true
                                        ? "none"
                                        : item?.SampleMinimumQty > 0
                                          ? ""
                                          : "none",
                                  }}
                                >
                                  <td>{indx + 1}</td>

                                  <td>{item.TestName}</td>
                                  <td style={{ textAlign: "left" }}>
                                    {item.SampleMinimumQty}{" "}
                                    {item.SampleMinimumUnitName
                                      ? item.SampleMinimumUnitName
                                      : ""}
                                  </td>
                                </tr>
                              ),
                            )
                          ) : (
                            <tr>
                              <td colSpan={4} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {showAddTPIDetailModal == true && (
                <div class="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
          </Spin>
        </Modal>
        {/* <Modal
          className="fade"
          show={showDefineMoreRatesModal}
          onHide={setShowDefineMoreRatesModal}
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikDefineMoreRates}>
              <Form onSubmit={formikDefineMoreRates.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Define More Rates</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowDefineMoreRatesModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div className="table-responsive active-projects style-1 shorting mb-2">
                        <div
                          id="DefineMoreRates-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="DefineMoreRates-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead className="fixedheader">
                              <tr>
                                <th width="5%" className="ps-1"></th>
                                <th width="95%" style={{ textAlign: "left" }}>
                                  Rate Type
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {MoreTestRatesList?.length > 0 ? (
                                MoreTestRatesList?.map((tRate, tRateindx) => (
                                  <tr key={`para_${tRateindx}`}>
                                    <td className="p-1">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`chkIsSelected${tRateindx}`}
                                        name={`chkIsSelected${tRateindx}`}
                                        checked={tRate.IsSelected}
                                        onChange={(e) => {
                                          formikDefineMoreRates.setFieldValue(
                                            `MoreTestRatesList[${tRateindx}].IsSelected`,
                                            e?.target?.checked
                                          );
                                        }}
                                        disabled={ViewPrimaryIdParam}
                                      />
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      {tRate.RateTypeName}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={2}
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  {!ViewPrimaryIdParam && MoreTestRatesList?.length > 0 ? (
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    variant="danger btn-sm"
                    onClick={() => setShowDefineMoreRatesModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal> */}
      </div>
    </div>
  );
};

export default AddMaterialInwardFoodTesting;
